/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * Generated by scripts/generate-offline-help.js
 */
window.PROBLEM_HELP_DATA = {
  "FRUTERÍA": [
    {
      "id": 1,
      "enunciado": "Las espinacas de esta frutería son estupendas. En la estantería había 47 bolsas de espinacas y los clientes compraron 15 bolsas. ¿Cuántas bolsas de espinacas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En la estantería había 47 bolsas de espinacas",
          "cantidad": 47,
          "emoji": "1f96c",
          "objeto": "bolsas"
        },
        "cambio": {
          "texto": "los clientes compraron 15 bolsas.",
          "cantidad": 15,
          "emoji": "1f96c",
          "objeto": "bolsas",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas bolsas de espinacas quedan?"
        }
      },
      "imagePath": "help-images/FRUTERÍA/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Una de las especialidades de esta frutería son las cerezas. Por la mañana había 37 cajas de cerezas, pero, en total, se vendieron 17 cajas. ¿Cuántas cajas de cerezas quedarán aún?",
      "ayuda": {
        "inicio": {
          "texto": "Por la mañana había 37 cajas de cerezas",
          "cantidad": 37,
          "emoji": "1f352",
          "objeto": "cajas"
        },
        "cambio": {
          "texto": "se vendieron 17 cajas.",
          "cantidad": 17,
          "emoji": "1f352",
          "objeto": "cajas",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas cajas de cerezas quedarán aún?"
        }
      },
      "imagePath": "help-images/FRUTERÍA/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "En la tienda hay 9 limones y el frutero ha cogido 2 limones para hacer más zumo. ¿Cuántos limones han sobrado?",
      "ayuda": {
        "inicio": {
          "texto": "En la tienda hay 9 limones",
          "cantidad": 9,
          "emoji": "1f34b",
          "objeto": "limones"
        },
        "cambio": {
          "texto": "el frutero ha cogido 2 limones para hacer más zumo.",
          "cantidad": 2,
          "emoji": "1f34b",
          "objeto": "limones",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos limones han sobrado?"
        }
      },
      "imagePath": "help-images/FRUTERÍA/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Había 10 tomates rojos en la caja, pero 3 se han golpeado. ¿Cuántos quedan perfectos?",
      "ayuda": {
        "inicio": {
          "texto": "Había 10 tomates rojos en la caja,",
          "cantidad": 10,
          "emoji": "1f345",
          "objeto": "tomates"
        },
        "cambio": {
          "texto": "3 se han golpeado.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "se han golpeado",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan perfectos?"
        }
      },
      "imagePath": "help-images/FRUTERÍA/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "El frutero tenía 8 fresas brillantes y se ha comido 4. ¿Cuántas fresas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "El frutero tenía 8 fresas brillantes",
          "cantidad": 8,
          "emoji": "1f353",
          "objeto": "fresas"
        },
        "cambio": {
          "texto": "se ha comido 4.",
          "cantidad": 4,
          "emoji": "1f353",
          "objeto": "fresas",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas fresas quedan?"
        }
      },
      "imagePath": "help-images/FRUTERÍA/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "En la caja hay 7 limones ácidos y usamos 2 para hacer zumo. ¿Cuántos limones sobran?",
      "ayuda": {
        "inicio": {
          "texto": "En la caja hay 7 limones ácidos",
          "cantidad": 7,
          "emoji": "1f34b",
          "objeto": "limones"
        },
        "cambio": {
          "texto": "usamos 2 para hacer zumo.",
          "cantidad": 2,
          "emoji": "1f9c3",
          "objeto": "para hacer zumo",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos limones sobran?"
        }
      },
      "imagePath": "help-images/FRUTERÍA/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Hay 12 hueveras de cartón y recibimos 5 hueveras más para la estantería. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 hueveras de cartón",
          "cantidad": 12,
          "emoji": "1f95a",
          "objeto": "hueveras de cartón"
        },
        "cambio": {
          "texto": "recibimos 5 hueveras más para la estantería.",
          "cantidad": 5,
          "emoji": "1f95a",
          "objeto": "hueveras",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/FRUTERÍA/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Un cliente compra 11 bolsas de nueces y 8 botes de miel pura. ¿Cuántas cosas lleva?",
      "ayuda": {
        "inicio": {
          "texto": "Un cliente compra 11 bolsas de nueces",
          "cantidad": 11,
          "emoji": "1f330",
          "objeto": "bolsas de nueces"
        },
        "cambio": {
          "texto": "8 botes de miel pura.",
          "cantidad": 8,
          "emoji": "1f36f",
          "objeto": "botes de miel",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas cosas lleva?"
        }
      },
      "imagePath": "help-images/FRUTERÍA/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En la caja hay 13 racimos de uvas y traen 6 piñas grandes. ¿Cuántas piezas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la caja hay 13 racimos de uvas",
          "cantidad": 13,
          "emoji": "1f347",
          "objeto": "racimos de uvas"
        },
        "cambio": {
          "texto": "traen 6 piñas grandes.",
          "cantidad": 6,
          "emoji": "1f34d",
          "objeto": "piñas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas piezas hay?"
        }
      },
      "imagePath": "help-images/FRUTERÍA/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Teníamos 16 sacos de patatas y los vecinos compran 5 sacos. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 sacos de patatas",
          "cantidad": 16,
          "emoji": "1f954",
          "objeto": "sacos de patatas"
        },
        "cambio": {
          "texto": "los vecinos compran 5 sacos.",
          "cantidad": 5,
          "emoji": "1f954",
          "objeto": "sacos",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/FRUTERÍA/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Había 15 botes de espárragos y el tendero ha vendido 4 botes. ¿Cuántos botes sobran?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 botes de espárragos",
          "cantidad": 15,
          "emoji": "1f96c",
          "objeto": "botes de espárragos"
        },
        "cambio": {
          "texto": "el tendero ha vendido 4 botes.",
          "cantidad": 4,
          "emoji": "1f36f",
          "objeto": "botes",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos botes sobran?"
        }
      },
      "imagePath": "help-images/FRUTERÍA/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En el mostrador hay 19 ajos blancos y se llevan 7 para cocinar. ¿Cuántos ajos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En el mostrador hay 19 ajos blancos",
          "cantidad": 19,
          "emoji": "1f9c4",
          "objeto": "ajos"
        },
        "cambio": {
          "texto": "se llevan 7 para cocinar.",
          "cantidad": 7,
          "emoji": "1f9c4",
          "objeto": "ajos",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos ajos quedan?"
        }
      },
      "imagePath": "help-images/FRUTERÍA/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "El sol de la mañana brilla mucho sobre las sandías grandes. Hay 22 sandías pesadas y el camión trae 14 melones amarillos muy dulces. ¿Cuántas frutas hay?",
      "ayuda": {
        "inicio": {
          "texto": "El sol de la mañana brilla mucho sobre las sandías grandes. Hay 22 sandías pesadas",
          "cantidad": 22,
          "emoji": "1f349",
          "objeto": "sandías"
        },
        "cambio": {
          "texto": "el camión trae 14 melones amarillos muy dulces.",
          "cantidad": 14,
          "emoji": "1f348",
          "objeto": "melones",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas frutas hay?"
        }
      },
      "imagePath": "help-images/FRUTERÍA/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "El olor de las naranjas recién cortadas es muy rico y fresco. Hay 31 naranjas con zumo y llegan 16 mandarinas pequeñas en una caja. ¿Cuántas naranjas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "fresco. Hay 31 naranjas con zumo",
          "cantidad": 31,
          "emoji": "1f9c3",
          "objeto": "con zumo",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas naranjas hay?"
        }
      },
      "imagePath": "help-images/FRUTERÍA/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Las cajas de madera son muy resistentes y huelen a pino limpio. Hay 25 cajas vacías y el carpintero nos trae 23 cajas nuevas. ¿Cuántas cajas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "huelen a pino limpio. Hay 25 cajas vacías",
          "cantidad": 25,
          "emoji": "1f4e6",
          "objeto": "cajas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas cajas hay?"
        }
      },
      "imagePath": "help-images/FRUTERÍA/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "El agua de la fuente del patio suena con una música muy suave. Teníamos 48 bolsas de espinacas verdes y los clientes compraron 15 bolsas. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "El agua de la fuente del patio suena con una música muy suave. Teníamos 48 bolsas de espinacas verdes",
          "cantidad": 48,
          "emoji": "1f96c",
          "objeto": "bolsas de espinacas"
        },
        "cambio": {
          "texto": "los clientes compraron 15 bolsas.",
          "cantidad": 15,
          "emoji": "1f381",
          "objeto": "bolsas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/FRUTERÍA/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "Los pájaros cantan fuera mientras el tendero ordena las cerezas rojas. Había 37 cajas de cerezas y hemos vendido 15 cajas para un banquete. ¿Cuántas pájaros quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Los pájaros cantan fuera mientras el tendero ordena las cerezas rojas. Había 37 cajas de cerezas",
          "cantidad": 37,
          "emoji": "1f352",
          "objeto": "cajas de cerezas"
        },
        "cambio": {
          "texto": "hemos vendido 15 cajas para un banquete.",
          "cantidad": 15,
          "emoji": "1f4e6",
          "objeto": "cajas",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas pájaros quedan?"
        }
      },
      "imagePath": "help-images/FRUTERÍA/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "El suelo de la tienda está recién fregado y brilla como un espejo. Teníamos 46 manojos de espárragos y hemos vendido 23 esta tarde. ¿Cuántos sobran?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "brilla como un espejo. Teníamos 46 manojos de espárragos",
          "cantidad": 46,
          "emoji": "1f96c",
          "objeto": "manojos de espárragos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos sobran?"
        }
      },
      "imagePath": "help-images/FRUTERÍA/problem_18.svg"
    },
    {
      "id": 1,
      "enunciado": "En una cesta hay 5 manzanas rojas y el agricultor trae 4 peras grandes. ¿Cuántas frutas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En una cesta hay 5 manzanas rojas",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "manzanas"
        },
        "cambio": {
          "texto": "el agricultor trae 4 peras grandes.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas frutas hay?"
        },
        "audioFull": "AL PRINCIPIO... En una cesta hay 5 manzanas rojas DESPUÉS... el agricultor trae 4 peras grandes. LA PREGUNTA ES... ¿Cuántas frutas hay?"
      }
    },
    {
      "id": 2,
      "enunciado": "Primero compramos 5 zanahorias y después compramos 2 brócolis buenísimos. ¿Cuántas verduras hemos comprado?",
      "ayuda": {
        "inicio": {
          "texto": "Compramos 5 zanahorias",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "zanahorias"
        },
        "cambio": {
          "texto": "compramos 2 brócolis buenísimos.",
          "cantidad": 2,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas verduras hemos comprado?"
        },
        "audioFull": "AL PRINCIPIO... Compramos 5 zanahorias DESPUÉS... compramos 2 brócolis buenísimos. LA PREGUNTA ES... ¿Cuántas verduras hemos comprado?"
      }
    },
    {
      "id": 1,
      "enunciado": "Había 8 tomates rojos en la caja, pero 3 tomates estaban estropeados. ¿Cuántos tomates estaban bien?",
      "ayuda": {
        "inicio": {
          "texto": "Había 8 tomates rojos en la caja,",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "tomates"
        },
        "cambio": {
          "texto": "vemos que 3 tomates estaban estropeados.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos tomates estaban bien?"
        },
        "audioFull": "AL PRINCIPIO... Había 8 tomates rojos en la caja, DESPUÉS... vemos que 3 tomates estaban estropeados. LA PREGUNTA ES... ¿Cuántos tomates estaban bien?"
      }
    },
    {
      "id": 1,
      "enunciado": "Hay 12 hueveras de cartón y el empleado trae 5 hueveras más para colocarlas en la estantería. ¿Cuántas hueveras hay ahora?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 hueveras de cartón",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "hueveras"
        },
        "cambio": {
          "texto": "el empleado trae 5 hueveras más.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hueveras hay ahora?"
        },
        "audioFull": "AL PRINCIPIO... Hay 12 hueveras de cartón DESPUÉS... el empleado trae 5 hueveras más. LA PREGUNTA ES... ¿Cuántas hueveras hay ahora?"
      }
    },
    {
      "id": 2,
      "enunciado": "En el mostrador hay 13 racimos de uvas y en la mesa hay 6 racimos más. ¿Cuántos racimos hay en total?",
      "ayuda": {
        "inicio": {
          "texto": "En el mostrador hay 13 racimos de uvas",
          "cantidad": 13,
          "emoji": "2753",
          "objeto": "racimos"
        },
        "cambio": {
          "texto": "en la mesa hay 6 racimos más.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos racimos hay en total?"
        },
        "audioFull": "AL PRINCIPIO... En el mostrador hay 13 racimos de uvas DESPUÉS... en la mesa hay 6 racimos más. LA PREGUNTA ES... ¿Cuántos racimos hay en total?"
      }
    },
    {
      "id": 1,
      "enunciado": "En la tienda tenían 16 sacos de patatas y los clientes compraron 6 sacos. ¿Cuántos sacos quedan ahora?",
      "ayuda": {
        "inicio": {
          "texto": "En la tienda tenían 16 sacos de patatas",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "sacos"
        },
        "cambio": {
          "texto": "los clientes compraron 6 sacos.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos sacos quedan ahora?"
        },
        "audioFull": "AL PRINCIPIO... En la tienda tenían 16 sacos de patatas DESPUÉS... los clientes compraron 6 sacos. LA PREGUNTA ES... ¿Cuántos sacos quedan ahora?"
      }
    },
    {
      "id": 2,
      "enunciado": "Había 14 botes de espárragos y el tendero ha vendido 4 botes. ¿Cuántos botes quedan aún?",
      "ayuda": {
        "inicio": {
          "texto": "Había 14 botes de espárragos",
          "cantidad": 14,
          "emoji": "2753",
          "objeto": "botes"
        },
        "cambio": {
          "texto": "el tendero ha vendido 4 botes.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos botes quedan aún?"
        },
        "audioFull": "AL PRINCIPIO... Había 14 botes de espárragos DESPUÉS... el tendero ha vendido 4 botes. LA PREGUNTA ES... ¿Cuántos botes quedan aún?"
      }
    },
    {
      "id": 1,
      "enunciado": "Nos encanta comer sandía y vamos a ir a comprar. En la frutería había 22 sandías y un camión trajo 13 sandías más. ¿Cuántas sandías habrán?",
      "ayuda": {
        "inicio": {
          "texto": "En la frutería había 22 sandías",
          "cantidad": 22,
          "emoji": "2753",
          "objeto": "sandías"
        },
        "cambio": {
          "texto": "un camión trajo 13 sandías más.",
          "cantidad": 13,
          "emoji": "2753",
          "objeto": "",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas sandías habrán?"
        },
        "audioFull": "AL PRINCIPIO... En la frutería había 22 sandías DESPUÉS... un camión trajo 13 sandías más. LA PREGUNTA ES... ¿Cuántas sandías habrán?"
      }
    },
    {
      "id": 2,
      "enunciado": "Nos faltan naranjas para hacer zumo de naranja para todos, así que, iremos a comprarlas. Cogimos 32 naranjas grandes y 18 naranjas pequeñas. ¿Cuántas naranjas cogimos?",
      "ayuda": {
        "inicio": {
          "texto": "Cogimos 32 naranjas grandes",
          "cantidad": 32,
          "emoji": "2753",
          "objeto": "naranjas"
        },
        "cambio": {
          "texto": "cogimos 18 naranjas pequeñas.",
          "cantidad": 18,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas naranjas cogimos?"
        },
        "audioFull": "AL PRINCIPIO... Cogimos 32 naranjas grandes DESPUÉS... cogimos 18 naranjas pequeñas. LA PREGUNTA ES... ¿Cuántas naranjas cogimos?"
      }
    }
  ],
  "CINE": [
    {
      "id": 1,
      "enunciado": "Hay 5 niños en la fila y llegan 4 más. ¿Cuántos niños hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 5 niños en la fila",
          "cantidad": 5,
          "emoji": "1f466",
          "objeto": "niños"
        },
        "cambio": {
          "texto": "llegan 4 más.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "más",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos niños hay?"
        }
      },
      "imagePath": "help-images/CINE/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Tengo 6 botes de refresco y compro 3 más. ¿Cuántos botes hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tengo 6 botes de refresco",
          "cantidad": 6,
          "emoji": "1f964",
          "objeto": "botes de refresco"
        },
        "cambio": {
          "texto": "compro 3 más.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "más",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos botes hay?"
        }
      },
      "imagePath": "help-images/CINE/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "En un cartel hay 4 estrellas y en otro 4. ¿Cuántas estrellas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En un cartel hay 4 estrellas",
          "cantidad": 4,
          "emoji": "2b50",
          "objeto": "estrellas"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas estrellas hay?"
        }
      },
      "imagePath": "help-images/CINE/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "El taquillero tiene 7 entradas y le dan 2 más. ¿Cuántas tiene?",
      "ayuda": {
        "inicio": {
          "texto": "El taquillero tiene 7 entradas",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "entradas"
        },
        "cambio": {
          "texto": "le dan 2 más.",
          "cantidad": 2,
          "emoji": "2753",
          "objeto": "más",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas tiene?"
        }
      },
      "imagePath": "help-images/CINE/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Hay 3 cubos de palomitas grandes y 5 pequeños. ¿Cuántos cubos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 3 cubos de palomitas grandes",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "cubos de palomitas"
        },
        "cambio": {
          "texto": "5 pequeños.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "pequeños",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos cubos hay?"
        }
      },
      "imagePath": "help-images/CINE/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "Había 10 gafas 3D y se han roto 4. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/CINE/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Tenía 9 piruletas y he vendido 5. ¿Cuántas piruletas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 9 piruletas",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "piruletas"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas piruletas quedan?"
        }
      },
      "imagePath": "help-images/CINE/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "En un banco hay 8 personas y 5 se van a la sala. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En un banco hay 8 personas",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "personas"
        },
        "cambio": {
          "texto": "5 se van a la sala.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "se van a la sala",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/CINE/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "El cartel tenía 7 luces y se han fundido 3. ¿Cuántas lucen?",
      "ayuda": {
        "inicio": {
          "texto": "El cartel tenía 7 luces",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "luces"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas lucen?"
        }
      },
      "imagePath": "help-images/CINE/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Había 6 pósteres y hemos quitado 2 viejos. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 6 pósteres",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "pósteres"
        },
        "cambio": {
          "texto": "hemos quitado 2 viejos.",
          "cantidad": 2,
          "emoji": "2753",
          "objeto": "viejos",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/CINE/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Hay 12 butacas rojas y ponemos 6 butacas azules. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 butacas rojas",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "butacas"
        },
        "cambio": {
          "texto": "ponemos 6 butacas azules.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "butacas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/CINE/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En la fila A hay 11 personas y en la B hay 8. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la fila A hay 11 personas",
          "cantidad": 11,
          "emoji": "2753",
          "objeto": "personas"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/CINE/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "Tengo 10 películas de acción y 7 de dibujos. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tengo 10 películas de acción",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "películas de acción"
        },
        "cambio": {
          "texto": "7 de dibujos.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "de dibujos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/CINE/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "Han entrado 13 niños y 5 adultos a la sala. ¿Cuántos niños son?",
      "ayuda": {
        "inicio": {
          "texto": "Han entrado 13 niños",
          "cantidad": 13,
          "emoji": "1f466",
          "objeto": "niños"
        },
        "cambio": {
          "texto": "5 adultos a la sala.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "adultos a la sala",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos niños son?"
        }
      },
      "imagePath": "help-images/CINE/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Hay 14 bolsas de gusanitos y traigo 5 más. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 14 bolsas de gusanitos",
          "cantidad": 14,
          "emoji": "1f381",
          "objeto": "bolsas de gusanitos"
        },
        "cambio": {
          "texto": "traigo 5 más.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "más",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/CINE/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "Teníamos 16 chocolatinas y hemos vendido 5. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 chocolatinas",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "chocolatinas"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/CINE/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "Había 15 linternas y 4 se han quedado sin pilas. ¿Cuántas lucen?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 linternas",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "linternas"
        },
        "cambio": {
          "texto": "4 se han quedado sin pilas.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "se han quedado sin pilas",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas lucen?"
        }
      },
      "imagePath": "help-images/CINE/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "En la pantalla había 19 nubes y han desaparecido 7. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En la pantalla había 19 nubes",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "nubes"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/CINE/problem_18.svg"
    },
    {
      "id": 19,
      "enunciado": "Había 18 empleados y 6 se han ido a descansar. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 18 empleados",
          "cantidad": 18,
          "emoji": "2753",
          "objeto": "empleados"
        },
        "cambio": {
          "texto": "6 se han ido a descansar.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "se han ido a descansar",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/CINE/problem_19.svg"
    },
    {
      "id": 20,
      "enunciado": "Tenía 17 entradas reservadas y han anulado 4. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 17 entradas reservadas",
          "cantidad": 17,
          "emoji": "2753",
          "objeto": "entradas reservadas"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/CINE/problem_20.svg"
    },
    {
      "id": 21,
      "enunciado": "El aire huele a caramelo y las luces parpadean. Tenemos 22 cartones de nachos y el camión trae 14 cartones más. ¿Cuántos caramelo hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "las luces parpadean. Tenemos 22 cartones de nachos",
          "cantidad": 22,
          "emoji": "2753",
          "objeto": "cartones de nachos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos caramelo hay?"
        }
      },
      "imagePath": "help-images/CINE/problem_21.svg"
    },
    {
      "id": 22,
      "enunciado": "Se oye el sonido de la banda sonora muy alto. Hay 31 personas con camiseta blanca y llegan 16 con camiseta negra. ¿Cuántos son?",
      "ayuda": {
        "inicio": {
          "texto": "Se oye el sonido de la banda sonora muy alto. Hay 31 personas con camiseta blanca",
          "cantidad": 31,
          "emoji": "2753",
          "objeto": "personas con camiseta"
        },
        "cambio": {
          "texto": "llegan 16 con camiseta negra.",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "con camiseta",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos son?"
        }
      },
      "imagePath": "help-images/CINE/problem_22.svg"
    },
    {
      "id": 23,
      "enunciado": "El suelo está un poco pegajoso y hace frío. Hay 25 refrescos de cola y compramos 23 de naranja. ¿Cuántos refrescos hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "hace frío. Hay 25 refrescos de cola",
          "cantidad": 25,
          "emoji": "1f964",
          "objeto": "refrescos de cola",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos refrescos hay?"
        }
      },
      "imagePath": "help-images/CINE/problem_23.svg"
    },
    {
      "id": 24,
      "enunciado": "Las cortinas son de terciopelo y la sala está oscura. Hay 32 niños sentados y entran 15 niños más corriendo. ¿Cuántos niños hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "la sala está oscura. Hay 32 niños sentados",
          "cantidad": 32,
          "emoji": "1f466",
          "objeto": "niños sentados",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos niños hay?"
        }
      },
      "imagePath": "help-images/CINE/problem_24.svg"
    },
    {
      "id": 25,
      "enunciado": "El proyector hace un ruido suave \"clic-clic\". Tenemos 24 rollos de película antiguos y 22 rollos modernos. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "El proyector hace un ruido suave \"clic-clic\". Tenemos 24 rollos de película antiguos",
          "cantidad": 24,
          "emoji": "2753",
          "objeto": "rollos de película antiguos"
        },
        "cambio": {
          "texto": "22 rollos modernos.",
          "cantidad": 22,
          "emoji": "2753",
          "objeto": "rollos modernos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/CINE/problem_25.svg"
    },
    {
      "id": 26,
      "enunciado": "La pantalla es gigante y blanca. Teníamos 48 bandejas de cartón y hemos repartido 15 a los clientes. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "blanca. Teníamos 48 bandejas de cartón",
          "cantidad": 48,
          "emoji": "2753",
          "objeto": "bandejas de cartón",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/CINE/problem_26.svg"
    },
    {
      "id": 27,
      "enunciado": "Se oyen risas y el crujir de las palomitas. Había 37 tickets de descuento y hemos usado 15 para las familias. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el crujir de las palomitas. Había 37 tickets de descuento",
          "cantidad": 37,
          "emoji": "2753",
          "objeto": "tickets de descuento",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/CINE/problem_27.svg"
    },
    {
      "id": 28,
      "enunciado": "El reloj del cine marca las ocho y las farolas se encienden. Tenía 46 pósteres pequeños y he regalado 23 a los fans. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "las farolas se encienden. Tenía 46 pósteres pequeños",
          "cantidad": 46,
          "emoji": "2753",
          "objeto": "pósteres",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/CINE/problem_28.svg"
    },
    {
      "id": 29,
      "enunciado": "El agua de la fuente está fría y hay silencio. Había 39 servilletas de papel y el viento se ha llevado 16 por la puerta. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "hay silencio. Había 39 servilletas de papel",
          "cantidad": 39,
          "emoji": "1f9fb",
          "objeto": "servilletas de papel",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/CINE/problem_29.svg"
    },
    {
      "id": 30,
      "enunciado": "La alfombra es roja y muy suave. Tenía 45 pegatinas de la película y he pegado 23 en las butacas. ¿Cuántas quedan en la hoja?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "muy suave. Tenía 45 pegatinas de la película",
          "cantidad": 45,
          "emoji": "2b50",
          "objeto": "pegatinas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan en la hoja?"
        }
      },
      "imagePath": "help-images/CINE/problem_30.svg"
    }
  ],
  "COLECCIONISTAS": [
    {
      "id": 1,
      "enunciado": "En la mano tengo 5 cromos de dinosaurios y mi abuelo me da 4 de planetas. ¿Cuántos tengo?",
      "ayuda": {
        "inicio": {
          "texto": "En la mano tengo 5 cromos de dinosaurios",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "cromos de dinosaurios"
        },
        "cambio": {
          "texto": "mi abuelo me da 4 de planetas.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "de planetas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos tengo?"
        }
      },
      "imagePath": "help-images/COLECCIONISTAS/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Tengo 6 cromos brillantes y encuentro 3 cromos normales en el suelo. ¿Cuántos cromos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tengo 6 cromos brillantes",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "cromos"
        },
        "cambio": {
          "texto": "encuentro 3 cromos normales en el suelo.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "cromos normales",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos cromos hay?"
        }
      },
      "imagePath": "help-images/COLECCIONISTAS/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "Un sobre tiene 4 cromos de futbolistas y otro tiene 4 de dibujos. ¿Cuántos cromos son?",
      "ayuda": {
        "inicio": {
          "texto": "Un sobre tiene 4 cromos de futbolistas",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "cromos de futbolistas"
        },
        "cambio": {
          "texto": "otro tiene 4 de dibujos.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "de dibujos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos cromos son?"
        }
      },
      "imagePath": "help-images/COLECCIONISTAS/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Tenía 10 cromos repetidos en el bolsillo y he cambiado 3 con mi amiga. ¿Cuántos me quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 10 cromos repetidos en el bolsillo",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "cromos repetidos"
        },
        "cambio": {
          "texto": "he cambiado 3 con mi amiga.",
          "cantidad": 3,
          "emoji": "1f467",
          "objeto": "con mi amiga",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos me quedan?"
        }
      },
      "imagePath": "help-images/COLECCIONISTAS/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Había 9 cromos sobre la mesa y el viento ha tirado 5 al suelo. ¿Cuántos quedan en la mesa?",
      "ayuda": {
        "inicio": {
          "texto": "Había 9 cromos sobre la mesa",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "cromos sobre la mesa"
        },
        "cambio": {
          "texto": "el viento ha tirado 5 al suelo.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "al suelo",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan en la mesa?"
        }
      },
      "imagePath": "help-images/COLECCIONISTAS/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "Tengo 8 cromos nuevos y ya he pegado 4 en mi álbum. ¿Cuántos me quedan por pegar?",
      "ayuda": {
        "inicio": {
          "texto": "Tengo 8 cromos nuevos",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "cromos"
        },
        "cambio": {
          "texto": "ya he pegado 4 en mi álbum.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "en mi álbum",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos me quedan por pegar?"
        }
      },
      "imagePath": "help-images/COLECCIONISTAS/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "En mi caja de \"Repes\" hay 12 cromos y hoy he conseguido 6 más. ¿Cuántos tengo en la caja?",
      "ayuda": {
        "inicio": {
          "texto": "En mi caja de \"Repes\" hay 12 cromos",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "cromos"
        },
        "cambio": {
          "texto": "hoy he conseguido 6 más.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "más",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos tengo en la caja?"
        }
      },
      "imagePath": "help-images/COLECCIONISTAS/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Un álbum tiene 11 páginas llenas y el otro tiene 8 páginas. ¿Cuántas páginas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Un álbum tiene 11 páginas llenas",
          "cantidad": 11,
          "emoji": "2753",
          "objeto": "páginas llenas"
        },
        "cambio": {
          "texto": "el otro tiene 8 páginas.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "páginas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas páginas hay?"
        }
      },
      "imagePath": "help-images/COLECCIONISTAS/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En el sobre especial vienen 10 cromos de oro y 7 de plata. ¿Cuántos cromos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el sobre especial vienen 10 cromos de oro",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "cromos de oro"
        },
        "cambio": {
          "texto": "7 de plata.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "de plata",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos cromos hay?"
        }
      },
      "imagePath": "help-images/COLECCIONISTAS/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Tenía 16 cromos de animales y he regalado 5 a mi hermano pequeño. ¿Cuántos me quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 16 cromos de animales",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "cromos de animales"
        },
        "cambio": {
          "texto": "he regalado 5 a mi hermano pequeño.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "a mi hermano",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos me quedan?"
        }
      },
      "imagePath": "help-images/COLECCIONISTAS/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Había 15 cromos de coches en la tienda y he comprado 4. ¿Cuántos quedan en la tienda?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 cromos de coches en la tienda",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "cromos de coches"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan en la tienda?"
        }
      },
      "imagePath": "help-images/COLECCIONISTAS/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En mi mazo de juego hay 19 cartas y he perdido 7 en el parque. ¿Cuántas cartas tengo?",
      "ayuda": {
        "inicio": {
          "texto": "En mi mazo de juego hay 19 cartas",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "cartas"
        },
        "cambio": {
          "texto": "he perdido 7 en el parque.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "en el parque",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas cartas tengo?"
        }
      },
      "imagePath": "help-images/COLECCIONISTAS/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "El álbum de cromos de la selva tiene muchas fotos de árboles verdes. Tengo 24 cromos de monos y mi prima me regala 15 de tigres naranjas. ¿Cuántos tengo?",
      "ayuda": {
        "inicio": {
          "texto": "El álbum de cromos de la selva tiene muchas fotos de árboles verdes. Tengo 24 cromos de monos",
          "cantidad": 24,
          "emoji": "2753",
          "objeto": "cromos de monos"
        },
        "cambio": {
          "texto": "mi prima me regala 15 de tigres naranjas.",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "de tigres",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos tengo?"
        }
      },
      "imagePath": "help-images/COLECCIONISTAS/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "El olor de los cromos recién sacados del sobre es muy especial y dulce. Hay 31 cromos de flores y el quiosquero me vende 16 de mariposas azules. ¿Cuántos cromos hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "dulce. Hay 31 cromos de flores",
          "cantidad": 31,
          "emoji": "2753",
          "objeto": "cromos de flores",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos cromos hay?"
        }
      },
      "imagePath": "help-images/COLECCIONISTAS/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Las esquinas de los cromos son puntiagudas y brillan bajo la luz blanca. Tengo 25 cromos de magos y mi amigo me cambia 24 de dragones verdes. ¿Cuántos tengo?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "brillan bajo la luz blanca. Tengo 25 cromos de magos",
          "cantidad": 25,
          "emoji": "2753",
          "objeto": "cromos de magos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos tengo?"
        }
      },
      "imagePath": "help-images/COLECCIONISTAS/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "El agua de lluvia moja el cristal de la ventana mientras ordeno mis tesoros. Tenía 48 cromos de superhéroes y he pegado 15 en la sección de villanos. ¿Cuántos sobran?",
      "ayuda": {
        "inicio": {
          "texto": "El agua de lluvia moja el cristal de la ventana mientras ordeno mis tesoros. Tenía 48 cromos de superhéroes",
          "cantidad": 48,
          "emoji": "2753",
          "objeto": "cromos de superhéroes"
        },
        "cambio": {
          "texto": "he pegado 15 en la sección de villanos.",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "en la sección de villanos",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos sobran?"
        }
      },
      "imagePath": "help-images/COLECCIONISTAS/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "Los pájaros cantan fuera mientras mi gato mira cómo cuento mis cartas de colores. Había 37 cartas de castillos y he guardado 15 en la caja roja. ¿Cuántas quedan fuera?",
      "ayuda": {
        "inicio": {
          "texto": "Los pájaros cantan fuera mientras mi gato mira cómo cuento mis cartas de colores. Había 37 cartas de castillos",
          "cantidad": 37,
          "emoji": "2753",
          "objeto": "cartas de castillos"
        },
        "cambio": {
          "texto": "he guardado 15 en la caja roja.",
          "cantidad": 15,
          "emoji": "1f4e6",
          "objeto": "en la caja",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan fuera?"
        }
      },
      "imagePath": "help-images/COLECCIONISTAS/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "El suelo de mi cuarto está limpio y mis cromos no se ensucian nada. Tenía 46 cromos de naves espaciales y he regalado 23 a mis mejores amigos. ¿Cuántos tengo?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "mis cromos no se ensucian nada. Tenía 46 cromos de naves espaciales",
          "cantidad": 46,
          "emoji": "2753",
          "objeto": "cromos de naves espaciales",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos tengo?"
        }
      },
      "imagePath": "help-images/COLECCIONISTAS/problem_18.svg"
    }
  ],
  "MANUALIDADES": [
    {
      "id": 1,
      "enunciado": "En el bote hay 4 botones rojos y pongo 3 botones azules. ¿Cuántos bote hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el bote hay 4 botones rojos",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "botones"
        },
        "cambio": {
          "texto": "pongo 3 botones azules.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "botones",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos bote hay?"
        }
      },
      "imagePath": "help-images/MANUALIDADES/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Tengo 6 palos de helado y encuentro 2 palos más debajo de la mesa. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tengo 6 palos de helado",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "palos de helado"
        },
        "cambio": {
          "texto": "encuentro 2 palos más debajo de la mesa.",
          "cantidad": 2,
          "emoji": "1f9c4",
          "objeto": "palos debajo",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/MANUALIDADES/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "Un collar tiene 5 cuentas amarillas y 5 cuentas rosas. ¿Cuántas cuentas tiene?",
      "ayuda": {
        "inicio": {
          "texto": "Un collar tiene 5 cuentas amarillas",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "cuentas"
        },
        "cambio": {
          "texto": "5 cuentas rosas.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "cuentas rosas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas cuentas tiene?"
        }
      },
      "imagePath": "help-images/MANUALIDADES/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Había 10 pegatinas de estrellas y he pegado 4 en mi dibujo. ¿Cuántas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "Había 10 pegatinas de estrellas",
          "cantidad": 10,
          "emoji": "2b50",
          "objeto": "pegatinas de estrellas"
        },
        "cambio": {
          "texto": "he pegado 4 en mi dibujo.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "en mi dibujo",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas sobran?"
        }
      },
      "imagePath": "help-images/MANUALIDADES/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Teníamos 9 pompones de lana y hemos usado 5 para hacer un conejo. ¿Cuántos pompóns quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 9 pompones de lana",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "pompones"
        },
        "cambio": {
          "texto": "hemos usado 5 para hacer un conejo.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "para hacer un conejo",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos pompóns quedan?"
        }
      },
      "imagePath": "help-images/MANUALIDADES/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "En la caja hay 8 pinceles y los niños cogen 3 para pintar. ¿Cuántos pinceles quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En la caja hay 8 pinceles",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "pinceles"
        },
        "cambio": {
          "texto": "los niños cogen 3 para pintar.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "para pintar",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos pinceles quedan?"
        }
      },
      "imagePath": "help-images/MANUALIDADES/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Hay 12 botes de purpurina dorada y compramos 6 botes de plata. ¿Cuántos botes hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 botes de purpurina dorada",
          "cantidad": 12,
          "emoji": "1f36f",
          "objeto": "botes de purpurina dorada"
        },
        "cambio": {
          "texto": "compramos 6 botes de plata.",
          "cantidad": 6,
          "emoji": "1f36f",
          "objeto": "botes de plata",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos botes hay?"
        }
      },
      "imagePath": "help-images/MANUALIDADES/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Un dibujo tiene 11 trozos de papel azul y 8 trozos de papel rojo. ¿Cuántos trozos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Un dibujo tiene 11 trozos de papel azul",
          "cantidad": 11,
          "emoji": "1f370",
          "objeto": "trozos de papel"
        },
        "cambio": {
          "texto": "8 trozos de papel rojo.",
          "cantidad": 8,
          "emoji": "1f370",
          "objeto": "trozos de papel",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos trozos hay?"
        }
      },
      "imagePath": "help-images/MANUALIDADES/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En el cajón hay 10 cintas de tela y traemos 7 cintas de seda. ¿Cuántas cintas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el cajón hay 10 cintas de tela",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "cintas de tela"
        },
        "cambio": {
          "texto": "traemos 7 cintas de seda.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "cintas de seda",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas cintas hay?"
        }
      },
      "imagePath": "help-images/MANUALIDADES/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Teníamos 16 cartulinas grandes y hemos usado 5 para hacer máscaras. ¿Cuántas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 cartulinas grandes",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "cartulinas"
        },
        "cambio": {
          "texto": "hemos usado 5 para hacer máscaras.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "para hacer máscaras",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas sobran?"
        }
      },
      "imagePath": "help-images/MANUALIDADES/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Había 15 botes de pegamento y se han gastado 4 botes. ¿Cuántos botes quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 botes de pegamento",
          "cantidad": 15,
          "emoji": "1f36f",
          "objeto": "botes de pegamento"
        },
        "cambio": {
          "texto": "se han gastado 4 botes.",
          "cantidad": 4,
          "emoji": "1f36f",
          "objeto": "botes",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos botes quedan?"
        }
      },
      "imagePath": "help-images/MANUALIDADES/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En el bote había 19 lápices de cera y se han roto 7 puntas. ¿Cuántos lápices sirven?",
      "ayuda": {
        "inicio": {
          "texto": "En el bote había 19 lápices de cera",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "lápices de cera"
        },
        "cambio": {
          "texto": "se han roto 7 puntas.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "puntas",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos lápices sirven?"
        }
      },
      "imagePath": "help-images/MANUALIDADES/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "El pegamento huele muy fuerte y dulce en el taller hoy. Tenemos 24 plumas de colores y mi amigo trae 15 plumas blancas muy suaves. ¿Cuántas colors hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "dulce en el taller hoy. Tenemos 24 plumas de colores",
          "cantidad": 24,
          "emoji": "2753",
          "objeto": "plumas de colores",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas colors hay?"
        }
      },
      "imagePath": "help-images/MANUALIDADES/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "La música de la radio suena bajito mientras cortamos. Hay 31 pajitas de plástico y la profesora trae 16 pajitas de papel muy bonitas. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "La música de la radio suena bajito mientras cortamos. Hay 31 pajitas de plástico",
          "cantidad": 31,
          "emoji": "1f964",
          "objeto": "pajitas de plástico"
        },
        "cambio": {
          "texto": "la profesora trae 16 pajitas de papel muy bonitas.",
          "cantidad": 16,
          "emoji": "1f964",
          "objeto": "pajitas de papel bonitas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/MANUALIDADES/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Las luces blancas del taller hacen que todo brille mucho. Hay 25 pinzas de madera y compramos 24 pinzas de colores de plástico. ¿Cuántas colors hay?",
      "ayuda": {
        "inicio": {
          "texto": "Las luces blancas del taller hacen que todo brille mucho. Hay 25 pinzas de madera",
          "cantidad": 25,
          "emoji": "2753",
          "objeto": "pinzas de madera"
        },
        "cambio": {
          "texto": "compramos 24 pinzas de colores de plástico.",
          "cantidad": 24,
          "emoji": "2753",
          "objeto": "pinzas de colores de plástico",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas colors hay?"
        }
      },
      "imagePath": "help-images/MANUALIDADES/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "El agua de los pinceles está muy sucia y de color gris oscuro. Teníamos 48 cuentas de cristal y hemos usado 15 para un collar. ¿Cuántas color quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "de color gris oscuro. Teníamos 48 cuentas de cristal",
          "cantidad": 48,
          "emoji": "2753",
          "objeto": "cuentas de cristal",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas color quedan?"
        }
      },
      "imagePath": "help-images/MANUALIDADES/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "El sol calienta el papel de seda mientras hacemos flores rojas. Había 37 tijeras en la caja y hemos repartido 15 a los otros niños. ¿Cuántas flors quedan?",
      "ayuda": {
        "inicio": {
          "texto": "El sol calienta el papel de seda mientras hacemos flores rojas. Había 37 tijeras en la caja",
          "cantidad": 37,
          "emoji": "2753",
          "objeto": "tijeras"
        },
        "cambio": {
          "texto": "hemos repartido 15 a los otros niños.",
          "cantidad": 15,
          "emoji": "1f466",
          "objeto": "a los otros niños",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas flors quedan?"
        }
      },
      "imagePath": "help-images/MANUALIDADES/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "El suelo está lleno de trocitos de papel brillante y purpurina. Teníamos 46 limpiapipas de colores y hemos usado 23 para hacer arañas. ¿Cuántos sobran?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "purpurina. Teníamos 46 limpiapipas de colores",
          "cantidad": 46,
          "emoji": "2753",
          "objeto": "limpiapipas de colores",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos sobran?"
        }
      },
      "imagePath": "help-images/MANUALIDADES/problem_18.svg"
    }
  ],
  "ORDENAR": [
    {
      "id": 1,
      "enunciado": "En la alfombra hay 5 coches rojos y encuentro 3 camiones azules. ¿Cuántos coches hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la alfombra hay 5 coches rojos",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "coches"
        },
        "cambio": {
          "texto": "encuentro 3 camiones azules.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "camiones",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos coches hay?"
        }
      },
      "imagePath": "help-images/ORDENAR/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Tengo 4 peluches en la cama y pongo 4 muñecos más. ¿Cuántos juguetes hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tengo 4 peluches en la cama",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "peluches"
        },
        "cambio": {
          "texto": "pongo 4 muñecos más.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "muñecos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos juguetes hay?"
        }
      },
      "imagePath": "help-images/ORDENAR/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "En el cajón hay 6 calcetines blancos y 2 calcetines negros. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el cajón hay 6 calcetines blancos",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "calcetines"
        },
        "cambio": {
          "texto": "2 calcetines negros.",
          "cantidad": 2,
          "emoji": "2753",
          "objeto": "calcetines",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/ORDENAR/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Había 10 piezas de puzzle en el suelo y he guardado 4. ¿Cuántas quedan fuera?",
      "ayuda": {
        "inicio": {
          "texto": "Había 10 piezas de puzzle en el suelo",
          "cantidad": 10,
          "emoji": "1f34e",
          "objeto": "piezas de puzzle"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan fuera?"
        }
      },
      "imagePath": "help-images/ORDENAR/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Tenía 9 lápices de colores y se han perdido 5 debajo de la cama. ¿Cuántos tengo?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 9 lápices de colores",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "lápices de colores"
        },
        "cambio": {
          "texto": "se han perdido 5 debajo de la cama.",
          "cantidad": 5,
          "emoji": "1f9c4",
          "objeto": "debajo",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos tengo?"
        }
      },
      "imagePath": "help-images/ORDENAR/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "En el armario hay 8 camisetas y saco 5 para ir al parque. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En el armario hay 8 camisetas",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "camisetas"
        },
        "cambio": {
          "texto": "saco 5 para ir al parque.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "para ir",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/ORDENAR/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Hay 12 libros en la estantería y pongo 6 cómics nuevos. ¿Cuántos libros hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 libros en la estantería",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "libros"
        },
        "cambio": {
          "texto": "pongo 6 cómics nuevos.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "cómics",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos libros hay?"
        }
      },
      "imagePath": "help-images/ORDENAR/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Un niño tiene 11 bloques de madera y 8 figuras de plástico. ¿Cuántas piezas tiene?",
      "ayuda": {
        "inicio": {
          "texto": "Un niño tiene 11 bloques de madera",
          "cantidad": 11,
          "emoji": "2753",
          "objeto": "bloques de madera"
        },
        "cambio": {
          "texto": "8 figuras de plástico.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "figuras de plástico",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas piezas tiene?"
        }
      },
      "imagePath": "help-images/ORDENAR/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En la bolsa hay 10 canicas verdes y traemos 7 canicas azules. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la bolsa hay 10 canicas verdes",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "canicas"
        },
        "cambio": {
          "texto": "traemos 7 canicas azules.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "canicas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/ORDENAR/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Teníamos 16 cartas de juegos y he perdido 5 en el jardín. ¿Cuántas me quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 cartas de juegos",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "cartas de juegos"
        },
        "cambio": {
          "texto": "he perdido 5 en el jardín.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "en el jardín",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas me quedan?"
        }
      },
      "imagePath": "help-images/ORDENAR/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Había 15 perchas en el perchero y uso 4 para colgar chaquetas. ¿Cuántas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 perchas en el perchero",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "perchas"
        },
        "cambio": {
          "texto": "uso 4 para colgar chaquetas.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "para colgar chaquetas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas sobran?"
        }
      },
      "imagePath": "help-images/ORDENAR/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En el bote había 19 rotuladores y 7 ya no pintan nada. ¿Cuántos sirven?",
      "ayuda": {
        "inicio": {
          "texto": "En el bote había 19 rotuladores",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "rotuladores"
        },
        "cambio": {
          "texto": "7 ya no pintan nada.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "ya no pintan nada",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos sirven?"
        }
      },
      "imagePath": "help-images/ORDENAR/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "La luz entra por la ventana y las cortinas azules se mueven. Tenemos 22 pantalones limpios y mi madre trae 14 jerséis muy suaves. ¿Cuánta ropa hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "las cortinas azules se mueven. Tenemos 22 pantalones limpios",
          "cantidad": 22,
          "emoji": "2753",
          "objeto": "pantalones",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuánta ropa hay?"
        }
      },
      "imagePath": "help-images/ORDENAR/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "El olor a lavanda de la almohada nos ayuda a dormir bien. Hay 31 bloques de madera y mi padre trae 16 piezas de lego pequeñas. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "El olor a lavanda de la almohada nos ayuda a dormir bien. Hay 31 bloques de madera",
          "cantidad": 31,
          "emoji": "2753",
          "objeto": "bloques de madera"
        },
        "cambio": {
          "texto": "mi padre trae 16 piezas de lego pequeñas.",
          "cantidad": 16,
          "emoji": "1f34e",
          "objeto": "piezas de lego",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/ORDENAR/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Las paredes blancas brillan y la puerta hace un ruido suave. Hay 25 juegos de mesa y compramos 24 juegos de cartas divertidos. ¿Cuántas cartas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "la puerta hace un ruido suave. Hay 25 juegos de mesa",
          "cantidad": 25,
          "emoji": "2753",
          "objeto": "juegos de mesa",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas cartas hay?"
        }
      },
      "imagePath": "help-images/ORDENAR/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "La lluvia golpea el cristal mientras leo en mi cama cómoda. Tenía 48 calcetines sucios y he puesto 14 en el cesto de lavar. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "La lluvia golpea el cristal mientras leo en mi cama cómoda. Tenía 48 calcetines sucios",
          "cantidad": 48,
          "emoji": "2753",
          "objeto": "calcetines sucios"
        },
        "cambio": {
          "texto": "he puesto 14 en el cesto de lavar.",
          "cantidad": 14,
          "emoji": "2753",
          "objeto": "en el cesto",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/ORDENAR/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "Los pájaros cantan fuera y el suelo está muy brillante hoy. Había 37 pegatinas en el álbum y he pegado 15 en mi mesa. ¿Cuántas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el suelo está muy brillante hoy. Había 37 pegatinas en el álbum",
          "cantidad": 37,
          "emoji": "2b50",
          "objeto": "pegatinas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas sobran?"
        }
      },
      "imagePath": "help-images/ORDENAR/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "El reloj hace tictac y las paredes blancas están muy limpias. Tenía 46 dibujos de animales y he guardado 23 en mi carpeta roja. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "las paredes blancas están muy limpias. Tenía 46 dibujos de animales",
          "cantidad": 46,
          "emoji": "2753",
          "objeto": "dibujos de animales",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/ORDENAR/problem_18.svg"
    }
  ],
  "OLIMPIADAS": [
    {
      "id": 1,
      "enunciado": "En el campo hay 5 balones de fútbol y el entrenador trae 4 balones más. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el campo hay 5 balones de fútbol",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "balones de fútbol"
        },
        "cambio": {
          "texto": "el entrenador trae 4 balones más.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "balones",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/OLIMPIADAS/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Tenemos 6 conos naranjas y compramos 3 conos amarillos para la carrera. ¿Cuántas naranjas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 6 conos naranjas",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "conos"
        },
        "cambio": {
          "texto": "compramos 3 conos amarillos para la carrera.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "conos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas naranjas hay?"
        }
      },
      "imagePath": "help-images/OLIMPIADAS/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "Un equipo tiene 4 medallas de oro y 4 medallas de plata. ¿Cuántas medallas son?",
      "ayuda": {
        "inicio": {
          "texto": "Un equipo tiene 4 medallas de oro",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "medallas de oro"
        },
        "cambio": {
          "texto": "4 medallas de plata.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "medallas de plata",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas medallas son?"
        }
      },
      "imagePath": "help-images/OLIMPIADAS/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Había 10 pelotas de tenis en la pista y hemos guardado 4 en el bote. ¿Cuántas quedan fuera?",
      "ayuda": {
        "inicio": {
          "texto": "Había 10 pelotas de tenis en la pista",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "pelotas de tenis"
        },
        "cambio": {
          "texto": "hemos guardado 4 en el bote.",
          "cantidad": 4,
          "emoji": "1f36f",
          "objeto": "en el bote",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan fuera?"
        }
      },
      "imagePath": "help-images/OLIMPIADAS/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Tenía 7 silbatos de colores y se han roto 3 silbatos. ¿Cuántos silbatos funcionan?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 7 silbatos de colores",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "silbatos de colores"
        },
        "cambio": {
          "texto": "se han roto 3 silbatos.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "silbatos",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos silbatos funcionan?"
        }
      },
      "imagePath": "help-images/OLIMPIADAS/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "En el banco hay 8 mochilas de deporte y 5 niños cogen la suya. ¿Cuántas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "En el banco hay 8 mochilas de deporte",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "mochilas de deporte"
        },
        "cambio": {
          "texto": "5 niños cogen la suya.",
          "cantidad": 5,
          "emoji": "1f466",
          "objeto": "niños cogen la suya",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas sobran?"
        }
      },
      "imagePath": "help-images/OLIMPIADAS/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Hay 12 gorros de natación rojos y ponemos 7 gorros azules en la caja. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 gorros de natación rojos",
          "cantidad": 12,
          "emoji": "1f389",
          "objeto": "gorros de natación"
        },
        "cambio": {
          "texto": "ponemos 7 gorros azules en la caja.",
          "cantidad": 7,
          "emoji": "1f389",
          "objeto": "gorros",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/OLIMPIADAS/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Un atleta corre 11 vueltas hoy y 8 vueltas mañana. ¿Cuántas vueltas corre en total?",
      "ayuda": {
        "inicio": {
          "texto": "Un atleta corre 11 vueltas hoy",
          "cantidad": 11,
          "emoji": "2753",
          "objeto": "vueltas hoy"
        },
        "cambio": {
          "texto": "8 vueltas mañana.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "vueltas mañana",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas vueltas corre en total?"
        }
      },
      "imagePath": "help-images/OLIMPIADAS/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En el almacén hay 10 bates de béisbol y traemos 5 bates nuevos. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el almacén hay 10 bates de béisbol",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "bates de béisbol"
        },
        "cambio": {
          "texto": "traemos 5 bates nuevos.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "bates",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/OLIMPIADAS/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Teníamos 16 botellas de agua y los corredores han bebido 5. ¿Cuántas quedan llenas?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 botellas de agua",
          "cantidad": 16,
          "emoji": "1f4a7",
          "objeto": "botellas de agua"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan llenas?"
        }
      },
      "imagePath": "help-images/OLIMPIADAS/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Había 18 pelotas de ping pong y se han perdido 6 por los rincones. ¿Cuántas pelotas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 18 pelotas de ping pong",
          "cantidad": 18,
          "emoji": "2753",
          "objeto": "pelotas de ping pong"
        },
        "cambio": {
          "texto": "se han perdido 6 por los rincones.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "por los rincones",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas pelotas quedan?"
        }
      },
      "imagePath": "help-images/OLIMPIADAS/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En la canasta había 15 balones de baloncesto y sacamos 4 para jugar. ¿Cuántos sobran?",
      "ayuda": {
        "inicio": {
          "texto": "En la canasta había 15 balones de baloncesto",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "balones de baloncesto"
        },
        "cambio": {
          "texto": "sacamos 4 para jugar.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "para jugar",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos sobran?"
        }
      },
      "imagePath": "help-images/OLIMPIADAS/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "El sol brilla mucho sobre la pista de tenis azul. Tenemos 22 zapatillas de correr y el camión trae 14 zapatillas de fútbol muy brillantes. ¿Cuántas zapatillas hay?",
      "ayuda": {
        "inicio": {
          "texto": "El sol brilla mucho sobre la pista de tenis azul. Tenemos 22 zapatillas de correr",
          "cantidad": 22,
          "emoji": "2753",
          "objeto": "zapatillas de correr"
        },
        "cambio": {
          "texto": "el camión trae 14 zapatillas de fútbol muy brillantes.",
          "cantidad": 14,
          "emoji": "2753",
          "objeto": "zapatillas de fútbol",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas zapatillas hay?"
        }
      },
      "imagePath": "help-images/OLIMPIADAS/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "El silbato del árbitro suena muy fuerte y alegre. Hay 31 banderas verdes pequeñas y traen 12 banderas amarillas muy grandes. ¿Cuántas banderas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "alegre. Hay 31 banderas verdes pequeñas",
          "cantidad": 31,
          "emoji": "2753",
          "objeto": "banderas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas banderas hay?"
        }
      },
      "imagePath": "help-images/OLIMPIADAS/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Las redes de las porterías son blancas y huelen a nuevo. Hay 25 dorsales de color rojo y ponemos 23 dorsales de color azul oscuro. ¿Cuántos color hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "huelen a nuevo. Hay 25 dorsales de color rojo",
          "cantidad": 25,
          "emoji": "2753",
          "objeto": "dorsales de color",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos color hay?"
        }
      },
      "imagePath": "help-images/OLIMPIADAS/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "El viento mueve las nubes sobre el estadio de atletismo. Teníamos 45 conos para saltar y los niños han movido 12 conos a la zona de arena. ¿Cuántos niños quedan?",
      "ayuda": {
        "inicio": {
          "texto": "El viento mueve las nubes sobre el estadio de atletismo. Teníamos 45 conos para saltar",
          "cantidad": 45,
          "emoji": "2753",
          "objeto": "conos"
        },
        "cambio": {
          "texto": "los niños han movido 12 conos a la zona de arena.",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "conos a la zona de arena",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos niños quedan?"
        }
      },
      "imagePath": "help-images/OLIMPIADAS/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "Se oye la música del desfile de los campeones. Había 36 medallas brillantes en la mesa y hemos repartido 13 a los ganadores. ¿Cuántas medallas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Se oye la música del desfile de los campeones. Había 36 medallas brillantes en la mesa",
          "cantidad": 36,
          "emoji": "2753",
          "objeto": "medallas"
        },
        "cambio": {
          "texto": "hemos repartido 13 a los ganadores.",
          "cantidad": 13,
          "emoji": "2753",
          "objeto": "a los ganadores",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas medallas quedan?"
        }
      },
      "imagePath": "help-images/OLIMPIADAS/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "El césped del campo está recién regado y huele a hierba. Teníamos 49 volantes de bádminton y se han roto 24 en el partido. ¿Cuántos sirven?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "huele a hierba. Teníamos 49 volantes de bádminton",
          "cantidad": 49,
          "emoji": "2753",
          "objeto": "volantes de bádminton",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos sirven?"
        }
      },
      "imagePath": "help-images/OLIMPIADAS/problem_18.svg"
    }
  ],
  "JUGUETES": [
    {
      "id": 1,
      "enunciado": "En la alfombra hay 5 dinosaurios y mi primo trae 4 robots de luces. ¿Cuántos dinosaurios hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la alfombra hay 5 dinosaurios",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "dinosaurios"
        },
        "cambio": {
          "texto": "mi primo trae 4 robots de luces.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "robots de luces",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos dinosaurios hay?"
        }
      },
      "imagePath": "help-images/JUGUETES/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Tengo 6 coches de carreras y encuentro 3 aviones pequeños en el suelo. ¿Cuántos coches hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tengo 6 coches de carreras",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "coches de carreras"
        },
        "cambio": {
          "texto": "encuentro 3 aviones pequeños en el suelo.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "aviones",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos coches hay?"
        }
      },
      "imagePath": "help-images/JUGUETES/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "Un cofre tiene 4 bloques azules y 4 bloques rojos. ¿Cuántos bloques hay?",
      "ayuda": {
        "inicio": {
          "texto": "Un cofre tiene 4 bloques azules",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "bloques"
        },
        "cambio": {
          "texto": "4 bloques rojos.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "bloques",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos bloques hay?"
        }
      },
      "imagePath": "help-images/JUGUETES/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Había 10 canicas brillantes y se han perdido 3 debajo del sofá. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 10 canicas brillantes",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "canicas"
        },
        "cambio": {
          "texto": "se han perdido 3 debajo del sofá.",
          "cantidad": 3,
          "emoji": "1f9c4",
          "objeto": "debajo",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/JUGUETES/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Tenía 9 peluches en mi cama y he prestado 5 a mi hermanita. ¿Cuántos tengo ahora?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 9 peluches en mi cama",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "peluches"
        },
        "cambio": {
          "texto": "he prestado 5 a mi hermanita.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "a mi hermanita",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos tengo ahora?"
        }
      },
      "imagePath": "help-images/JUGUETES/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "En mi caja hay 8 trompos y he sacado 4 para jugar en el patio. ¿Cuántos sobran?",
      "ayuda": {
        "inicio": {
          "texto": "En mi caja hay 8 trompos",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "trompos"
        },
        "cambio": {
          "texto": "he sacado 4 para jugar en el patio.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "para jugar",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos sobran?"
        }
      },
      "imagePath": "help-images/JUGUETES/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Hay 12 cromos de superhéroes y me regalan 6 cromos de villanos. ¿Cuántos cromos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 cromos de superhéroes",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "cromos de superhéroes"
        },
        "cambio": {
          "texto": "me regalan 6 cromos de villanos.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "cromos de villanos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos cromos hay?"
        }
      },
      "imagePath": "help-images/JUGUETES/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Un tren tiene 11 vagones de madera y le ponemos 8 vagones de carga. ¿Cuántos tiene?",
      "ayuda": {
        "inicio": {
          "texto": "Un tren tiene 11 vagones de madera",
          "cantidad": 11,
          "emoji": "2753",
          "objeto": "vagones de madera"
        },
        "cambio": {
          "texto": "le ponemos 8 vagones de carga.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "vagones de carga",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos tiene?"
        }
      },
      "imagePath": "help-images/JUGUETES/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En la caja de piezas hay 10 ruedas y traigo 7 piezas de motor. ¿Cuántas piezas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la caja de piezas hay 10 ruedas",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "ruedas"
        },
        "cambio": {
          "texto": "traigo 7 piezas de motor.",
          "cantidad": 7,
          "emoji": "1f34e",
          "objeto": "piezas de motor",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas piezas hay?"
        }
      },
      "imagePath": "help-images/JUGUETES/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Teníamos 16 piezas de un puzzle y hemos perdido 5 en la alfombra. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 piezas de un puzzle",
          "cantidad": 16,
          "emoji": "1f34e",
          "objeto": "piezas de un puzzle"
        },
        "cambio": {
          "texto": "hemos perdido 5 en la alfombra.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "en la",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/JUGUETES/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Había 15 barquitos de plástico y se han hundido 4 en la bañera. ¿Cuántos flotan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 barquitos de plástico",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "barquitos de plástico"
        },
        "cambio": {
          "texto": "se han hundido 4 en la bañera.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "en la bañera",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos flotan?"
        }
      },
      "imagePath": "help-images/JUGUETES/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En el bote había 19 tizas de colores y 7 se han hecho trocitos. ¿Cuántas están enteras?",
      "ayuda": {
        "inicio": {
          "texto": "En el bote había 19 tizas de colores",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "tizas de colores"
        },
        "cambio": {
          "texto": "7 se han hecho trocitos.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "se han hecho trocitos",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas están enteras?"
        }
      },
      "imagePath": "help-images/JUGUETES/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "El sol brilla sobre la estantería y las cortinas se mueven. Tenemos 24 piezas de Lego verdes y mi padre trae 15 piezas de Lego azules. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "las cortinas se mueven. Tenemos 24 piezas de Lego verdes",
          "cantidad": 24,
          "emoji": "1f34e",
          "objeto": "piezas de lego",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/JUGUETES/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "El olor de los juguetes nuevos es muy rico y el cuarto está en silencio. Hay 31 soldados de plástico y llegan 16 jinetes a caballo. ¿Cuántos juguetes hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el cuarto está en silencio. Hay 31 soldados de plástico",
          "cantidad": 31,
          "emoji": "2753",
          "objeto": "soldados de plástico",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos juguetes hay?"
        }
      },
      "imagePath": "help-images/JUGUETES/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Las luces del techo brillan y las paredes blancas están muy limpias. Hay 25 cartas de animales y compramos 24 cartas de monstruos. ¿Cuántas cartas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "las paredes blancas están muy limpias. Hay 25 cartas de animales",
          "cantidad": 25,
          "emoji": "2753",
          "objeto": "cartas de animales",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas cartas hay?"
        }
      },
      "imagePath": "help-images/JUGUETES/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "La lluvia golpea la ventana mientras juego con mis naves. Tenía 48 piezas de una nave espacial y he usado 15 para hacer un cohete. ¿Cuántas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "La lluvia golpea la ventana mientras juego con mis naves. Tenía 48 piezas de una nave espacial",
          "cantidad": 48,
          "emoji": "1f34e",
          "objeto": "piezas de una nave espacial"
        },
        "cambio": {
          "texto": "he usado 15 para hacer un cohete.",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "para hacer un cohete",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas sobran?"
        }
      },
      "imagePath": "help-images/JUGUETES/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "Los pájaros cantan fuera y el suelo está muy brillante y limpio. Había 37 pegatinas de planetas y he pegado 15 en mi casco de astronauta. ¿Cuántas pájaros quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas pájaros quedan?"
        }
      },
      "imagePath": "help-images/JUGUETES/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "El reloj hace tictac y mamá dice que es hora de merendar. Tenía 46 canicas de cristal y he regalado 23 a mi mejor amigo. ¿Cuántas tengo ahora?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "mamá dice que es hora de merendar. Tenía 46 canicas de cristal",
          "cantidad": 46,
          "emoji": "2753",
          "objeto": "canicas de cristal",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas tengo ahora?"
        }
      },
      "imagePath": "help-images/JUGUETES/problem_18.svg"
    }
  ],
  "COCINA": [
    {
      "id": 8,
      "enunciado": "Enunciado",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/COCINA/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En la huevera hay 5 huevos y mi madre trae 4 huevos más. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la huevera hay 5 huevos",
          "cantidad": 5,
          "emoji": "1f95a",
          "objeto": "huevos"
        },
        "cambio": {
          "texto": "mi madre trae 4 huevos más.",
          "cantidad": 4,
          "emoji": "1f95a",
          "objeto": "huevos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/COCINA/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Tenemos 6 tenedores de plata y ponemos 3 cucharas de sopa. ¿Cuántos cubiertos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 6 tenedores de plata",
          "cantidad": 6,
          "emoji": "1f374",
          "objeto": "tenedores de plata"
        },
        "cambio": {
          "texto": "ponemos 3 cucharas de sopa.",
          "cantidad": 3,
          "emoji": "1f944",
          "objeto": "cucharas de sopa",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos cubiertos hay?"
        }
      },
      "imagePath": "help-images/COCINA/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Hay 4 vasos azules y pongo otros 4 vasos amarillos. ¿Cuántos vasos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 4 vasos azules",
          "cantidad": 4,
          "emoji": "1f964",
          "objeto": "vasos"
        },
        "cambio": {
          "texto": "pongo otros 4 vasos amarillos.",
          "cantidad": 4,
          "emoji": "1f964",
          "objeto": "vasos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos vasos hay?"
        }
      },
      "imagePath": "help-images/COCINA/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "Había 10 magdalenas de chocolate y nos hemos comido 4. ¿Cuántas chocolate quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 10 magdalenas de chocolate",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "magdalenas de chocolate"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas chocolate quedan?"
        }
      },
      "imagePath": "help-images/COCINA/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "Tenía 9 servilletas de papel y el perro ha roto 5. ¿Cuántas quedan bien?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 9 servilletas de papel",
          "cantidad": 9,
          "emoji": "1f9fb",
          "objeto": "servilletas de papel"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan bien?"
        }
      },
      "imagePath": "help-images/COCINA/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "En la frutera hay 8 naranjas y usamos 5 para zumo. ¿Cuántas naranjas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "En la frutera hay 8 naranjas",
          "cantidad": 8,
          "emoji": "1f34a",
          "objeto": "naranjas"
        },
        "cambio": {
          "texto": "usamos 5 para zumo.",
          "cantidad": 5,
          "emoji": "1f9c3",
          "objeto": "para zumo",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas naranjas sobran?"
        }
      },
      "imagePath": "help-images/COCINA/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Hay 12 platos blancos en el armario y guardamos 6 platos de flores. ¿Cuántas flors hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 platos blancos en el armario",
          "cantidad": 12,
          "emoji": "1f37d",
          "objeto": "platos"
        },
        "cambio": {
          "texto": "guardamos 6 platos de flores.",
          "cantidad": 6,
          "emoji": "1f37d",
          "objeto": "platos de flores",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas flors hay?"
        }
      },
      "imagePath": "help-images/COCINA/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "El frutero tiene 11 plátanos y compramos 8 fresas grandes. ¿Cuántas frutas hay?",
      "ayuda": {
        "inicio": {
          "texto": "El frutero tiene 11 plátanos",
          "cantidad": 11,
          "emoji": "1f34c",
          "objeto": "plátanos"
        },
        "cambio": {
          "texto": "compramos 8 fresas grandes.",
          "cantidad": 8,
          "emoji": "1f353",
          "objeto": "fresas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas frutas hay?"
        }
      },
      "imagePath": "help-images/COCINA/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "En la despensa hay 10 botes de tomate y traen 7 de guisantes. ¿Cuántos botes hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la despensa hay 10 botes de tomate",
          "cantidad": 10,
          "emoji": "1f345",
          "objeto": "botes de tomate"
        },
        "cambio": {
          "texto": "traen 7 de guisantes.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "de guisantes",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos botes hay?"
        }
      },
      "imagePath": "help-images/COCINA/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "Teníamos 16 galletas de avena y los niños han merendado 5. ¿Cuántas galletas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 galletas de avena",
          "cantidad": 16,
          "emoji": "1f36a",
          "objeto": "galletas de avena"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas galletas quedan?"
        }
      },
      "imagePath": "help-images/COCINA/problem_18.svg"
    },
    {
      "id": 19,
      "enunciado": "Había 15 yogures en la nevera y se han caducado 4. ¿Cuántos sirven?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 yogures en la nevera",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "yogures"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos sirven?"
        }
      },
      "imagePath": "help-images/COCINA/problem_19.svg"
    },
    {
      "id": 20,
      "enunciado": "En la mesa hay 19 croquetas ricas y mi gato se come 7. ¿Cuántas croquetas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la mesa hay 19 croquetas ricas",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "croquetas ricas"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas croquetas hay?"
        }
      },
      "imagePath": "help-images/COCINA/problem_20.svg"
    },
    {
      "id": 21,
      "enunciado": "El horno huele a pollo asado y las patatas están calientes. Hay 22 recipientes de cristal y compramos 14 fiambreras de plástico nuevas. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "las patatas están calientes. Hay 22 recipientes de cristal",
          "cantidad": 22,
          "emoji": "2753",
          "objeto": "recipientes de cristal",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/COCINA/problem_21.svg"
    },
    {
      "id": 22,
      "enunciado": "La batidora hace mucho ruido y el suelo está recién fregado. Hay 31 pajitas de papel y traemos 16 pajitas de colores para la fiesta. ¿Cuántas colors hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el suelo está recién fregado. Hay 31 pajitas de papel",
          "cantidad": 31,
          "emoji": "1f964",
          "objeto": "pajitas de papel",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas colors hay?"
        }
      },
      "imagePath": "help-images/COCINA/problem_22.svg"
    },
    {
      "id": 23,
      "enunciado": "Las luces de la cocina brillan y la radio suena bajito. Hay 25 paquetes de pasta y compramos 23 botes de arroz blanco. ¿Cuántos botes hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "la radio suena bajito. Hay 25 paquetes de pasta",
          "cantidad": 25,
          "emoji": "2753",
          "objeto": "paquetes de pasta",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos botes hay?"
        }
      },
      "imagePath": "help-images/COCINA/problem_23.svg"
    },
    {
      "id": 24,
      "enunciado": "El vapor de la olla empaña el cristal de la ventana. Teníamos 48 terrones de azúcar y hemos usado 15 para un pastel de manzana. ¿Cuántos sobran?",
      "ayuda": {
        "inicio": {
          "texto": "El vapor de la olla empaña el cristal de la ventana. Teníamos 48 terrones de azúcar",
          "cantidad": 48,
          "emoji": "2753",
          "objeto": "terrones de azúcar"
        },
        "cambio": {
          "texto": "hemos usado 15 para un pastel de manzana.",
          "cantidad": 15,
          "emoji": "1f34e",
          "objeto": "para un pastel de manzana",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos sobran?"
        }
      },
      "imagePath": "help-images/COCINA/problem_24.svg"
    },
    {
      "id": 25,
      "enunciado": "El tictac del reloj avisa que la cena está lista y huele muy bien. Había 37 bolsas de té en la caja y hemos servido 15 a los invitados. ¿Cuántas invitados quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "huele muy bien. Había 37 bolsas de té en la caja",
          "cantidad": 37,
          "emoji": "1f381",
          "objeto": "bolsas de té",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas invitados quedan?"
        }
      },
      "imagePath": "help-images/COCINA/problem_25.svg"
    },
    {
      "id": 26,
      "enunciado": "El grifo del agua suena con un ruido suave y constante. Teníamos 46 cápsulas de café y hemos gastado 23 esta semana. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "constante. Teníamos 46 cápsulas de café",
          "cantidad": 46,
          "emoji": "2753",
          "objeto": "cápsulas de café",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/COCINA/problem_26.svg"
    }
  ],
  "MASCOTAS": [
    {
      "id": 1,
      "enunciado": "En el parque hay 5 perros grandes y llegan 4 cachorros pequeños. ¿Cuántos perros hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el parque hay 5 perros grandes",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "perros"
        },
        "cambio": {
          "texto": "llegan 4 cachorros pequeños.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "cachorros",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos perros hay?"
        }
      },
      "imagePath": "help-images/MASCOTAS/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Mi gato tiene 6 ratones de juguete y yo le compro 3 pelotas de lana. ¿Cuántos juguetes tiene?",
      "ayuda": {
        "inicio": {
          "texto": "Mi gato tiene 6 ratones de juguete",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "ratones de juguete"
        },
        "cambio": {
          "texto": "yo le compro 3 pelotas de lana.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "pelotas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos juguetes tiene?"
        }
      },
      "imagePath": "help-images/MASCOTAS/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "En una rama hay 4 pájaros verdes y 4 pájaros amarillos. ¿Cuántos pájaros hay?",
      "ayuda": {
        "inicio": {
          "texto": "En una rama hay 4 pájaros verdes",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "pájaros"
        },
        "cambio": {
          "texto": "4 pájaros amarillos.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "pájaros",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos pájaros hay?"
        }
      },
      "imagePath": "help-images/MASCOTAS/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Tenía 10 huesos para mi perro y ha enterrado 3 en el jardín. ¿Cuántos quedan a la vista?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 10 huesos para mi perro",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "huesos"
        },
        "cambio": {
          "texto": "ha enterrado 3 en el jardín.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "en el jardín",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan a la vista?"
        }
      },
      "imagePath": "help-images/MASCOTAS/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Había 9 peces en el acuario y 5 se han escondido detrás de las rocas. ¿Cuántos se ven?",
      "ayuda": {
        "inicio": {
          "texto": "Había 9 peces en el acuario",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "peces"
        },
        "cambio": {
          "texto": "5 se han escondido detrás de las rocas.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "se han escondido detrás",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos se ven?"
        }
      },
      "imagePath": "help-images/MASCOTAS/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "Tengo 8 premios para gatos y ya he repartido 4 entre mis gatitos. ¿Cuántos me quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Tengo 8 premios para gatos",
          "cantidad": 8,
          "emoji": "1f381",
          "objeto": "premios"
        },
        "cambio": {
          "texto": "ya he repartido 4 entre mis gatitos.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "entre mis gatitos",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos me quedan?"
        }
      },
      "imagePath": "help-images/MASCOTAS/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "En la tienda de animales hay 12 hamsters y traen 6 hamsters más en una caja. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la tienda de animales hay 12 hamsters",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "hamsters"
        },
        "cambio": {
          "texto": "traen 6 hamsters más en una caja.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "hamsters",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/MASCOTAS/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Un conejo come 11 zanahorias por la mañana y 8 por la tarde. ¿Cuántas come en total?",
      "ayuda": {
        "inicio": {
          "texto": "Un conejo come 11 zanahorias por la mañana",
          "cantidad": 11,
          "emoji": "1f955",
          "objeto": "zanahorias por la mañana"
        },
        "cambio": {
          "texto": "8 por la tarde.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "por la tarde",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas come en total?"
        }
      },
      "imagePath": "help-images/MASCOTAS/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En la protectora hay 10 gatos negros y han llegado 7 gatos blancos. ¿Cuántos gatos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la protectora hay 10 gatos negros",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "gatos"
        },
        "cambio": {
          "texto": "han llegado 7 gatos blancos.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "gatos",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos gatos hay?"
        }
      },
      "imagePath": "help-images/MASCOTAS/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Teníamos 16 correas para pasear perros y hemos prestado 5 a los vecinos. ¿Cuántas perros quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 correas para pasear perros",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "correas"
        },
        "cambio": {
          "texto": "hemos prestado 5 a los vecinos.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "a los vecinos",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas perros quedan?"
        }
      },
      "imagePath": "help-images/MASCOTAS/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Había 15 tortugas al sol y 4 se han tirado al agua para nadar. ¿Cuántas quedan al sol?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 tortugas al sol",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "tortugas"
        },
        "cambio": {
          "texto": "4 se han tirado al agua para nadar.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "se han tirado",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan al sol?"
        }
      },
      "imagePath": "help-images/MASCOTAS/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En el saco había 19 kilos de comida y el perro ya se ha comido 7 kilos. ¿Cuántos perro quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En el saco había 19 kilos de comida",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "kilos de comida"
        },
        "cambio": {
          "texto": "el perro ya se ha comido 7 kilos.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "kilos",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos perro quedan?"
        }
      },
      "imagePath": "help-images/MASCOTAS/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "El aire huele a hierba recién cortada y el cielo es muy azul. Tenemos 24 periquitos verdes y el veterinario trae 15 periquitos azules muy bonitos. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el cielo es muy azul. Tenemos 24 periquitos verdes",
          "cantidad": 24,
          "emoji": "2753",
          "objeto": "periquitos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/MASCOTAS/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "Se oye el ladrido alegre de los perros de lejos y la música suena suave. Hay 31 peces de colores y el abuelo trae 16 caracoles de agua para limpiar. ¿Cuántos perros hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "la música suena suave. Hay 31 peces de colores",
          "cantidad": 31,
          "emoji": "2753",
          "objeto": "peces de colores",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos perros hay?"
        }
      },
      "imagePath": "help-images/MASCOTAS/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Las paredes de la tienda son blancas y las luces brillan mucho. Hay 25 botes de champú para perros y compramos 24 botes de jabón para gatos. ¿Cuántos botes hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "las luces brillan mucho. Hay 25 botes de champú para perros",
          "cantidad": 25,
          "emoji": "1f36f",
          "objeto": "botes de champú",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos botes hay?"
        }
      },
      "imagePath": "help-images/MASCOTAS/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "El vapor del baño empaña el espejo y el perro huele a jabón de fresa. Tenía 48 toallas para mascotas y hemos usado 15 para secar a los perritos mojados. ¿Cuántas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el perro huele a jabón de fresa. Tenía 48 toallas para mascotas",
          "cantidad": 48,
          "emoji": "2753",
          "objeto": "toallas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas sobran?"
        }
      },
      "imagePath": "help-images/MASCOTAS/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "Los pájaros cantan fuera y el suelo del refugio está muy limpio y brillante. Había 37 mantas calientes para el invierno y hemos repartido 15 entre las jaulas. ¿Cuántas pájaros quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas pájaros quedan?"
        }
      },
      "imagePath": "help-images/MASCOTAS/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "El reloj hace tictac y el gato ronronea muy bajito en el sofá. Tenía 46 pelotas de goma y he regalado 23 a la escuela de perros guía. ¿Cuántas tengo ahora?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el gato ronronea muy bajito en el sofá. Tenía 46 pelotas de goma",
          "cantidad": 46,
          "emoji": "2753",
          "objeto": "pelotas de goma",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas tengo ahora?"
        }
      },
      "imagePath": "help-images/MASCOTAS/problem_18.svg"
    }
  ],
  "BOSQUE": [
    {
      "id": 1,
      "enunciado": "En el sendero vemos 5 ardillas marrones y aparecen 4 ardillas rojas. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el sendero vemos 5 ardillas marrones",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "ardillas"
        },
        "cambio": {
          "texto": "aparecen 4 ardillas rojas.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "ardillas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/BOSQUE/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Tenemos 6 mochilas azules y vienen 3 amigos con mochilas verdes. ¿Cuántas amigos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 6 mochilas azules",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "mochilas"
        },
        "cambio": {
          "texto": "vienen 3 amigos con mochilas verdes.",
          "cantidad": 3,
          "emoji": "1f466",
          "objeto": "amigos con mochilas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas amigos hay?"
        }
      },
      "imagePath": "help-images/BOSQUE/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "Hay 4 pinos grandes y 4 robles pequeños en un claro. ¿Cuántos árboles hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 4 pinos grandes",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "pinos"
        },
        "cambio": {
          "texto": "4 robles pequeños en un claro.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "robles",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos árboles hay?"
        }
      },
      "imagePath": "help-images/BOSQUE/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Había 10 mariposas en las flores y 3 han volado lejos. ¿Cuántas mariposas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 10 mariposas en las flores",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "mariposas"
        },
        "cambio": {
          "texto": "3 han volado lejos.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "han volado lejos",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas mariposas quedan?"
        }
      },
      "imagePath": "help-images/BOSQUE/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Tenía 9 piedras bonitas en mi bolsillo y se han caído 5 por el camino. ¿Cuántas tengo?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 9 piedras bonitas en mi bolsillo",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "piedras bonitas"
        },
        "cambio": {
          "texto": "se han caído 5 por el camino.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "por el camino",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas tengo?"
        }
      },
      "imagePath": "help-images/BOSQUE/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "En el río hay 8 patos nadando y 5 salen a la orilla. ¿Cuántos quedan en el agua?",
      "ayuda": {
        "inicio": {
          "texto": "En el río hay 8 patos nadando",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "patos nadando"
        },
        "cambio": {
          "texto": "5 salen a la orilla.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "salen a la orilla",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan en el agua?"
        }
      },
      "imagePath": "help-images/BOSQUE/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Hay 12 setas rojas y encontramos 6 setas marrones comestibles. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 setas rojas",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "setas"
        },
        "cambio": {
          "texto": "encontramos 6 setas marrones comestibles.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "setas comestibles",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/BOSQUE/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Un explorador ve 11 ciervos a lo lejos y 8 ciervos más cerca. ¿Cuántos ciervos ve?",
      "ayuda": {
        "inicio": {
          "texto": "Un explorador ve 11 ciervos a lo lejos",
          "cantidad": 11,
          "emoji": "2753",
          "objeto": "ciervos a lo lejos"
        },
        "cambio": {
          "texto": "8 ciervos más cerca.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "ciervos cerca",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos ciervos ve?"
        }
      },
      "imagePath": "help-images/BOSQUE/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En el refugio hay 10 bastones de madera y traen 7 bastones nuevos. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el refugio hay 10 bastones de madera",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "bastones de madera"
        },
        "cambio": {
          "texto": "traen 7 bastones nuevos.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "bastones",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/BOSQUE/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Teníamos 16 bocadillos para el almuerzo y nos hemos comido 5. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 bocadillos para el almuerzo",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "bocadillos"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/BOSQUE/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Había 15 cantimploras llenas y hemos vaciado 4 bebiendo agua. ¿Cuántas siguen llenas?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 cantimploras llenas",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "cantimploras llenas"
        },
        "cambio": {
          "texto": "hemos vaciado 4 bebiendo agua.",
          "cantidad": 4,
          "emoji": "1f4a7",
          "objeto": "bebiendo agua",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas siguen llenas?"
        }
      },
      "imagePath": "help-images/BOSQUE/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En la charca hay 19 ranas verdes y 7 saltan al agua para esconderse. ¿Cuántas se ven?",
      "ayuda": {
        "inicio": {
          "texto": "En la charca hay 19 ranas verdes",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "ranas"
        },
        "cambio": {
          "texto": "7 saltan al agua para esconderse.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "saltan",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas se ven?"
        }
      },
      "imagePath": "help-images/BOSQUE/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "El sol calienta mucho y el aire huele a pino fresco. Hay 22 piñas grandes en el suelo y encontramos 14 piñas pequeñas para la colección. ¿Cuántas piñas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el aire huele a pino fresco. Hay 22 piñas grandes en el suelo",
          "cantidad": 22,
          "emoji": "1f34d",
          "objeto": "piñas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas piñas hay?"
        }
      },
      "imagePath": "help-images/BOSQUE/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "El sonido del río es muy relajante y vemos peces nadando. Hay 31 peces plateados y llegan 16 peces dorados muy brillantes. ¿Cuántos pezs hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "vemos peces nadando. Hay 31 peces plateados",
          "cantidad": 31,
          "emoji": "2753",
          "objeto": "peces plateados",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos pezs hay?"
        }
      },
      "imagePath": "help-images/BOSQUE/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Las montañas a lo lejos se ven azules y el cielo está despejado. Hay 25 tiendas de campaña verdes y montamos 23 tiendas azules nuevas. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el cielo está despejado. Hay 25 tiendas de campaña verdes",
          "cantidad": 25,
          "emoji": "2753",
          "objeto": "tiendas de campaña",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/BOSQUE/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "La brisa mueve las hojas de los árboles y se oyen los pájaros. Teníamos 48 barritas de cereales y hemos repartido 15 entre los compañeros. ¿Cuántas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "se oyen los pájaros. Teníamos 48 barritas de cereales",
          "cantidad": 48,
          "emoji": "2753",
          "objeto": "barritas de cereales",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas sobran?"
        }
      },
      "imagePath": "help-images/BOSQUE/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "El camino es largo y tiene muchas piedras pequeñas y grises. Había 37 señales de madera y el viento ha tirado 15 señales al suelo. ¿Cuántas quedan de pie?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan de pie?"
        }
      },
      "imagePath": "help-images/BOSQUE/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "El mirador está muy alto y se ve todo el valle verde abajo. Teníamos 46 mapas de papel y hemos perdido 23 por el viento fuerte. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "se ve todo el valle verde abajo. Teníamos 46 mapas de papel",
          "cantidad": 46,
          "emoji": "2753",
          "objeto": "mapas de papel",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/BOSQUE/problem_18.svg"
    }
  ],
  "ACUARIO": [
    {
      "id": 1,
      "enunciado": "En el coral hay 5 peces payaso naranjas y aparecen 4 peces cirujano azules. ¿Cuántos pezs hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el coral hay 5 peces payaso naranjas",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "peces payaso"
        },
        "cambio": {
          "texto": "aparecen 4 peces cirujano azules.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "peces cirujano",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos pezs hay?"
        }
      },
      "imagePath": "help-images/ACUARIO/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Tenemos 6 estrellas de mar rojas y el buceador trae 3 estrellas amarillas. ¿Cuántas estrellas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 6 estrellas de mar rojas",
          "cantidad": 6,
          "emoji": "2b50",
          "objeto": "estrellas de mar"
        },
        "cambio": {
          "texto": "el buceador trae 3 estrellas amarillas.",
          "cantidad": 3,
          "emoji": "2b50",
          "objeto": "estrellas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas estrellas hay?"
        }
      },
      "imagePath": "help-images/ACUARIO/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "En un tanque hay 4 caballitos de mar y pongo otros 4 caballitos verdes. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En un tanque hay 4 caballitos de mar",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "caballitos de mar"
        },
        "cambio": {
          "texto": "pongo otros 4 caballitos verdes.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "caballitos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/ACUARIO/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Había 10 medusas brillantes y 4 se han ido a otro tanque. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 10 medusas brillantes",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "medusas"
        },
        "cambio": {
          "texto": "4 se han ido a otro tanque.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "se han ido a otro tanque",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/ACUARIO/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Tenía 9 conchas bonitas y he regalado 5 a un niño que miraba el cristal. ¿Cuántas tengo?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 9 conchas bonitas",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "conchas bonitas"
        },
        "cambio": {
          "texto": "he regalado 5 a un niño que miraba el cristal.",
          "cantidad": 5,
          "emoji": "1f466",
          "objeto": "a un niño que miraba el cristal",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas tengo?"
        }
      },
      "imagePath": "help-images/ACUARIO/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "En la piscina hay 8 rayas nadando y 5 se esconden bajo la arena. ¿Cuántas se ven?",
      "ayuda": {
        "inicio": {
          "texto": "En la piscina hay 8 rayas nadando",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "rayas nadando"
        },
        "cambio": {
          "texto": "5 se esconden bajo la arena.",
          "cantidad": 5,
          "emoji": "1f9c4",
          "objeto": "se esconden bajo la arena",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas se ven?"
        }
      },
      "imagePath": "help-images/ACUARIO/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Hay 12 cangrejos en las rocas y el cuidador pone 6 cangrejos nuevos. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 cangrejos en las rocas",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "cangrejos"
        },
        "cambio": {
          "texto": "el cuidador pone 6 cangrejos nuevos.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "cangrejos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/ACUARIO/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Un tanque tiene 11 peces planos y 8 rayas pequeñas. ¿Cuántos animales hay?",
      "ayuda": {
        "inicio": {
          "texto": "Un tanque tiene 11 peces planos",
          "cantidad": 11,
          "emoji": "2753",
          "objeto": "peces planos"
        },
        "cambio": {
          "texto": "8 rayas pequeñas.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "rayas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos animales hay?"
        }
      },
      "imagePath": "help-images/ACUARIO/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En la zona fría hay 10 pingüinos y llegan 7 pingüinos de viaje. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la zona fría hay 10 pingüinos",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "pingüinos"
        },
        "cambio": {
          "texto": "llegan 7 pingüinos de viaje.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "pingüinos de viaje",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/ACUARIO/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Teníamos 16 erizos de mar y hemos movido 5 al tanque de limpieza. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 erizos de mar",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "erizos de mar"
        },
        "cambio": {
          "texto": "hemos movido 5 al tanque de limpieza.",
          "cantidad": 5,
          "emoji": "1f34e",
          "objeto": "al tanque de limpieza",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/ACUARIO/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Había 15 calamares en el túnel y 4 se han ido al fondo oscuro. ¿Cuántos se ven?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 calamares en el túnel",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "calamares"
        },
        "cambio": {
          "texto": "4 se han ido al fondo oscuro.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "se han ido",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos se ven?"
        }
      },
      "imagePath": "help-images/ACUARIO/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En el bote había 19 raciones de comida y los delfines comen 7. ¿Cuántas bote quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En el bote había 19 raciones de comida",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "raciones de comida"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas bote quedan?"
        }
      },
      "imagePath": "help-images/ACUARIO/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "La luz azul brilla en el agua y las burbujas suben despacio. Hay 22 peces ángel y el camión trae 14 peces ángel de colores raros. ¿Cuántos pezs hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "las burbujas suben despacio. Hay 22 peces ángel",
          "cantidad": 22,
          "emoji": "2753",
          "objeto": "peces ángel",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos pezs hay?"
        }
      },
      "imagePath": "help-images/ACUARIO/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "El cristal del acuario está muy limpio y el agua se mueve suave. Hay 31 corales amarillos y traen 16 corales rosas muy grandes. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el agua se mueve suave. Hay 31 corales amarillos",
          "cantidad": 31,
          "emoji": "2753",
          "objeto": "corales",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/ACUARIO/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "El sonido de las burbujas es relajante y las paredes son de piedra fría. Hay 25 tiburones pequeños y llegan 24 tiburones martillo. ¿Cuántas piedra hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "las paredes son de piedra fría. Hay 25 tiburones pequeños",
          "cantidad": 25,
          "emoji": "2753",
          "objeto": "tiburones",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas piedra hay?"
        }
      },
      "imagePath": "help-images/ACUARIO/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "El agua de la piscina está muy salada y los cristales brillan. Tenía 48 estrellas de mar y hemos movido 15 a la zona de cría. ¿Cuántas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "los cristales brillan. Tenía 48 estrellas de mar",
          "cantidad": 48,
          "emoji": "2b50",
          "objeto": "estrellas de mar",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas sobran?"
        }
      },
      "imagePath": "help-images/ACUARIO/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "Los pájaros marinos gritan fuera y el suelo del acuario está mojado. Había 37 pegatinas de peces en la tienda y he vendido 15. ¿Cuántas pájaros quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el suelo del acuario está mojado. Había 37 pegatinas de peces en la tienda",
          "cantidad": 37,
          "emoji": "2b50",
          "objeto": "pegatinas de peces",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas pájaros quedan?"
        }
      },
      "imagePath": "help-images/ACUARIO/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "El reloj marca la hora de comer y las luces cambian a color lila. Tenía 46 pelotas para los leones marinos y se han pinchado 23. ¿Cuántas sirven?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "las luces cambian a color lila. Tenía 46 pelotas para los leones marinos",
          "cantidad": 46,
          "emoji": "2753",
          "objeto": "pelotas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas sirven?"
        }
      },
      "imagePath": "help-images/ACUARIO/problem_18.svg"
    }
  ],
  "JARDÍN": [
    {
      "id": 1,
      "enunciado": "En el mostrador hay 5 orquídeas blancas y el jardinero trae 4 orquídeas rosas. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el mostrador hay 5 orquídeas blancas",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "orquídeas"
        },
        "cambio": {
          "texto": "el jardinero trae 4 orquídeas rosas.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "orquídeas rosas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/JARDÍN/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Tenemos 6 cactus pequeños y compramos 3 cactus con flores rojas. ¿Cuántos cactus hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 6 cactus pequeños",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "cactus"
        },
        "cambio": {
          "texto": "compramos 3 cactus con flores rojas.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "cactus con flores",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos cactus hay?"
        }
      },
      "imagePath": "help-images/JARDÍN/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "En un jarrón hay 4 tulipanes rojos y 4 tulipanes amarillos. ¿Cuántos tulipanes hay?",
      "ayuda": {
        "inicio": {
          "texto": "En un jarrón hay 4 tulipanes rojos",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "tulipanes"
        },
        "cambio": {
          "texto": "4 tulipanes amarillos.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "tulipanes",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos tulipanes hay?"
        }
      },
      "imagePath": "help-images/JARDÍN/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Había 10 margaritas en una cesta y hemos vendido 4 a una señora. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 10 margaritas en una cesta",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "margaritas"
        },
        "cambio": {
          "texto": "hemos vendido 4 a una señora.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "a una señora",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/JARDÍN/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Tenía 9 paquetes de semillas y se han roto 5 paquetes en el suelo. ¿Cuántos quedan bien?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 9 paquetes de semillas",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "paquetes de semillas"
        },
        "cambio": {
          "texto": "se han roto 5 paquetes en el suelo.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "paquetes",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan bien?"
        }
      },
      "imagePath": "help-images/JARDÍN/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "En el estante hay 8 regaderas de colores y usamos 5 para las flores. ¿Cuántas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "En el estante hay 8 regaderas de colores",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "regaderas de colores"
        },
        "cambio": {
          "texto": "usamos 5 para las flores.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "para las flores",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas sobran?"
        }
      },
      "imagePath": "help-images/JARDÍN/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Hay 12 macetas de barro y traemos 6 macetas de cerámica azul. ¿Cuántas macetas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 macetas de barro",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "macetas de barro"
        },
        "cambio": {
          "texto": "traemos 6 macetas de cerámica azul.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "macetas de cerámica",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas macetas hay?"
        }
      },
      "imagePath": "help-images/JARDÍN/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Un puesto tiene 11 plantas carnívoras y 8 helechos verdes. ¿Cuántas plantas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Un puesto tiene 11 plantas carnívoras",
          "cantidad": 11,
          "emoji": "2753",
          "objeto": "plantas carnívoras"
        },
        "cambio": {
          "texto": "8 helechos verdes.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "helechos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas plantas hay?"
        }
      },
      "imagePath": "help-images/JARDÍN/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En el almacén hay 10 sacos de tierra y traen 7 sacos de abono. ¿Cuántos sacos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el almacén hay 10 sacos de tierra",
          "cantidad": 10,
          "emoji": "1f4e6",
          "objeto": "sacos de tierra"
        },
        "cambio": {
          "texto": "traen 7 sacos de abono.",
          "cantidad": 7,
          "emoji": "1f4e6",
          "objeto": "sacos de abono",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos sacos hay?"
        }
      },
      "imagePath": "help-images/JARDÍN/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Teníamos 16 ramos de rosas y los novios se llevan 5 ramos. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 ramos de rosas",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "ramos de rosas"
        },
        "cambio": {
          "texto": "los novios se llevan 5 ramos.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "ramos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/JARDÍN/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Había 15 bonsáis en la mesa y 4 se han llevado a la sombra. ¿Cuántos quedan al sol?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 bonsáis en la mesa",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "bonsáis"
        },
        "cambio": {
          "texto": "4 se han llevado a la sombra.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "se han llevado a la sombra",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan al sol?"
        }
      },
      "imagePath": "help-images/JARDÍN/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En la caja había 19 tijeras de podar y los jardineros usan 7. ¿Cuántas tijeras quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En la caja había 19 tijeras de podar",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "tijeras de podar"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas tijeras quedan?"
        }
      },
      "imagePath": "help-images/JARDÍN/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "El aire huele a jazmín dulce y el cielo está muy despejado. Tenemos 22 lirios blancos y el camión trae 14 lirios morados brillantes. ¿Cuántos camión hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el cielo está muy despejado. Tenemos 22 lirios blancos",
          "cantidad": 22,
          "emoji": "2753",
          "objeto": "lirios",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos camión hay?"
        }
      },
      "imagePath": "help-images/JARDÍN/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "Se oye el zumbido de las abejas y el suelo está recién regado. Hay 31 girasoles altos y traemos 16 girasoles bajos para decorar. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el suelo está recién regado. Hay 31 girasoles altos",
          "cantidad": 31,
          "emoji": "2753",
          "objeto": "girasoles",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/JARDÍN/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Las luces de la carpa brillan y las paredes son de cristal limpio. Hay 25 plantas de lavanda y compramos 23 plantas de romero. ¿Cuántas plantas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "las paredes son de cristal limpio. Hay 25 plantas de lavanda",
          "cantidad": 25,
          "emoji": "2753",
          "objeto": "plantas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas plantas hay?"
        }
      },
      "imagePath": "help-images/JARDÍN/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "El vapor del humidificador forma nubes y las hojas están brillantes. Teníamos 48 claveles rojos y hemos usado 15 para un gran centro floral. ¿Cuántos sobran?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "las hojas están brillantes. Teníamos 48 claveles rojos",
          "cantidad": 48,
          "emoji": "2753",
          "objeto": "claveles",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos sobran?"
        }
      },
      "imagePath": "help-images/JARDÍN/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "Los pájaros cantan en el tejado y el sol entra por la ventana. Había 37 folletos de cuidados y hemos repartido 15 a los visitantes. ¿Cuántos pájaros quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el sol entra por la ventana. Había 37 folletos de cuidados",
          "cantidad": 37,
          "emoji": "2753",
          "objeto": "folletos de cuidados",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos pájaros quedan?"
        }
      },
      "imagePath": "help-images/JARDÍN/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "El reloj de la torre suena y la gente camina despacio. Tenía 46 guantes de jardín y se han roto 23 por las espinas. ¿Cuántos sirven?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "la gente camina despacio. Tenía 46 guantes de jardín",
          "cantidad": 46,
          "emoji": "2753",
          "objeto": "guantes de jardín",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos sirven?"
        }
      },
      "imagePath": "help-images/JARDÍN/problem_18.svg"
    }
  ],
  "CONCURSO": [
    {
      "id": 1,
      "enunciado": "En la pista hay 5 perros Poodle y entran 4 perros Bulldog. ¿Cuántos perros hay en total?",
      "ayuda": {
        "inicio": {
          "texto": "En la pista hay 5 perros Poodle",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "perros poodle"
        },
        "cambio": {
          "texto": "entran 4 perros Bulldog.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "perros bulldog",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos perros hay en total?"
        }
      },
      "imagePath": "help-images/CONCURSO/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Tenemos 6 trofeos brillantes y el camión trae 3 trofeos más. ¿Cuántos trofeos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 6 trofeos brillantes",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "trofeos"
        },
        "cambio": {
          "texto": "el camión trae 3 trofeos más.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "trofeos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos trofeos hay?"
        }
      },
      "imagePath": "help-images/CONCURSO/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "Un perro ha ganado 4 cintas azules y 4 cintas rojas. ¿Cuántas cintas tiene?",
      "ayuda": {
        "inicio": {
          "texto": "Un perro ha ganado 4 cintas azules",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "cintas"
        },
        "cambio": {
          "texto": "4 cintas rojas.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "cintas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas cintas tiene?"
        }
      },
      "imagePath": "help-images/CONCURSO/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Había 10 sacos de premios y los jueces han usado 4. ¿Cuántos sacos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 10 sacos de premios",
          "cantidad": 10,
          "emoji": "1f4e6",
          "objeto": "sacos de premios"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos sacos quedan?"
        }
      },
      "imagePath": "help-images/CONCURSO/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Tenía 9 peines para perros y se han roto 5 durante el concurso. ¿Cuántos quedan bien?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 9 peines para perros",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "peines"
        },
        "cambio": {
          "texto": "se han roto 5 durante el concurso.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "durante el concurso",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan bien?"
        }
      },
      "imagePath": "help-images/CONCURSO/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "En el circuito hay 8 obstáculos y el perro ya ha saltado 5. ¿Cuántos le faltan?",
      "ayuda": {
        "inicio": {
          "texto": "En el circuito hay 8 obstáculos",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "obstáculos"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos le faltan?"
        }
      },
      "imagePath": "help-images/CONCURSO/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Hay 12 correas de cuero y traemos 6 correas de colores nuevas. ¿Cuántas colors hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 correas de cuero",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "correas de cuero"
        },
        "cambio": {
          "texto": "traemos 6 correas de colores nuevas.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "correas de colores",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas colors hay?"
        }
      },
      "imagePath": "help-images/CONCURSO/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Un grupo tiene 11 perros pequeños y 8 perros grandes. ¿Cuántos perros hay?",
      "ayuda": {
        "inicio": {
          "texto": "Un grupo tiene 11 perros pequeños",
          "cantidad": 11,
          "emoji": "2753",
          "objeto": "perros"
        },
        "cambio": {
          "texto": "8 perros grandes.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "perros",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos perros hay?"
        }
      },
      "imagePath": "help-images/CONCURSO/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En la zona de descanso hay 10 mantas y traen 7 mantas más. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la zona de descanso hay 10 mantas",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "mantas"
        },
        "cambio": {
          "texto": "traen 7 mantas más.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "mantas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/CONCURSO/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Teníamos 16 cepillos de seda y los peluqueros usan 5. ¿Cuántos quedan en la caja?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 cepillos de seda",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "cepillos de seda"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan en la caja?"
        }
      },
      "imagePath": "help-images/CONCURSO/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Había 15 pelotas de juguete y 4 han rodado fuera del ring. ¿Cuántas quedan dentro?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 pelotas de juguete",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "pelotas de juguete"
        },
        "cambio": {
          "texto": "4 han rodado fuera del ring.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "han rodado fuera",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan dentro?"
        }
      },
      "imagePath": "help-images/CONCURSO/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En la lista había 19 perros inscritos y 7 no han llegado a tiempo. ¿Cuántos concursan?",
      "ayuda": {
        "inicio": {
          "texto": "En la lista había 19 perros inscritos",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "perros inscritos"
        },
        "cambio": {
          "texto": "7 no han llegado a tiempo.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "no han llegado a tiempo",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos concursan?"
        }
      },
      "imagePath": "help-images/CONCURSO/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "El aire huele a champú de fresa y se oyen muchos ladridos. Tenemos 22 dorsales rojos y el juez trae 14 dorsales amarillos muy brillantes. ¿Cuántas fresa hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "se oyen muchos ladridos. Tenemos 22 dorsales rojos",
          "cantidad": 22,
          "emoji": "2753",
          "objeto": "dorsales",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas fresa hay?"
        }
      },
      "imagePath": "help-images/CONCURSO/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "Las luces del estadio brillan y el suelo está muy limpio. Hay 31 bebederos de metal y traemos 16 bebederos de plástico azul. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el suelo está muy limpio. Hay 31 bebederos de metal",
          "cantidad": 31,
          "emoji": "2753",
          "objeto": "bebederos de metal",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/CONCURSO/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Se oye música de desfile y el público aplaude mucho. Hay 25 pañuelos de cuello verdes y compramos 23 pañuelos de color naranja. ¿Cuántos color hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el público aplaude mucho. Hay 25 pañuelos de cuello verdes",
          "cantidad": 25,
          "emoji": "2753",
          "objeto": "pañuelos de cuello",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos color hay?"
        }
      },
      "imagePath": "help-images/CONCURSO/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "El vapor del secador de pelo forma nubes y los perros están muy suaves. Teníamos 48 botes de laca y hemos usado 15 para los perros Poodle. ¿Cuántos sobran?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "los perros están muy suaves. Teníamos 48 botes de laca",
          "cantidad": 48,
          "emoji": "1f36f",
          "objeto": "botes",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos sobran?"
        }
      },
      "imagePath": "help-images/CONCURSO/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "Los pájaros cantan fuera y el sol entra por los cristales del techo. Había 37 sillas para el público y hemos quitado 15 que estaban rotas. ¿Cuántas pájaros quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el sol entra por los cristales del techo. Había 37 sillas para el público",
          "cantidad": 37,
          "emoji": "2753",
          "objeto": "sillas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas pájaros quedan?"
        }
      },
      "imagePath": "help-images/CONCURSO/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "El reloj de la torre suena y la gente camina deprisa. Tenía 46 medallas de plata y hemos repartido 23 a los ganadores del desfile. ¿Cuántas medallas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "la gente camina deprisa. Tenía 46 medallas de plata",
          "cantidad": 46,
          "emoji": "2753",
          "objeto": "medallas de plata",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas medallas quedan?"
        }
      },
      "imagePath": "help-images/CONCURSO/problem_18.svg"
    }
  ],
  "RECUPERACIÓN": [
    {
      "id": 1,
      "enunciado": "En la sala de vuelo hay 5 halcones y traen 4 águilas rescatadas. ¿Cuántas aves hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la sala de vuelo hay 5 halcones",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "halcones"
        },
        "cambio": {
          "texto": "traen 4 águilas rescatadas.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "águilas rescatadas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas aves hay?"
        }
      },
      "imagePath": "help-images/RECUPERACIÓN/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Tenemos 6 tortugas en el estanque y el equipo encuentra 3 tortugas más. ¿Cuántas tortugas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 6 tortugas en el estanque",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "tortugas"
        },
        "cambio": {
          "texto": "el equipo encuentra 3 tortugas más.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "tortugas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas tortugas hay?"
        }
      },
      "imagePath": "help-images/RECUPERACIÓN/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "Un nido tiene 4 polluelos de búho y llegan otros 4 polluelos huérfanos. ¿Cuántos polluelos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Un nido tiene 4 polluelos de búho",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "polluelos de búho"
        },
        "cambio": {
          "texto": "llegan otros 4 polluelos huérfanos.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "polluelos huérfanos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos polluelos hay?"
        }
      },
      "imagePath": "help-images/RECUPERACIÓN/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Había 10 erizos en recuperación y hemos liberado 3 en el prado. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 10 erizos en recuperación",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "erizos"
        },
        "cambio": {
          "texto": "hemos liberado 3 en el prado.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "en el prado",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/RECUPERACIÓN/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Tenía 9 frascos de vitaminas y he usado 5 para los zorritos. ¿Cuántos me quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 9 frascos de vitaminas",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "frascos de vitaminas"
        },
        "cambio": {
          "texto": "he usado 5 para los zorritos.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "para los zorritos",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos me quedan?"
        }
      },
      "imagePath": "help-images/RECUPERACIÓN/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "En la jaula hay 8 ardillas y 4 ya se han ido a saltar a los árboles. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En la jaula hay 8 ardillas",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "ardillas"
        },
        "cambio": {
          "texto": "4 ya se han ido a saltar a los árboles.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "ya se han ido a saltar a los árboles",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/RECUPERACIÓN/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Hay 12 cajas de transporte vacías y el camión trae 6 cajas más. ¿Cuántas cajas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 cajas de transporte vacías",
          "cantidad": 12,
          "emoji": "1f4e6",
          "objeto": "cajas de transporte"
        },
        "cambio": {
          "texto": "el camión trae 6 cajas más.",
          "cantidad": 6,
          "emoji": "1f4e6",
          "objeto": "cajas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas cajas hay?"
        }
      },
      "imagePath": "help-images/RECUPERACIÓN/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Un biólogo ve 11 corzos en el valle y 8 corzos en la montaña. ¿Cuántos ve en total?",
      "ayuda": {
        "inicio": {
          "texto": "Un biólogo ve 11 corzos en el valle",
          "cantidad": 11,
          "emoji": "2753",
          "objeto": "corzos"
        },
        "cambio": {
          "texto": "8 corzos en la montaña.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "corzos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos ve en total?"
        }
      },
      "imagePath": "help-images/RECUPERACIÓN/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En la despensa hay 10 sacos de pienso y compramos 7 sacos nuevos. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la despensa hay 10 sacos de pienso",
          "cantidad": 10,
          "emoji": "1f4e6",
          "objeto": "sacos de pienso"
        },
        "cambio": {
          "texto": "compramos 7 sacos nuevos.",
          "cantidad": 7,
          "emoji": "1f4e6",
          "objeto": "sacos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/RECUPERACIÓN/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Teníamos 16 mantas para los animales y hemos usado 5 para los linces. ¿Cuántas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 mantas para los animales",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "mantas"
        },
        "cambio": {
          "texto": "hemos usado 5 para los linces.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "para los linces",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas sobran?"
        }
      },
      "imagePath": "help-images/RECUPERACIÓN/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Había 15 jeringuillas para vacunas y hemos gastado 4 hoy. ¿Cuántas jeringuillas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 jeringuillas para vacunas",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "jeringuillas"
        },
        "cambio": {
          "texto": "hemos gastado 4 hoy.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "hoy",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas jeringuillas quedan?"
        }
      },
      "imagePath": "help-images/RECUPERACIÓN/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En el mapa hay 19 nidos controlados y 7 ya están vacíos. ¿Cuántos nidos tienen aves?",
      "ayuda": {
        "inicio": {
          "texto": "En el mapa hay 19 nidos controlados",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "nidos controlados"
        },
        "cambio": {
          "texto": "7 ya están vacíos.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "ya están",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos nidos tienen aves?"
        }
      },
      "imagePath": "help-images/RECUPERACIÓN/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "El viento sopla fuerte y las hojas de los árboles bailan. Tenemos 22 búhos reales y llegan 14 búhos de un rescate en la ciudad. ¿Cuántos búhos hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "las hojas de los árboles bailan. Tenemos 22 búhos reales",
          "cantidad": 22,
          "emoji": "2753",
          "objeto": "búhos reales",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos búhos hay?"
        }
      },
      "imagePath": "help-images/RECUPERACIÓN/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "Se oye el goteo de la lluvia y el suelo huele a tierra mojada. Hay 31 viseras para el sol y el centro recibe 16 viseras nuevas para los voluntarios. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el suelo huele a tierra mojada. Hay 31 viseras para el sol",
          "cantidad": 31,
          "emoji": "2753",
          "objeto": "viseras",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/RECUPERACIÓN/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Las luces de la incubadora brillan y el silencio es total. Hay 25 huevos de cigüeña y nos traen 24 huevos de garza para cuidar. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el silencio es total. Hay 25 huevos de cigüeña",
          "cantidad": 25,
          "emoji": "1f95a",
          "objeto": "huevos de cigüeña",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/RECUPERACIÓN/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "El olor a mar inunda la sala y se oye el chapoteo del agua. Teníamos 48 pescados para las focas y hemos repartido 15 esta mañana. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "se oye el chapoteo del agua. Teníamos 48 pescados para las focas",
          "cantidad": 48,
          "emoji": "2753",
          "objeto": "pescados",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/RECUPERACIÓN/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "Los pájaros cantan fuera y el sol calienta el cristal de la ventana. Había 37 toallas limpias y hemos usado 15 para secar a unos patitos mojados. ¿Cuántas pájaros quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el sol calienta el cristal de la ventana. Había 37 toallas limpias",
          "cantidad": 37,
          "emoji": "2753",
          "objeto": "toallas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas pájaros quedan?"
        }
      },
      "imagePath": "help-images/RECUPERACIÓN/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "El reloj hace tictac y la merienda huele muy bien en la cocina. Tenía 46 anillas de identificación y he usado 23 para marcar a los pajaritos. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "la merienda huele muy bien en la cocina. Tenía 46 anillas de identificación",
          "cantidad": 46,
          "emoji": "2753",
          "objeto": "anillas de identificación",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/RECUPERACIÓN/problem_18.svg"
    }
  ],
  "PLAYA": [
    {
      "id": 1,
      "enunciado": "En la arena hay 5 conchas blancas y el mar trae 4 conchas rosas. ¿Cuántas conchas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la arena hay 5 conchas blancas",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "conchas"
        },
        "cambio": {
          "texto": "el mar trae 4 conchas rosas.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "conchas rosas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas conchas hay?"
        }
      },
      "imagePath": "help-images/PLAYA/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Tenemos 6 sombrillas abiertas y ponemos 3 sombrillas más. ¿Cuántas sombrillas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 6 sombrillas abiertas",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "sombrillas abiertas"
        },
        "cambio": {
          "texto": "ponemos 3 sombrillas más.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "sombrillas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas sombrillas hay?"
        }
      },
      "imagePath": "help-images/PLAYA/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "Hay 4 cubos azules y 4 palas amarillas en la orilla. ¿Cuántos juguetes hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 4 cubos azules",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "cubos"
        },
        "cambio": {
          "texto": "4 palas amarillas en la orilla.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "palas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos juguetes hay?"
        }
      },
      "imagePath": "help-images/PLAYA/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Había 10 polos de fresa y los niños se han comido 4. ¿Cuántas fresa quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 10 polos de fresa",
          "cantidad": 10,
          "emoji": "1f353",
          "objeto": "polos de fresa"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas fresa quedan?"
        }
      },
      "imagePath": "help-images/PLAYA/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Tenía 9 toallas extendidas y el viento se ha llevado 5. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 9 toallas extendidas",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "toallas extendidas"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/PLAYA/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "En una roca hay 8 estrellas de mar y 5 se han ido al agua. ¿Cuántas estrellas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En una roca hay 8 estrellas de mar",
          "cantidad": 8,
          "emoji": "2b50",
          "objeto": "estrellas de mar"
        },
        "cambio": {
          "texto": "5 se han ido al agua.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "se han ido",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas estrellas quedan?"
        }
      },
      "imagePath": "help-images/PLAYA/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Hay 12 piedras blancas redondas y guardamos 6 piedras grises. ¿Cuántas piedras hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 piedras blancas redondas",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "piedras redondas"
        },
        "cambio": {
          "texto": "guardamos 6 piedras grises.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "piedras grises",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas piedras hay?"
        }
      },
      "imagePath": "help-images/PLAYA/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "En un banco de peces hay 11 peces plata y 8 peces azules. ¿Cuántos pezs hay?",
      "ayuda": {
        "inicio": {
          "texto": "En un banco de peces hay 11 peces plata",
          "cantidad": 11,
          "emoji": "2753",
          "objeto": "peces plata"
        },
        "cambio": {
          "texto": "8 peces azules.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "peces",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos pezs hay?"
        }
      },
      "imagePath": "help-images/PLAYA/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En el puerto hay 10 barcos de vela y llegan 7 motos de agua. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el puerto hay 10 barcos de vela",
          "cantidad": 10,
          "emoji": "1f56f",
          "objeto": "barcos de vela"
        },
        "cambio": {
          "texto": "llegan 7 motos de agua.",
          "cantidad": 7,
          "emoji": "1f4a7",
          "objeto": "motos de agua",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/PLAYA/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Teníamos 16 bocadillos de jamón y nos hemos comido 5. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 bocadillos de jamón",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "bocadillos de jamón"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/PLAYA/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Había 15 botes de crema solar y se han gastado 4. ¿Cuántos botes quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 botes de crema solar",
          "cantidad": 15,
          "emoji": "1f36f",
          "objeto": "botes de crema solar"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos botes quedan?"
        }
      },
      "imagePath": "help-images/PLAYA/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En el cielo hay 19 gaviotas y 7 han volado hacia el faro. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En el cielo hay 19 gaviotas",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "gaviotas"
        },
        "cambio": {
          "texto": "7 han volado hacia el faro.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "han volado hacia el faro",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/PLAYA/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "El aire huele a salitre y las olas suenan muy fuerte. Hay 22 gafas de buceo azules y compramos 14 gafas de color rosa. ¿Cuántas color hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "las olas suenan muy fuerte. Hay 22 gafas de buceo azules",
          "cantidad": 22,
          "emoji": "2753",
          "objeto": "gafas de buceo",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas color hay?"
        }
      },
      "imagePath": "help-images/PLAYA/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "La arena quema mucho los pies y el viento sopla suave. Hay 31 cometas de papel y traemos 16 cometas de tela. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el viento sopla suave. Hay 31 cometas de papel",
          "cantidad": 31,
          "emoji": "2753",
          "objeto": "cometas de papel",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/PLAYA/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "El sol brilla mucho y se oye música de radio a lo lejos. Hay 25 pares de chanclas y 23 bañadores de flores. ¿Cuántas prendas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "se oye música de radio a lo lejos. Hay 25 pares de chanclas",
          "cantidad": 25,
          "emoji": "2753",
          "objeto": "pares de chanclas",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas prendas hay?"
        }
      },
      "imagePath": "help-images/PLAYA/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "El agua está muy fría y salpica al saltar. Teníamos 48 botellas de agua y nos hemos bebido 15 bajo el sol. ¿Cuántas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "salpica al saltar. Teníamos 48 botellas de agua",
          "cantidad": 48,
          "emoji": "1f4a7",
          "objeto": "botellas de agua",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas sobran?"
        }
      },
      "imagePath": "help-images/PLAYA/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "Se oyen pájaros marinos y el sabor de la sal está en los labios. Había 37 pelotas de playa y se han pinchado 15. ¿Cuántas quedan bien?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el sabor de la sal está en los labios. Había 37 pelotas de playa",
          "cantidad": 37,
          "emoji": "2753",
          "objeto": "pelotas de playa",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan bien?"
        }
      },
      "imagePath": "help-images/PLAYA/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "Los niños ríen y suena la campana del heladero. Teníamos 46 castillos de arena y las olas han deshecho 23. ¿Cuántos niños quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "suena la campana del heladero. Teníamos 46 castillos de arena",
          "cantidad": 46,
          "emoji": "2753",
          "objeto": "castillos de arena",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos niños quedan?"
        }
      },
      "imagePath": "help-images/PLAYA/problem_18.svg"
    }
  ],
  "BOMBEROS": [
    {
      "id": 1,
      "enunciado": "El capitán tiene 5 cascos rojos y compra 3 cascos amarillos nuevos. ¿Cuántos cascos tiene?",
      "ayuda": {
        "inicio": {
          "texto": "El capitán tiene 5 cascos rojos",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "cascos"
        },
        "cambio": {
          "texto": "compra 3 cascos amarillos nuevos.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "cascos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos cascos tiene?"
        }
      },
      "imagePath": "help-images/BOMBEROS/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "En el garaje hay 4 camiones grandes y llegan 4 camiones pequeños. ¿Cuántos camiones hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el garaje hay 4 camiones grandes",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "camiones"
        },
        "cambio": {
          "texto": "llegan 4 camiones pequeños.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "camiones",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos camiones hay?"
        }
      },
      "imagePath": "help-images/BOMBEROS/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "Vemos 6 mangueras largas y el mecánico trae 2 mangueras cortas. ¿Cuántas mangueras tenemos?",
      "ayuda": {
        "inicio": {
          "texto": "Vemos 6 mangueras largas",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "mangueras largas"
        },
        "cambio": {
          "texto": "el mecánico trae 2 mangueras cortas.",
          "cantidad": 2,
          "emoji": "2753",
          "objeto": "mangueras cortas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas mangueras tenemos?"
        }
      },
      "imagePath": "help-images/BOMBEROS/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Tenemos 9 extintores llenos, pero usamos 3 en una práctica. ¿Cuántos quedan llenos?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 9 extintores llenos,",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "extintores llenos"
        },
        "cambio": {
          "texto": "usamos 3 en una práctica.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "en una práctica",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan llenos?"
        }
      },
      "imagePath": "help-images/BOMBEROS/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Hay 8 dálmatas jugando y 4 dálmatas se van a dormir. ¿Cuántos siguen jugando?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 8 dálmatas jugando",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "dálmatas jugando"
        },
        "cambio": {
          "texto": "4 dálmatas se van a dormir.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "dálmatas se van a dormir",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos siguen jugando?"
        }
      },
      "imagePath": "help-images/BOMBEROS/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "En la mesa hay 7 bocadillos y los bomberos se comen 5. ¿Cuántos bocadillos sobran?",
      "ayuda": {
        "inicio": {
          "texto": "En la mesa hay 7 bocadillos",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "bocadillos"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos bocadillos sobran?"
        }
      },
      "imagePath": "help-images/BOMBEROS/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "En la estantería hay 12 botas izquierdas y ponemos 6 botas derechas. ¿Cuántas botas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la estantería hay 12 botas izquierdas",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "botas izquierdas"
        },
        "cambio": {
          "texto": "ponemos 6 botas derechas.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "botas derechas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas botas hay?"
        }
      },
      "imagePath": "help-images/BOMBEROS/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "El equipo tiene 11 linternas y recibe una caja con 8 linternas más. ¿Cuántas linternas tienen?",
      "ayuda": {
        "inicio": {
          "texto": "El equipo tiene 11 linternas",
          "cantidad": 11,
          "emoji": "2753",
          "objeto": "linternas"
        },
        "cambio": {
          "texto": "recibe una caja con 8 linternas más.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "linternas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas linternas tienen?"
        }
      },
      "imagePath": "help-images/BOMBEROS/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "Hay 10 escaleras en el suelo y bajan 5 escaleras del camión. ¿Cuántas escaleras hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 10 escaleras en el suelo",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "escaleras"
        },
        "cambio": {
          "texto": "bajan 5 escaleras del camión.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "escaleras",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas escaleras hay?"
        }
      },
      "imagePath": "help-images/BOMBEROS/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Había 16 conos naranjas en la calle y recogemos 4 conos. ¿Cuántos conos quedan puestos?",
      "ayuda": {
        "inicio": {
          "texto": "Había 16 conos naranjas en la calle",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "conos"
        },
        "cambio": {
          "texto": "recogemos 4 conos.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "conos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos conos quedan puestos?"
        }
      },
      "imagePath": "help-images/BOMBEROS/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "El tanque tenía 19 litros de agua y gastamos 7 litros regando. ¿Cuántos litros quedan?",
      "ayuda": {
        "inicio": {
          "texto": "El tanque tenía 19 litros de agua",
          "cantidad": 19,
          "emoji": "1f4a7",
          "objeto": "litros de agua"
        },
        "cambio": {
          "texto": "gastamos 7 litros regando.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "litros regando",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos litros quedan?"
        }
      },
      "imagePath": "help-images/BOMBEROS/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "Tenemos 15 medallas brillantes para regalar y entregamos 3 medallas. ¿Cuántas nos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 15 medallas brillantes para regalar",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "medallas"
        },
        "cambio": {
          "texto": "entregamos 3 medallas.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "medallas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas nos quedan?"
        }
      },
      "imagePath": "help-images/BOMBEROS/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "El día es muy soleado y perfecto para limpiar los vehículos grandes. Lavamos 22 ruedas del camión grande y luego lavamos 14 ruedas del camión pequeño. ¿Cuántas ruedas lavamos?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "perfecto para limpiar los vehículos grandes. Lavamos 22 ruedas del camión grande",
          "cantidad": 22,
          "emoji": "2753",
          "objeto": "ruedas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas ruedas lavamos?"
        }
      },
      "imagePath": "help-images/BOMBEROS/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "La sirena suena muy fuerte para avisar a todos los coches. En el primer aviso sonó 31 veces y en el segundo aviso sonó 12 veces más. ¿Cuántos sonidos hizo?",
      "ayuda": {
        "inicio": {
          "texto": "La sirena suena muy fuerte para avisar a todos los coches. En el primer aviso sonó 31 veces",
          "cantidad": 31,
          "emoji": "2753",
          "objeto": "veces"
        },
        "cambio": {
          "texto": "en el segundo aviso sonó 12 veces más.",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "veces",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos sonidos hizo?"
        }
      },
      "imagePath": "help-images/BOMBEROS/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Los bomberos entrenan subiendo y bajando por la torre de madera. El bombero subió 24 escalones muy rápido y después subió otros 25 escalones sin cansarse. ¿Cuántos escalones subió?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "bajando por la torre de madera. El bombero subió 24 escalones muy rápido",
          "cantidad": 24,
          "emoji": "2753",
          "objeto": "escalones rápido",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos escalones subió?"
        }
      },
      "imagePath": "help-images/BOMBEROS/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "El gato estaba muy asustado encima del árbol alto del parque. Los bomberos pusieron 38 colchonetas blandas abajo pero retiraron 12 porque no hacían falta. ¿Cuántas colchonetas dejaron?",
      "ayuda": {
        "inicio": {
          "texto": "El gato estaba muy asustado encima del árbol alto del parque. Los bomberos pusieron 38 colchonetas blandas abajo",
          "cantidad": 38,
          "emoji": "1f9c4",
          "objeto": "colchonetas blandas abajo"
        },
        "cambio": {
          "texto": "retiraron 12 porque no hacían falta.",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "porque no hacían falta",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas colchonetas dejaron?"
        }
      },
      "imagePath": "help-images/BOMBEROS/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "En la cocina del parque huele muy bien a comida rica. Prepararon 46 platos de sopa caliente y los bomberos ya se han comido 24 platos. ¿Cuántos platos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En la cocina del parque huele muy bien a comida rica. Prepararon 46 platos de sopa caliente",
          "cantidad": 46,
          "emoji": "1f37d",
          "objeto": "platos de sopa caliente"
        },
        "cambio": {
          "texto": "los bomberos ya se han comido 24 platos.",
          "cantidad": 24,
          "emoji": "1f37d",
          "objeto": "platos",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos platos quedan?"
        }
      },
      "imagePath": "help-images/BOMBEROS/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "El almacén de uniformes está muy ordenado con ropa limpia colgada. Teníamos 35 pantalones azules colgados y los bomberos se han llevado 13 pantalones para vestirse. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "El almacén de uniformes está muy ordenado con ropa limpia colgada. Teníamos 35 pantalones azules colgados",
          "cantidad": 35,
          "emoji": "2753",
          "objeto": "pantalones colgados"
        },
        "cambio": {
          "texto": "los bomberos se han llevado 13 pantalones para vestirse.",
          "cantidad": 13,
          "emoji": "2753",
          "objeto": "pantalones",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/BOMBEROS/problem_18.svg"
    }
  ],
  "PARQUE": [
    {
      "id": 4,
      "enunciado": "Enunciado",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/PARQUE/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "En el árbol hay 5 pájaros cantando y llegan 4 pájaros más a la rama. ¿Cuántos pájaros hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el árbol hay 5 pájaros cantando",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "pájaros cantando"
        },
        "cambio": {
          "texto": "llegan 4 pájaros más a la rama.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "pájaros a la rama",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos pájaros hay?"
        }
      },
      "imagePath": "help-images/PARQUE/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "Tenemos 6 columpios de color rojo y el ayuntamiento pone 3 columpios verdes. ¿Cuántos columpios hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 6 columpios de color rojo",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "columpios de color"
        },
        "cambio": {
          "texto": "el ayuntamiento pone 3 columpios verdes.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "columpios",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos columpios hay?"
        }
      },
      "imagePath": "help-images/PARQUE/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "En el arenero hay 4 cubos de plástico y 4 palas de colores. ¿Cuántos juguetes hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el arenero hay 4 cubos de plástico",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "cubos de plástico"
        },
        "cambio": {
          "texto": "4 palas de colores.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "palas de colores",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos juguetes hay?"
        }
      },
      "imagePath": "help-images/PARQUE/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Un vendedor tenía 10 globos de helio y se le han escapado 4 volando. ¿Cuántos le quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Un vendedor tenía 10 globos de helio",
          "cantidad": 10,
          "emoji": "1f388",
          "objeto": "globos de helio"
        },
        "cambio": {
          "texto": "se le han escapado 4 volando.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "volando",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos le quedan?"
        }
      },
      "imagePath": "help-images/PARQUE/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "Tenía 9 cromos para jugar en el banco y he perdido 5 entre las hojas. ¿Cuántos tengo?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 9 cromos para jugar en el banco",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "cromos"
        },
        "cambio": {
          "texto": "he perdido 5 entre las hojas.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "entre las hojas",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos tengo?"
        }
      },
      "imagePath": "help-images/PARQUE/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "En el camino hay 8 perros paseando y 5 ya se han ido a casa. ¿Cuántos perros quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En el camino hay 8 perros paseando",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "perros paseando"
        },
        "cambio": {
          "texto": "5 ya se han ido a casa.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "ya se han ido a casa",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos perros quedan?"
        }
      },
      "imagePath": "help-images/PARQUE/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Hay 12 bancos de madera para descansar y ponen 6 bancos de hierro nuevos. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 bancos de madera para descansar",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "bancos de madera"
        },
        "cambio": {
          "texto": "ponen 6 bancos de hierro nuevos.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "bancos de hierro",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/PARQUE/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En el estanque hay 11 patos nadando y llegan 8 patos pequeños. ¿Cuántos patos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el estanque hay 11 patos nadando",
          "cantidad": 11,
          "emoji": "2753",
          "objeto": "patos nadando"
        },
        "cambio": {
          "texto": "llegan 8 patos pequeños.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "patos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos patos hay?"
        }
      },
      "imagePath": "help-images/PARQUE/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "En la caseta hay 10 balones de fútbol y traen 7 balones de baloncesto. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la caseta hay 10 balones de fútbol",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "balones de fútbol"
        },
        "cambio": {
          "texto": "traen 7 balones de baloncesto.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "balones de baloncesto",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/PARQUE/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "Teníamos 16 sándwiches para la merienda y nos hemos comido 5. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 sándwiches para la merienda",
          "cantidad": 16,
          "emoji": "1f96a",
          "objeto": "sándwiches"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/PARQUE/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Había 15 árboles jóvenes plantados y 4 se han secado por el calor. ¿Cuántos quedan vivos?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 árboles jóvenes plantados",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "árboles jóvenes plantados"
        },
        "cambio": {
          "texto": "4 se han secado por el calor.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "se han secado por el calor",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan vivos?"
        }
      },
      "imagePath": "help-images/PARQUE/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "En el aparcamiento hay 19 bicicletas y 7 niños se las han llevado para correr. ¿Cuántas niños quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En el aparcamiento hay 19 bicicletas",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "bicicletas"
        },
        "cambio": {
          "texto": "7 niños se las han llevado para correr.",
          "cantidad": 7,
          "emoji": "1f466",
          "objeto": "niños se las han llevado",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas niños quedan?"
        }
      },
      "imagePath": "help-images/PARQUE/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "El sol calienta mucho y se oye el ruido de las fuentes. Hay 22 palomas grises comiendo pan y llegan 14 palomas blancas volando muy rápido. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "se oye el ruido de las fuentes. Hay 22 palomas grises comiendo pan",
          "cantidad": 22,
          "emoji": "2753",
          "objeto": "palomas grises comiendo pan",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/PARQUE/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "El viento sopla suave y huele a flores frescas de primavera. Hay 31 hojas secas en el suelo y caen 16 hojas amarillas más del roble. ¿Cuántas flors hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "huele a flores frescas de primavera. Hay 31 hojas secas en el suelo",
          "cantidad": 31,
          "emoji": "2753",
          "objeto": "hojas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas flors hay?"
        }
      },
      "imagePath": "help-images/PARQUE/problem_18.svg"
    },
    {
      "id": 19,
      "enunciado": "Los niños gritan de alegría y el vendedor de helados hace sonar su campana. Hay 25 helados de fresa y compramos 23 de chocolate. ¿Cuántos niños hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el vendedor de helados hace sonar su campana. Hay 25 helados de fresa",
          "cantidad": 25,
          "emoji": "1f353",
          "objeto": "helados de fresa",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos niños hay?"
        }
      },
      "imagePath": "help-images/PARQUE/problem_19.svg"
    },
    {
      "id": 20,
      "enunciado": "El agua de la fuente está muy fría y brilla con el sol. Teníamos 48 monedas de un céntimo en el fondo y hemos sacado 15 para limpiar. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "brilla con el sol. Teníamos 48 monedas de un céntimo en el fondo",
          "cantidad": 48,
          "emoji": "2753",
          "objeto": "monedas de un céntimo",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/PARQUE/problem_20.svg"
    },
    {
      "id": 21,
      "enunciado": "Los pájaros cantan muy alto y el suelo de caucho está un poco caliente. Había 37 entradas para el tiovivo y hemos vendido 15 a los abuelos. ¿Cuántas pájaros quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el suelo de caucho está un poco caliente. Había 37 entradas para el tiovivo",
          "cantidad": 37,
          "emoji": "2753",
          "objeto": "entradas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas pájaros quedan?"
        }
      },
      "imagePath": "help-images/PARQUE/problem_21.svg"
    },
    {
      "id": 22,
      "enunciado": "El reloj del parque marca la hora de cenar y las farolas se encienden. Tenía 46 cometas volando y 23 han bajado al suelo porque no hay viento. ¿Cuántas quedan arriba?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "las farolas se encienden. Tenía 46 cometas volando",
          "cantidad": 46,
          "emoji": "2753",
          "objeto": "cometas volando",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan arriba?"
        }
      },
      "imagePath": "help-images/PARQUE/problem_22.svg"
    }
  ],
  "HUERTO": [
    {
      "id": 1,
      "enunciado": "En un surco hay 5 lechugas verdes y plantamos 4 lechugas moradas. ¿Cuántas lechugas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En un surco hay 5 lechugas verdes",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "lechugas"
        },
        "cambio": {
          "texto": "plantamos 4 lechugas moradas.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "lechugas moradas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas lechugas hay?"
        }
      },
      "imagePath": "help-images/HUERTO/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Tenemos 6 calabacines largos y recolectamos 3 calabacines redondos. ¿Cuántos calabacíns hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 6 calabacines largos",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "calabacines largos"
        },
        "cambio": {
          "texto": "recolectamos 3 calabacines redondos.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "calabacines redondos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos calabacíns hay?"
        }
      },
      "imagePath": "help-images/HUERTO/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "En una rama hay 4 tomates rojos y 4 tomates amarillos. ¿Cuántos tomates hay?",
      "ayuda": {
        "inicio": {
          "texto": "En una rama hay 4 tomates rojos",
          "cantidad": 4,
          "emoji": "1f345",
          "objeto": "tomates"
        },
        "cambio": {
          "texto": "4 tomates amarillos.",
          "cantidad": 4,
          "emoji": "1f345",
          "objeto": "tomates",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos tomates hay?"
        }
      },
      "imagePath": "help-images/HUERTO/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Había 10 gusanos de seda en las hojas y 3 se han convertido en mariposa. ¿Cuántas mariposa quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 10 gusanos de seda en las hojas",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "gusanos de seda"
        },
        "cambio": {
          "texto": "3 se han convertido en mariposa.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "se han convertido",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas mariposa quedan?"
        }
      },
      "imagePath": "help-images/HUERTO/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Tenía 9 macetas de barro y se han roto 5 al moverlas. ¿Cuántas quedan enteras?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 9 macetas de barro",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "macetas de barro"
        },
        "cambio": {
          "texto": "se han roto 5 al moverlas.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "al moverlas",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan enteras?"
        }
      },
      "imagePath": "help-images/HUERTO/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "En el cobertizo hay 8 azadas y los abuelos usan 5 para trabajar. ¿Cuántas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "En el cobertizo hay 8 azadas",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "azadas"
        },
        "cambio": {
          "texto": "los abuelos usan 5 para trabajar.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "para trabajar",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas sobran?"
        }
      },
      "imagePath": "help-images/HUERTO/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Hay 12 cajas de madera y el tractor trae 6 cajas de plástico. ¿Cuántas cajas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 cajas de madera",
          "cantidad": 12,
          "emoji": "1f4e6",
          "objeto": "cajas de madera"
        },
        "cambio": {
          "texto": "el tractor trae 6 cajas de plástico.",
          "cantidad": 6,
          "emoji": "1f4e6",
          "objeto": "cajas de plástico",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas cajas hay?"
        }
      },
      "imagePath": "help-images/HUERTO/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Un bancal tiene 11 plantas de pimiento y 8 de berenjena. ¿Cuántas plantas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Un bancal tiene 11 plantas de pimiento",
          "cantidad": 11,
          "emoji": "2753",
          "objeto": "plantas de pimiento"
        },
        "cambio": {
          "texto": "8 de berenjena.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "de berenjena",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas plantas hay?"
        }
      },
      "imagePath": "help-images/HUERTO/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En el depósito hay 10 litros de agua y echamos 7 litros más. ¿Cuántos litros hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el depósito hay 10 litros de agua",
          "cantidad": 10,
          "emoji": "1f4a7",
          "objeto": "litros de agua"
        },
        "cambio": {
          "texto": "echamos 7 litros más.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "litros",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos litros hay?"
        }
      },
      "imagePath": "help-images/HUERTO/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Teníamos 16 zanahorias y los conejitos se han comido 5. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 zanahorias",
          "cantidad": 16,
          "emoji": "1f955",
          "objeto": "zanahorias"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/HUERTO/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Había 15 espantapájaros en el campo y 4 se han caído por el viento. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 espantapájaros en el campo",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "espantapájaros"
        },
        "cambio": {
          "texto": "4 se han caído por el viento.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "se han caído por el viento",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/HUERTO/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En la cesta había 19 fresas y nos hemos merendado 7. ¿Cuántas fresas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En la cesta había 19 fresas",
          "cantidad": 19,
          "emoji": "1f353",
          "objeto": "fresas"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas fresas quedan?"
        }
      },
      "imagePath": "help-images/HUERTO/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "El aire huele a albahaca y se oye el motor de un tractor lejos. Tenemos 22 calabazas grandes y el vecino nos regala 14 calabazas pequeñas. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "se oye el motor de un tractor lejos. Tenemos 22 calabazas grandes",
          "cantidad": 22,
          "emoji": "2753",
          "objeto": "calabazas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/HUERTO/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "Las abejas zumban entre las flores y el suelo está muy húmedo. Hay 31 surcos de patatas y el jardinero cava 16 surcos nuevos. ¿Cuántas flors hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el suelo está muy húmedo. Hay 31 surcos de patatas",
          "cantidad": 31,
          "emoji": "1f954",
          "objeto": "surcos de patatas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas flors hay?"
        }
      },
      "imagePath": "help-images/HUERTO/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "El sol brilla mucho y las mariposas blancas vuelan sobre las coles. Hay 25 sobres de semillas de rábano y compramos 23 de cebolla. ¿Cuántas mariposas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "las mariposas blancas vuelan sobre las coles. Hay 25 sobres de semillas de rábano",
          "cantidad": 25,
          "emoji": "2753",
          "objeto": "sobres de semillas de rábano",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas mariposas hay?"
        }
      },
      "imagePath": "help-images/HUERTO/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "Se oye el canto de los pájaros y el agua corre por la acequia. Teníamos 48 pepinos y hemos llevado 15 a la tienda del pueblo. ¿Cuántos pájaros quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el agua corre por la acequia. Teníamos 48 pepinos",
          "cantidad": 48,
          "emoji": "2753",
          "objeto": "pepinos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos pájaros quedan?"
        }
      },
      "imagePath": "help-images/HUERTO/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "El cielo está nublado y se nota el frescor de la tarde. Había 37 estacas para los tomates y hemos usado 15 para sujetar las plantas. ¿Cuántas tomates quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "se nota el frescor de la tarde. Había 37 estacas para los tomates",
          "cantidad": 37,
          "emoji": "2753",
          "objeto": "estacas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas tomates quedan?"
        }
      },
      "imagePath": "help-images/HUERTO/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "El reloj de la iglesia suena a lo lejos y el gato duerme bajo la sombra. Tenía 46 bulbos de ajo y he plantado 23 antes de comer. ¿Cuántos quedan en la bolsa?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el gato duerme bajo la sombra. Tenía 46 bulbos de ajo",
          "cantidad": 46,
          "emoji": "1f9c4",
          "objeto": "bulbos de ajo",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan en la bolsa?"
        }
      },
      "imagePath": "help-images/HUERTO/problem_18.svg"
    }
  ],
  "GRANJA": [
    {
      "id": 1,
      "enunciado": "En el nido hay 5 pollitos amarillos y nacen 4 pollitos marrones. ¿Cuántos pollitos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el nido hay 5 pollitos amarillos",
          "cantidad": 5,
          "emoji": "1f424",
          "objeto": "pollitos"
        },
        "cambio": {
          "texto": "nacen 4 pollitos marrones.",
          "cantidad": 4,
          "emoji": "1f424",
          "objeto": "pollitos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos pollitos hay?"
        }
      },
      "imagePath": "help-images/GRANJA/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Tenemos 6 cerditos en el barro y llegan 3 cerditos más a jugar. ¿Cuántos cerditos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 6 cerditos en el barro",
          "cantidad": 6,
          "emoji": "1f437",
          "objeto": "cerditos"
        },
        "cambio": {
          "texto": "llegan 3 cerditos más a jugar.",
          "cantidad": 3,
          "emoji": "1f437",
          "objeto": "cerditos a jugar",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos cerditos hay?"
        }
      },
      "imagePath": "help-images/GRANJA/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "En un establo hay 4 ovejas blancas y 4 ovejas negras. ¿Cuántas ovejas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En un establo hay 4 ovejas blancas",
          "cantidad": 4,
          "emoji": "1f411",
          "objeto": "ovejas"
        },
        "cambio": {
          "texto": "4 ovejas negras.",
          "cantidad": 4,
          "emoji": "1f411",
          "objeto": "ovejas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas ovejas hay?"
        }
      },
      "imagePath": "help-images/GRANJA/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Había 10 huevos en la huevera y hemos usado 4 para hacer un bizcocho. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 10 huevos en la huevera",
          "cantidad": 10,
          "emoji": "1f95a",
          "objeto": "huevos"
        },
        "cambio": {
          "texto": "hemos usado 4 para hacer un bizcocho.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "para hacer un bizcocho",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/GRANJA/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Tenía 9 manzanas en un árbol y se han caído 5 al suelo. ¿Cuántas quedan en las ramas?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 9 manzanas en un árbol",
          "cantidad": 9,
          "emoji": "1f34e",
          "objeto": "manzanas"
        },
        "cambio": {
          "texto": "se han caído 5 al suelo.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "al suelo",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan en las ramas?"
        }
      },
      "imagePath": "help-images/GRANJA/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "En el campo hay 8 vacas y 5 se han ido a beber agua al río. ¿Cuántas vacas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En el campo hay 8 vacas",
          "cantidad": 8,
          "emoji": "1f404",
          "objeto": "vacas"
        },
        "cambio": {
          "texto": "5 se han ido a beber agua al río.",
          "cantidad": 5,
          "emoji": "1f4a7",
          "objeto": "se han ido a beber agua",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas vacas quedan?"
        }
      },
      "imagePath": "help-images/GRANJA/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Hay 12 sacos de trigo en el granero y el camión trae 6 sacos más. ¿Cuántos sacos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 sacos de trigo en el granero",
          "cantidad": 12,
          "emoji": "1f33e",
          "objeto": "sacos de trigo"
        },
        "cambio": {
          "texto": "el camión trae 6 sacos más.",
          "cantidad": 6,
          "emoji": "1f4e6",
          "objeto": "sacos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos sacos hay?"
        }
      },
      "imagePath": "help-images/GRANJA/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Un pastor tiene 11 cabras saltando y 8 cabras durmiendo. ¿Cuántas cabras hay?",
      "ayuda": {
        "inicio": {
          "texto": "Un pastor tiene 11 cabras saltando",
          "cantidad": 11,
          "emoji": "1f410",
          "objeto": "cabras saltando"
        },
        "cambio": {
          "texto": "8 cabras durmiendo.",
          "cantidad": 8,
          "emoji": "1f410",
          "objeto": "cabras durmiendo",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas cabras hay?"
        }
      },
      "imagePath": "help-images/GRANJA/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En la despensa hay 10 tarros de miel y traen 7 tarros de mermelada. ¿Cuántos tarros hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la despensa hay 10 tarros de miel",
          "cantidad": 10,
          "emoji": "1f36f",
          "objeto": "tarros de miel"
        },
        "cambio": {
          "texto": "traen 7 tarros de mermelada.",
          "cantidad": 7,
          "emoji": "1f353",
          "objeto": "tarros de mermelada",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos tarros hay?"
        }
      },
      "imagePath": "help-images/GRANJA/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Teníamos 16 herraduras para los caballos y hemos usado 5. ¿Cuántas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 herraduras para los caballos",
          "cantidad": 16,
          "emoji": "1f527",
          "objeto": "herraduras"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas sobran?"
        }
      },
      "imagePath": "help-images/GRANJA/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Había 15 pavos en el corral y 4 se han escapado por la valla. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 pavos en el corral",
          "cantidad": 15,
          "emoji": "1f983",
          "objeto": "pavos"
        },
        "cambio": {
          "texto": "4 se han escapado por la valla.",
          "cantidad": 4,
          "emoji": "1fab5",
          "objeto": "se han escapado por la valla",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/GRANJA/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En la caja hay 19 herramientas y el granjero usa 7 para arreglar el tractor. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En la caja hay 19 herramientas",
          "cantidad": 19,
          "emoji": "1f527",
          "objeto": "herramientas"
        },
        "cambio": {
          "texto": "el granjero usa 7 para arreglar el tractor.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "para arreglar el tractor",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/GRANJA/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "El aire huele a alfalfa fresca y se oye el motor de un tractor lejos. Tenemos 22 gallinas blancas y llegan 14 gallinas marrones de otra granja. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "se oye el motor de un tractor lejos. Tenemos 22 gallinas blancas",
          "cantidad": 22,
          "emoji": "1f414",
          "objeto": "gallinas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/GRANJA/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "El sol calienta la paja y las moscas zumban en el establo. Hay 31 fardos de paja seca y el tractor trae 16 fardos nuevos. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "las moscas zumban en el establo. Hay 31 fardos de paja seca",
          "cantidad": 31,
          "emoji": "1f33e",
          "objeto": "fardos de paja",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/GRANJA/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Los pájaros cantan en el tejado y el perro ladra alegremente. Hay 25 botes de leche fresca y compramos 23 botes de queso. ¿Cuántos productos hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el perro ladra alegremente. Hay 25 botes de leche fresca",
          "cantidad": 25,
          "emoji": "1f95b",
          "objeto": "botes de leche",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos productos hay?"
        }
      },
      "imagePath": "help-images/GRANJA/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "Se oye el goteo de la lluvia en el tejado de zinc y el suelo está embarrado. Teníamos 48 zanahorias para los caballos y hemos repartido 15. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el suelo está embarrado. Teníamos 48 zanahorias para los caballos",
          "cantidad": 48,
          "emoji": "1f955",
          "objeto": "zanahorias",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/GRANJA/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "El cielo está muy azul y las mariposas vuelan sobre las flores. Había 37 vallas de madera y hemos quitado 15 que estaban viejas. ¿Cuántas mariposas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "las mariposas vuelan sobre las flores. Había 37 vallas de madera",
          "cantidad": 37,
          "emoji": "1fab5",
          "objeto": "vallas de madera",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas mariposas quedan?"
        }
      },
      "imagePath": "help-images/GRANJA/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "El reloj de la torre suena y es la hora de cenar en la casa. Tenía 46 botellas de leche y he vendido 23 en el mercado del pueblo. ¿Cuántas me quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "es la hora de cenar en la casa. Tenía 46 botellas de leche",
          "cantidad": 46,
          "emoji": "1f37c",
          "objeto": "botellas de leche",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas me quedan?"
        }
      },
      "imagePath": "help-images/GRANJA/problem_18.svg"
    }
  ],
  "DISFRACES": [
    {
      "id": 1,
      "enunciado": "En el salón hay 5 niños vestidos de superhéroe y llegan 4 niñas vestidas de pirata. ¿Cuántos niños hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el salón hay 5 niños vestidos de superhéroe",
          "cantidad": 5,
          "emoji": "1f466",
          "objeto": "niños vestidos de superhéroe"
        },
        "cambio": {
          "texto": "llegan 4 niñas vestidas de pirata.",
          "cantidad": 4,
          "emoji": "1f467",
          "objeto": "niñas vestidas de pirata",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos niños hay?"
        }
      },
      "imagePath": "help-images/DISFRACES/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Tenemos 6 botes de pintura roja y el organizador trae 3 botes de pintura azul. ¿Cuántos botes hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 6 botes de pintura roja",
          "cantidad": 6,
          "emoji": "1f36f",
          "objeto": "botes de pintura"
        },
        "cambio": {
          "texto": "el organizador trae 3 botes de pintura azul.",
          "cantidad": 3,
          "emoji": "1f36f",
          "objeto": "botes de pintura",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos botes hay?"
        }
      },
      "imagePath": "help-images/DISFRACES/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "Un disfraz tiene 4 estrellas brillantes en la capa y 4 estrellas en el sombrero. ¿Cuántas disfraz tiene?",
      "ayuda": {
        "inicio": {
          "texto": "Un disfraz tiene 4 estrellas brillantes en la capa",
          "cantidad": 4,
          "emoji": "2b50",
          "objeto": "estrellas"
        },
        "cambio": {
          "texto": "4 estrellas en el sombrero.",
          "cantidad": 4,
          "emoji": "2b50",
          "objeto": "estrellas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas disfraz tiene?"
        }
      },
      "imagePath": "help-images/DISFRACES/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Había 10 máscaras de tigre y los invitados han cogido 4. ¿Cuántas máscaras quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 10 máscaras de tigre",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "máscaras de tigre"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas máscaras quedan?"
        }
      },
      "imagePath": "help-images/DISFRACES/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Tenía 9 varitas mágicas y se han roto 5 durante el baile. ¿Cuántas quedan bien?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 9 varitas mágicas",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "varitas mágicas"
        },
        "cambio": {
          "texto": "se han roto 5 durante el baile.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "durante el baile",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan bien?"
        }
      },
      "imagePath": "help-images/DISFRACES/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "En la caja hay 8 pelucas de colores y 5 invitados ya se han puesto una. ¿Cuántas colors quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En la caja hay 8 pelucas de colores",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "pelucas de colores"
        },
        "cambio": {
          "texto": "5 invitados ya se han puesto una.",
          "cantidad": 5,
          "emoji": "1f466",
          "objeto": "invitados",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas colors quedan?"
        }
      },
      "imagePath": "help-images/DISFRACES/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Hay 12 bolsas de confeti dorado y el repartidor trae 6 bolsas de confeti plateado. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 bolsas de confeti dorado",
          "cantidad": 12,
          "emoji": "2b50",
          "objeto": "bolsas de confeti dorado"
        },
        "cambio": {
          "texto": "el repartidor trae 6 bolsas de confeti plateado.",
          "cantidad": 6,
          "emoji": "2b50",
          "objeto": "bolsas de confeti plateado",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/DISFRACES/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Un grupo tiene 11 invitados con antifaz y 8 invitados con sombrero de copa. ¿Cuántos invitados hay?",
      "ayuda": {
        "inicio": {
          "texto": "Un grupo tiene 11 invitados con antifaz",
          "cantidad": 11,
          "emoji": "1f466",
          "objeto": "invitados con antifaz"
        },
        "cambio": {
          "texto": "8 invitados con sombrero de copa.",
          "cantidad": 8,
          "emoji": "1f466",
          "objeto": "invitados con sombrero de copa",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos invitados hay?"
        }
      },
      "imagePath": "help-images/DISFRACES/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En el perchero hay 10 capas de vampiro y cuelgan 7 capas de mago. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el perchero hay 10 capas de vampiro",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "capas de vampiro"
        },
        "cambio": {
          "texto": "cuelgan 7 capas de mago.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "capas de mago",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/DISFRACES/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Teníamos 16 diademas de flores y las bailarinas usan 5. ¿Cuántas quedan en la caja?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 diademas de flores",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "diademas de flores"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan en la caja?"
        }
      },
      "imagePath": "help-images/DISFRACES/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Había 15 globos de helio y 4 han subido al techo y no se alcanzan. ¿Cuántos quedan abajo?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 globos de helio",
          "cantidad": 15,
          "emoji": "1f388",
          "objeto": "globos de helio"
        },
        "cambio": {
          "texto": "4 han subido al techo",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "han subido",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan abajo?"
        }
      },
      "imagePath": "help-images/DISFRACES/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En la lista había 19 disfraces por premiar y 7 ya han recibido su medalla. ¿Cuántos faltan?",
      "ayuda": {
        "inicio": {
          "texto": "En la lista había 19 disfraces por premiar",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "disfraces por premiar"
        },
        "cambio": {
          "texto": "7 ya han recibido su medalla.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "ya han recibido su medalla",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos faltan?"
        }
      },
      "imagePath": "help-images/DISFRACES/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "El aire huele a chocolate caliente y se oyen muchas risas. Tenemos 22 capas de terciopelo azul y llegan 14 capas rojas muy brillantes. ¿Cuántas chocolate hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "se oyen muchas risas. Tenemos 22 capas de terciopelo azul",
          "cantidad": 22,
          "emoji": "2753",
          "objeto": "capas de terciopelo",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas chocolate hay?"
        }
      },
      "imagePath": "help-images/DISFRACES/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "Las luces de colores parpadean y el suelo está lleno de serpentinas. Hay 31 antifaces de plumas y traemos 16 antifaces de cuero. ¿Cuántos colors hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el suelo está lleno de serpentinas. Hay 31 antifaces de plumas",
          "cantidad": 31,
          "emoji": "2753",
          "objeto": "antifaces de plumas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos colors hay?"
        }
      },
      "imagePath": "help-images/DISFRACES/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Se oye música de carnaval y el público aplaude muy fuerte. Hay 25 paquetes de gominolas y compramos 23 paquetes de caramelos. ¿Cuántos caramelos hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el público aplaude muy fuerte. Hay 25 paquetes de gominolas",
          "cantidad": 25,
          "emoji": "2753",
          "objeto": "paquetes de gominolas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos caramelos hay?"
        }
      },
      "imagePath": "help-images/DISFRACES/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "El vapor de la máquina de humo forma nubes y los disfraces brillan. Teníamos 48 coronas de rey y hemos repartido 15 a los caballeros. ¿Cuántas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "los disfraces brillan. Teníamos 48 coronas de rey",
          "cantidad": 48,
          "emoji": "2753",
          "objeto": "coronas de rey",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas sobran?"
        }
      },
      "imagePath": "help-images/DISFRACES/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "Los pájaros cantan fuera y el sol entra por los cristales del salón. Había 37 sillas con fundas de colores y hemos quitado 15 que estaban manchadas. ¿Cuántas pájaros quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el sol entra por los cristales del salón. Había 37 sillas con fundas de colores",
          "cantidad": 37,
          "emoji": "2753",
          "objeto": "sillas con fundas de colores",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas pájaros quedan?"
        }
      },
      "imagePath": "help-images/DISFRACES/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "El reloj de la torre suena y la gente baila deprisa. Tenía 46 broches de plata y hemos regalado 23 a los mejores bailarines. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "la gente baila deprisa. Tenía 46 broches de plata",
          "cantidad": 46,
          "emoji": "2753",
          "objeto": "broches de plata",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/DISFRACES/problem_18.svg"
    }
  ],
  "UN RESTAURANTE": [
    {
      "id": 1,
      "enunciado": "En una mesa hay 5 pizzas de queso y el camarero trae 4 pizzas de jamón. ¿Cuántas pizzas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En una mesa hay 5 pizzas de queso",
          "cantidad": 5,
          "emoji": "1f9c0",
          "objeto": "pizzas de queso"
        },
        "cambio": {
          "texto": "el camarero trae 4 pizzas de jamón.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "pizzas de jamón",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas pizzas hay?"
        }
      },
      "imagePath": "help-images/UN RESTAURANTE/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Tenemos 6 vasos de zumo en la barra y preparamos 3 vasos más. ¿Cuántos vasos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 6 vasos de zumo en la barra",
          "cantidad": 6,
          "emoji": "1f964",
          "objeto": "vasos de zumo"
        },
        "cambio": {
          "texto": "preparamos 3 vasos más.",
          "cantidad": 3,
          "emoji": "1f964",
          "objeto": "vasos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos vasos hay?"
        }
      },
      "imagePath": "help-images/UN RESTAURANTE/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "En la cocina hay 4 cocineros con gorro y 4 ayudantes sin gorro. ¿Cuántos trabajadores hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la cocina hay 4 cocineros con gorro",
          "cantidad": 4,
          "emoji": "1f389",
          "objeto": "cocineros con gorro"
        },
        "cambio": {
          "texto": "4 ayudantes sin gorro.",
          "cantidad": 4,
          "emoji": "1f389",
          "objeto": "ayudantes sin gorro",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos trabajadores hay?"
        }
      },
      "imagePath": "help-images/UN RESTAURANTE/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Había 10 copas de helado y los niños se han comido 4. ¿Cuántas niños quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 10 copas de helado",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "copas de helado"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas niños quedan?"
        }
      },
      "imagePath": "help-images/UN RESTAURANTE/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Tenía 9 servilletas de papel y he usado 5 para limpiar una mancha. ¿Cuántas me quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 9 servilletas de papel",
          "cantidad": 9,
          "emoji": "1f9fb",
          "objeto": "servilletas de papel"
        },
        "cambio": {
          "texto": "he usado 5 para limpiar una mancha.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "para limpiar una mancha",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas me quedan?"
        }
      },
      "imagePath": "help-images/UN RESTAURANTE/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "En el comedor hay 8 sillas ocupadas y 5 personas ya se han ido. ¿Cuántas sillas quedan ocupadas?",
      "ayuda": {
        "inicio": {
          "texto": "En el comedor hay 8 sillas ocupadas",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "sillas ocupadas"
        },
        "cambio": {
          "texto": "5 personas ya se han ido.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "personas",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas sillas quedan ocupadas?"
        }
      },
      "imagePath": "help-images/UN RESTAURANTE/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Hay 12 tenedores en el cajón y el lavavajillas saca 6 tenedores más. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 tenedores en el cajón",
          "cantidad": 12,
          "emoji": "1f374",
          "objeto": "tenedores"
        },
        "cambio": {
          "texto": "el lavavajillas saca 6 tenedores más.",
          "cantidad": 6,
          "emoji": "1f374",
          "objeto": "tenedores",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/UN RESTAURANTE/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "En la despensa hay 11 botes de tomate y 8 botes de mayonesa. ¿Cuántos botes hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la despensa hay 11 botes de tomate",
          "cantidad": 11,
          "emoji": "1f345",
          "objeto": "botes de tomate"
        },
        "cambio": {
          "texto": "8 botes de mayonesa.",
          "cantidad": 8,
          "emoji": "1f36f",
          "objeto": "botes de mayonesa",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos botes hay?"
        }
      },
      "imagePath": "help-images/UN RESTAURANTE/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En la terraza hay 10 mesas redondas y traen 7 mesas cuadradas nuevas. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la terraza hay 10 mesas redondas",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "mesas redondas"
        },
        "cambio": {
          "texto": "traen 7 mesas cuadradas nuevas.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "mesas cuadradas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/UN RESTAURANTE/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Teníamos 16 menús infantiles y hemos servido 5. ¿Cuántos menús quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 menús infantiles",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "menús infantiles"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos menús quedan?"
        }
      },
      "imagePath": "help-images/UN RESTAURANTE/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Había 15 platos limpios en la pila y se han roto 4 al caerse. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 platos limpios en la pila",
          "cantidad": 15,
          "emoji": "1f37d",
          "objeto": "platos"
        },
        "cambio": {
          "texto": "se han roto 4 al caerse.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "al caerse",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/UN RESTAURANTE/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En el perchero había 19 abrigos y 7 clientes se han marchado con el suyo. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En el perchero había 19 abrigos",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "abrigos"
        },
        "cambio": {
          "texto": "7 clientes se han marchado con el suyo.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "clientes se han marchado con el suyo",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/UN RESTAURANTE/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "El aire huele a pan tostado y se oye el tintineo de las copas. Tenemos 22 manteles blancos y llegan 14 manteles de cuadros. ¿Cuántos manteles hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "se oye el tintineo de las copas. Tenemos 22 manteles blancos",
          "cantidad": 22,
          "emoji": "2753",
          "objeto": "manteles",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos manteles hay?"
        }
      },
      "imagePath": "help-images/UN RESTAURANTE/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "La máquina de café hace mucho ruido y hay mucha luz en la ventana. Hay 31 tazas de café y la camarera trae 16 tazas de té. ¿Cuántas tazas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "hay mucha luz en la ventana. Hay 31 tazas de café",
          "cantidad": 31,
          "emoji": "2753",
          "objeto": "tazas de café",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas tazas hay?"
        }
      },
      "imagePath": "help-images/UN RESTAURANTE/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Los clientes ríen y se oye música de piano suave. Hay 25 postres de tarta y compramos 23 postres de flan. ¿Cuántos postres hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "se oye música de piano suave. Hay 25 postres de tarta",
          "cantidad": 25,
          "emoji": "1f370",
          "objeto": "postres de tarta",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos postres hay?"
        }
      },
      "imagePath": "help-images/UN RESTAURANTE/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "El suelo brilla porque está recién fregado y huele a limón. Teníamos 48 pajitas de colores y hemos usado 15 para los refrescos. ¿Cuántas colors quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "huele a limón. Teníamos 48 pajitas de colores",
          "cantidad": 48,
          "emoji": "1f964",
          "objeto": "pajitas de colores",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas colors quedan?"
        }
      },
      "imagePath": "help-images/UN RESTAURANTE/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "Se oye el motor de la nevera y la cocina está muy caliente. Había 37 bandejas de metal y hemos llevado 15 a la mesa de banquetes. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "la cocina está muy caliente. Había 37 bandejas de metal",
          "cantidad": 37,
          "emoji": "2753",
          "objeto": "bandejas de metal",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/UN RESTAURANTE/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "El reloj de la cocina marca la hora del cierre y las luces se apagan. Tenía 46 cartas del menú y he guardado 23 en el cajón. ¿Cuántas quedan sobre las mesas?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "las luces se apagan. Tenía 46 cartas del menú",
          "cantidad": 46,
          "emoji": "2753",
          "objeto": "cartas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan sobre las mesas?"
        }
      },
      "imagePath": "help-images/UN RESTAURANTE/problem_18.svg"
    }
  ],
  "CIRCO": [
    {
      "id": 1,
      "enunciado": "En la pista hay 5 payasos haciendo reír y entran 4 payasos más. ¿Cuántos payasos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la pista hay 5 payasos haciendo reír",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "payasos haciendo reír"
        },
        "cambio": {
          "texto": "entran 4 payasos más.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "payasos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos payasos hay?"
        }
      },
      "imagePath": "help-images/CIRCO/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Un malabarista lanza 6 aros al aire y su ayudante le lanza 3 más. ¿Cuántos aros hay?",
      "ayuda": {
        "inicio": {
          "texto": "Un malabarista lanza 6 aros al aire",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "aros"
        },
        "cambio": {
          "texto": "su ayudante le lanza 3 más.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "más",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos aros hay?"
        }
      },
      "imagePath": "help-images/CIRCO/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "Hay 4 elefantes con mantas azules y 4 elefantes con mantas rojas. ¿Cuántos elefantes hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 4 elefantes con mantas azules",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "elefantes con mantas"
        },
        "cambio": {
          "texto": "4 elefantes con mantas rojas.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "elefantes con mantas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos elefantes hay?"
        }
      },
      "imagePath": "help-images/CIRCO/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "El mago tenía 10 conejos en el sombrero y ha hecho desaparecer 4. ¿Cuántos quedan dentro?",
      "ayuda": {
        "inicio": {
          "texto": "El mago tenía 10 conejos en el sombrero",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "conejos"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan dentro?"
        }
      },
      "imagePath": "help-images/CIRCO/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Tenía 9 nubes de algodón dulce y he vendido 5 a los niños. ¿Cuántas me quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 9 nubes de algodón dulce",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "nubes de"
        },
        "cambio": {
          "texto": "he vendido 5 a los niños.",
          "cantidad": 5,
          "emoji": "1f466",
          "objeto": "a los niños",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas me quedan?"
        }
      },
      "imagePath": "help-images/CIRCO/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "En la cuerda floja había 8 equilibristas y 5 han bajado al suelo. ¿Cuántos quedan arriba?",
      "ayuda": {
        "inicio": {
          "texto": "En la cuerda floja había 8 equilibristas",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "equilibristas"
        },
        "cambio": {
          "texto": "5 han bajado al suelo.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "han bajado",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan arriba?"
        }
      },
      "imagePath": "help-images/CIRCO/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Hay 12 monociclos aparcados y traen 6 monociclos nuevos para el desfile. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 monociclos aparcados",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "monociclos aparcados"
        },
        "cambio": {
          "texto": "traen 6 monociclos nuevos para el desfile.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "monociclos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/CIRCO/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Un grupo de acróbatas tiene 11 personas abajo y 8 personas subidas encima. ¿Cuántos son?",
      "ayuda": {
        "inicio": {
          "texto": "Un grupo de acróbatas tiene 11 personas abajo",
          "cantidad": 11,
          "emoji": "1f9c4",
          "objeto": "personas abajo"
        },
        "cambio": {
          "texto": "8 personas subidas encima.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "personas subidas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos son?"
        }
      },
      "imagePath": "help-images/CIRCO/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En el baúl hay 10 varitas mágicas y el mago encuentra 7 más. ¿Cuántas varitas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el baúl hay 10 varitas mágicas",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "varitas mágicas"
        },
        "cambio": {
          "texto": "el mago encuentra 7 más.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "más",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas varitas hay?"
        }
      },
      "imagePath": "help-images/CIRCO/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Teníamos 16 tartas de crema para lanzarlas y los payasos han tirado 5. ¿Cuántas tartas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 tartas de crema para lanzarlas",
          "cantidad": 16,
          "emoji": "1f370",
          "objeto": "tartas de crema"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas tartas quedan?"
        }
      },
      "imagePath": "help-images/CIRCO/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Había 15 focas jugando con pelotas y 4 se han ido a dormir a la piscina. ¿Cuántas siguen jugando?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 focas jugando con pelotas",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "focas jugando con pelotas"
        },
        "cambio": {
          "texto": "4 se han ido a dormir a la piscina.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "se han ido a dormir a la piscina",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas siguen jugando?"
        }
      },
      "imagePath": "help-images/CIRCO/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "El forzudo levantaba 19 pesas gigantes y ha dejado 7 en el suelo. ¿Cuántas levanta ahora?",
      "ayuda": {
        "inicio": {
          "texto": "El forzudo levantaba 19 pesas gigantes",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "pesas gigantes"
        },
        "cambio": {
          "texto": "ha dejado 7 en el suelo.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "en el suelo",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas levanta ahora?"
        }
      },
      "imagePath": "help-images/CIRCO/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "Los focos brillan mucho y la música de la banda suena fuerte. Hay 22 bailarinas con plumas y entran 14 bailarines con zancos. ¿Cuántos artistas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "la música de la banda suena fuerte. Hay 22 bailarinas con plumas",
          "cantidad": 22,
          "emoji": "2753",
          "objeto": "bailarinas con plumas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos artistas hay?"
        }
      },
      "imagePath": "help-images/CIRCO/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "El olor a palomitas recién hechas llena la carpa. Hay 31 bolsas de palomitas saladas y preparamos 16 bolsas de palomitas dulces. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "El olor a palomitas recién hechas llena la carpa. Hay 31 bolsas de palomitas saladas",
          "cantidad": 31,
          "emoji": "1f381",
          "objeto": "bolsas de palomitas saladas"
        },
        "cambio": {
          "texto": "preparamos 16 bolsas de palomitas dulces.",
          "cantidad": 16,
          "emoji": "1f381",
          "objeto": "bolsas de palomitas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/CIRCO/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "El público aplaude y grita \"¡Bravo!\" muy emocionado. Hay 25 globos rojos gigantes y el vendedor infla 23 globos azules. ¿Cuántos globos hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "grita \"¡Bravo!\" muy emocionado. Hay 25 globos rojos gigantes",
          "cantidad": 25,
          "emoji": "1f388",
          "objeto": "globos gigantes",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos globos hay?"
        }
      },
      "imagePath": "help-images/CIRCO/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "Las alturas marean un poco y los trapecistas vuelan rápido. Teníamos 48 redes de seguridad y hemos colocado 15 debajo de los trapecios. ¿Cuántas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "los trapecistas vuelan rápido. Teníamos 48 redes de seguridad",
          "cantidad": 48,
          "emoji": "2753",
          "objeto": "redes de seguridad",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas sobran?"
        }
      },
      "imagePath": "help-images/CIRCO/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "Los trajes de lentejuelas brillan bajo las luces de colores. Había 37 narices de payaso rojas y hemos repartido 15 a los niños del público. ¿Cuántas colors quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Los trajes de lentejuelas brillan bajo las luces de colores. Había 37 narices de payaso rojas",
          "cantidad": 37,
          "emoji": "2753",
          "objeto": "narices de payaso"
        },
        "cambio": {
          "texto": "hemos repartido 15 a los niños del público.",
          "cantidad": 15,
          "emoji": "1f466",
          "objeto": "a los niños",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas colors quedan?"
        }
      },
      "imagePath": "help-images/CIRCO/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "El redoble de tambor anuncia el final y todos se ponen de pie. Tenía 46 entradas para la función y he vendido 23 en la taquilla. ¿Cuántas me quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "todos se ponen de pie. Tenía 46 entradas para la función",
          "cantidad": 46,
          "emoji": "2753",
          "objeto": "entradas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas me quedan?"
        }
      },
      "imagePath": "help-images/CIRCO/problem_18.svg"
    }
  ],
  "ABUELOS": [
    {
      "id": 1,
      "enunciado": "El abuelo lleva 5 fotos en la cámara y la abuela hace 4 fotos más del paisaje. ¿Cuántas fotos hay?",
      "ayuda": {
        "inicio": {
          "texto": "El abuelo lleva 5 fotos en la cámara",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "fotos"
        },
        "cambio": {
          "texto": "la abuela hace 4 fotos más del paisaje.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "fotos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas fotos hay?"
        }
      },
      "imagePath": "help-images/ABUELOS/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Tenemos 6 gorras en el maletero y compramos 3 gorras nuevas en la gasolinera. ¿Cuántas gorras hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 6 gorras en el maletero",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "gorras"
        },
        "cambio": {
          "texto": "compramos 3 gorras nuevas en la gasolinera.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "gorras",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas gorras hay?"
        }
      },
      "imagePath": "help-images/ABUELOS/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "En el asiento de atrás hay 4 peluches míos y 4 peluches de mi hermana. ¿Cuántos peluches hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el asiento de atrás hay 4 peluches míos",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "peluches míos"
        },
        "cambio": {
          "texto": "4 peluches de mi hermana.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "peluches de mi hermana",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos peluches hay?"
        }
      },
      "imagePath": "help-images/ABUELOS/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "La abuela traía 10 caramelos de menta y nos hemos comido 4. ¿Cuántos caramelos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "La abuela traía 10 caramelos de menta",
          "cantidad": 10,
          "emoji": "1f36c",
          "objeto": "caramelos de menta"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos caramelos quedan?"
        }
      },
      "imagePath": "help-images/ABUELOS/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Tenía 9 monedas para el peaje y he pagado 5 al cajero. ¿Cuántas monedas me quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 9 monedas para el peaje",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "monedas"
        },
        "cambio": {
          "texto": "he pagado 5 al cajero.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "al cajero",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas monedas me quedan?"
        }
      },
      "imagePath": "help-images/ABUELOS/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "Por la ventana veo 8 vacas pastando y 5 se esconden detrás de un árbol. ¿Cuántas veo ahora?",
      "ayuda": {
        "inicio": {
          "texto": "Por la ventana veo 8 vacas pastando",
          "cantidad": 8,
          "emoji": "1f404",
          "objeto": "vacas pastando"
        },
        "cambio": {
          "texto": "5 se esconden detrás de un árbol.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "se esconden detrás de un árbol",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas veo ahora?"
        }
      },
      "imagePath": "help-images/ABUELOS/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "En la maleta hay 12 camisetas dobladas y la abuela mete 6 camisetas más. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la maleta hay 12 camisetas dobladas",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "camisetas dobladas"
        },
        "cambio": {
          "texto": "la abuela mete 6 camisetas más.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "camisetas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/ABUELOS/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Hemos visto 11 señales de tráfico azules y 8 señales blancas. ¿Cuántas señales hemos visto?",
      "ayuda": {
        "inicio": {
          "texto": "Hemos visto 11 señales de tráfico azules",
          "cantidad": 11,
          "emoji": "2753",
          "objeto": "señales de tráfico"
        },
        "cambio": {
          "texto": "8 señales blancas.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "señales",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas señales hemos visto?"
        }
      },
      "imagePath": "help-images/ABUELOS/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "Mi abuelo tiene 10 postales de la montaña y yo tengo 7 postales del mar. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Mi abuelo tiene 10 postales de la montaña",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "postales"
        },
        "cambio": {
          "texto": "yo tengo 7 postales del mar.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "postales",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/ABUELOS/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Teníamos 16 sándwiches en la nevera portátil y nos hemos comido 5. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 sándwiches en la nevera portátil",
          "cantidad": 16,
          "emoji": "1f96a",
          "objeto": "sándwiches"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/ABUELOS/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Había 15 perchas en el armario del hotel y hemos usado 4. ¿Cuántas quedan libres?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 perchas en el armario del hotel",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "perchas"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan libres?"
        }
      },
      "imagePath": "help-images/ABUELOS/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En el mapa hay 19 paradas marcadas y ya hemos hecho 7 paradas. ¿Cuántas faltan?",
      "ayuda": {
        "inicio": {
          "texto": "En el mapa hay 19 paradas marcadas",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "paradas marcadas"
        },
        "cambio": {
          "texto": "ya hemos hecho 7 paradas.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "paradas",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas faltan?"
        }
      },
      "imagePath": "help-images/ABUELOS/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "El motor del coche suena constante y huele a gasolina. Hay 22 maletas en el autobús del hotel y llegan 14 maletas más del grupo de abuelos. ¿Cuántas coche hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "huele a gasolina. Hay 22 maletas en el autobús del hotel",
          "cantidad": 22,
          "emoji": "2753",
          "objeto": "maletas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas coche hay?"
        }
      },
      "imagePath": "help-images/ABUELOS/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "El aire acondicionado está frío y la radio toca una canción antigua. Hay 31 conchas recogidas en la orilla y el abuelo trae 16 conchas más en el bolsillo. ¿Cuántas conchas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "la radio toca una canción antigua. Hay 31 conchas recogidas en la orilla",
          "cantidad": 31,
          "emoji": "2753",
          "objeto": "conchas recogidas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas conchas hay?"
        }
      },
      "imagePath": "help-images/ABUELOS/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Los pájaros cantan fuera y el abuelo conduce despacio. Hay 25 pins en mi mochila y la abuela me regala 23 pins de ciudades nuevas. ¿Cuántos tengo ahora?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el abuelo conduce despacio. Hay 25 pins en mi mochila",
          "cantidad": 25,
          "emoji": "2753",
          "objeto": "pins",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos tengo ahora?"
        }
      },
      "imagePath": "help-images/ABUELOS/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "Las luces de la ciudad brillan y se oye el viento en la ventana. Teníamos 48 galletas para el camino y nos hemos comido 15 merendando. ¿Cuántas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "se oye el viento en la ventana. Teníamos 48 galletas para el camino",
          "cantidad": 48,
          "emoji": "1f36a",
          "objeto": "galletas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas sobran?"
        }
      },
      "imagePath": "help-images/ABUELOS/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "El sol se pone y el cielo está naranja. Había 37 folletos de museos y hemos tirado 15 porque ya los habíamos visitado. ¿Cuántas naranja quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "el cielo está naranja. Había 37 folletos de museos",
          "cantidad": 37,
          "emoji": "2753",
          "objeto": "folletos de museos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas naranja quedan?"
        }
      },
      "imagePath": "help-images/ABUELOS/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "El reloj del coche marca la hora de dormir y los abuelos están cansados. Tenía 46 pegatinas de mi viaje y he pegado 23 en mi diario. ¿Cuántas quedan en la hoja?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "los abuelos están cansados. Tenía 46 pegatinas de mi viaje",
          "cantidad": 46,
          "emoji": "2b50",
          "objeto": "pegatinas de mi viaje",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan en la hoja?"
        }
      },
      "imagePath": "help-images/ABUELOS/problem_18.svg"
    }
  ],
  "CASTILLO": [
    {
      "id": 1,
      "enunciado": "En la torre alta ondean 4 banderas azules y ponemos 3 banderas rojas. ¿Cuántas banderas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la torre alta ondean 4 banderas azules",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "banderas"
        },
        "cambio": {
          "texto": "ponemos 3 banderas rojas.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "banderas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas banderas hay?"
        }
      },
      "imagePath": "help-images/CASTILLO/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "El bufón tiene 5 pelotas verdes y encuentra 4 pelotas amarillas. ¿Cuántas pelotas tiene?",
      "ayuda": {
        "inicio": {
          "texto": "El bufón tiene 5 pelotas verdes",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "pelotas"
        },
        "cambio": {
          "texto": "encuentra 4 pelotas amarillas.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "pelotas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas pelotas tiene?"
        }
      },
      "imagePath": "help-images/CASTILLO/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "En el foso hay 2 ranas saltando y llegan 6 ranas más. ¿Cuántas ranas hay en total?",
      "ayuda": {
        "inicio": {
          "texto": "En el foso hay 2 ranas saltando",
          "cantidad": 2,
          "emoji": "2753",
          "objeto": "ranas saltando"
        },
        "cambio": {
          "texto": "llegan 6 ranas más.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "ranas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas ranas hay en total?"
        }
      },
      "imagePath": "help-images/CASTILLO/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "El cofre del tesoro tenía 10 monedas de oro y sacamos 3 monedas. ¿Cuántas quedan dentro?",
      "ayuda": {
        "inicio": {
          "texto": "El cofre del tesoro tenía 10 monedas de oro",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "monedas de oro"
        },
        "cambio": {
          "texto": "sacamos 3 monedas.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "monedas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan dentro?"
        }
      },
      "imagePath": "help-images/CASTILLO/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Hay 8 velas encendidas en el pasillo y el viento apaga 2 velas. ¿Cuántas siguen encendidas?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 8 velas encendidas en el pasillo",
          "cantidad": 8,
          "emoji": "1f56f",
          "objeto": "velas"
        },
        "cambio": {
          "texto": "el viento apaga 2 velas.",
          "cantidad": 2,
          "emoji": "1f56f",
          "objeto": "velas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas siguen encendidas?"
        }
      },
      "imagePath": "help-images/CASTILLO/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "En la mesa real hay 9 manzanas rojas y el caballo se come 4. ¿Cuántas manzanas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "En la mesa real hay 9 manzanas rojas",
          "cantidad": 9,
          "emoji": "1f34e",
          "objeto": "manzanas"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas manzanas sobran?"
        }
      },
      "imagePath": "help-images/CASTILLO/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "El cocinero tiene 12 pasteles de nata y hornea 6 pasteles de chocolate más. ¿Cuántos pasteles hay?",
      "ayuda": {
        "inicio": {
          "texto": "El cocinero tiene 12 pasteles de nata",
          "cantidad": 12,
          "emoji": "1f382",
          "objeto": "pasteles de nata"
        },
        "cambio": {
          "texto": "hornea 6 pasteles de chocolate más.",
          "cantidad": 6,
          "emoji": "1f382",
          "objeto": "pasteles de chocolate",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos pasteles hay?"
        }
      },
      "imagePath": "help-images/CASTILLO/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "En la biblioteca hay 11 libros antiguos y el mago trae 8 libros mágicos. ¿Cuántos libros hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la biblioteca hay 11 libros antiguos",
          "cantidad": 11,
          "emoji": "2753",
          "objeto": "libros antiguos"
        },
        "cambio": {
          "texto": "el mago trae 8 libros mágicos.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "libros mágicos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos libros hay?"
        }
      },
      "imagePath": "help-images/CASTILLO/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "Hay 13 escudos colgados en la pared y colgamos 5 escudos nuevos. ¿Cuántos escudos vemos?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 13 escudos colgados en la pared",
          "cantidad": 13,
          "emoji": "2753",
          "objeto": "escudos colgados"
        },
        "cambio": {
          "texto": "colgamos 5 escudos nuevos.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "escudos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos escudos vemos?"
        }
      },
      "imagePath": "help-images/CASTILLO/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "La princesa tenía 18 flores en su ramo pero regaló 5 flores a su amiga. ¿Cuántas flores le quedan?",
      "ayuda": {
        "inicio": {
          "texto": "La princesa tenía 18 flores en su ramo",
          "cantidad": 18,
          "emoji": "2753",
          "objeto": "flores"
        },
        "cambio": {
          "texto": "regaló 5 flores a su amiga.",
          "cantidad": 5,
          "emoji": "1f467",
          "objeto": "flores a su amiga",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas flores le quedan?"
        }
      },
      "imagePath": "help-images/CASTILLO/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "En la cuadra había 16 caballos durmiendo y 4 salen a pasear. ¿Cuántos caballos quedan dentro?",
      "ayuda": {
        "inicio": {
          "texto": "En la cuadra había 16 caballos durmiendo",
          "cantidad": 16,
          "emoji": "1f40e",
          "objeto": "caballos durmiendo"
        },
        "cambio": {
          "texto": "4 salen a pasear.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "salen a pasear",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos caballos quedan dentro?"
        }
      },
      "imagePath": "help-images/CASTILLO/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "El rey tenía 19 llaves en su llavero y se le perdieron 7 llaves en el jardín. ¿Cuántas llaves tiene?",
      "ayuda": {
        "inicio": {
          "texto": "El rey tenía 19 llaves en su llavero",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "llaves"
        },
        "cambio": {
          "texto": "se le perdieron 7 llaves en el jardín.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "llaves",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas llaves tiene?"
        }
      },
      "imagePath": "help-images/CASTILLO/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "Los constructores levantan un muro fuerte y alto para el castillo. Ya pusieron 24 piedras grises y ahora traen 15 piedras blancas más. ¿Cuántas piedras hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "alto para el castillo. Ya pusieron 24 piedras grises",
          "cantidad": 24,
          "emoji": "2753",
          "objeto": "piedras grises",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas piedras hay?"
        }
      },
      "imagePath": "help-images/CASTILLO/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "La reina cuida su jardín lleno de colores y aromas dulces. Hay 32 rosas rojas preciosas y el jardinero planta 14 tulipanes amarillos. ¿Cuántas flores hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "aromas dulces. Hay 32 rosas rojas preciosas",
          "cantidad": 32,
          "emoji": "2753",
          "objeto": "rosas preciosas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas flores hay?"
        }
      },
      "imagePath": "help-images/CASTILLO/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "En la cocina real huele a pan recién hecho y calentito. El panadero tiene 21 barras listas y mete 28 barras más al horno. ¿Cuántas barras cocinó?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "calentito. El panadero tiene 21 barras listas",
          "cantidad": 21,
          "emoji": "2753",
          "objeto": "barras listas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas barras cocinó?"
        }
      },
      "imagePath": "help-images/CASTILLO/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "El dragón del castillo es muy amable y brilla mucho al sol. Tenía 45 escamas doradas pero se le cayeron 12 escamas viejas. ¿Cuántas le quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "brilla mucho al sol. Tenía 45 escamas doradas",
          "cantidad": 45,
          "emoji": "2753",
          "objeto": "escamas doradas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas le quedan?"
        }
      },
      "imagePath": "help-images/CASTILLO/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "Hoy es el día de limpieza general en las torres altas. El castillo tiene 36 ventanas sucias y los sirvientes ya limpiaron 13 ventanas. ¿Cuántas faltan?",
      "ayuda": {
        "inicio": {
          "texto": "Hoy es el día de limpieza general en las torres altas. El castillo tiene 36 ventanas sucias",
          "cantidad": 36,
          "emoji": "2753",
          "objeto": "ventanas sucias"
        },
        "cambio": {
          "texto": "los sirvientes ya limpiaron 13 ventanas.",
          "cantidad": 13,
          "emoji": "2753",
          "objeto": "ventanas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas faltan?"
        }
      },
      "imagePath": "help-images/CASTILLO/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "La gran fiesta del rey fue muy divertida con música y baile. Había 48 invitados comiendo pastel y ya se han ido 24 invitados. ¿Cuántos invitados quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "baile. Había 48 invitados comiendo pastel",
          "cantidad": 48,
          "emoji": "1f382",
          "objeto": "invitados comiendo pastel",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos invitados quedan?"
        }
      },
      "imagePath": "help-images/CASTILLO/problem_18.svg"
    }
  ],
  "DOCTORES": [
    {
      "id": 1,
      "enunciado": "En la bandeja hay 4 jeringuillas y la enfermera trae 3 jeringuillas más. ¿Cuántas jeringuillas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la bandeja hay 4 jeringuillas",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "jeringuillas"
        },
        "cambio": {
          "texto": "la enfermera trae 3 jeringuillas más.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "jeringuillas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas jeringuillas hay?"
        }
      },
      "imagePath": "help-images/DOCTORES/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Tenemos 5 camillas vacías y llegan 2 camillas con pacientes nuevos. ¿Cuántas camillas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 5 camillas vacías",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "camillas"
        },
        "cambio": {
          "texto": "llegan 2 camillas con pacientes nuevos.",
          "cantidad": 2,
          "emoji": "2753",
          "objeto": "camillas con pacientes",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas camillas hay?"
        }
      },
      "imagePath": "help-images/DOCTORES/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "Un doctor tiene 6 tiritas de dibujos y encuentra 4 tiritas de colores. ¿Cuántas doctor tiene?",
      "ayuda": {
        "inicio": {
          "texto": "Un doctor tiene 6 tiritas de dibujos",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "tiritas de dibujos"
        },
        "cambio": {
          "texto": "encuentra 4 tiritas de colores.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "tiritas de colores",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas doctor tiene?"
        }
      },
      "imagePath": "help-images/DOCTORES/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Había 8 termómetros en la caja, pero 3 se han estropeado. ¿Cuántos funcionan bien?",
      "ayuda": {
        "inicio": {
          "texto": "Había 8 termómetros en la caja,",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "termómetros"
        },
        "cambio": {
          "texto": "3 se han estropeado.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "se han estropeado",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos funcionan bien?"
        }
      },
      "imagePath": "help-images/DOCTORES/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "En la sala hay 9 sillas y se llevan 4 para otra habitación. ¿Cuántas sillas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En la sala hay 9 sillas",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "sillas"
        },
        "cambio": {
          "texto": "se llevan 4 para otra habitación.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "para otra habitación",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas sillas quedan?"
        }
      },
      "imagePath": "help-images/DOCTORES/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "El pediatra tiene 7 globos para los niños y regala 5 globos. ¿Cuántos globos le quedan?",
      "ayuda": {
        "inicio": {
          "texto": "El pediatra tiene 7 globos para los niños",
          "cantidad": 7,
          "emoji": "1f388",
          "objeto": "globos"
        },
        "cambio": {
          "texto": "regala 5 globos.",
          "cantidad": 5,
          "emoji": "1f388",
          "objeto": "globos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos globos le quedan?"
        }
      },
      "imagePath": "help-images/DOCTORES/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "En la farmacia hay 12 botes de jarabe y reciben 6 botes nuevos. ¿Cuántos botes tienen?",
      "ayuda": {
        "inicio": {
          "texto": "En la farmacia hay 12 botes de jarabe",
          "cantidad": 12,
          "emoji": "1f36f",
          "objeto": "botes de jarabe"
        },
        "cambio": {
          "texto": "reciben 6 botes nuevos.",
          "cantidad": 6,
          "emoji": "1f36f",
          "objeto": "botes",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos botes tienen?"
        }
      },
      "imagePath": "help-images/DOCTORES/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Vemos 11 batas blancas colgadas y el camión trae 8 batas limpias. ¿Cuántas batas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Vemos 11 batas blancas colgadas",
          "cantidad": 11,
          "emoji": "2753",
          "objeto": "batas colgadas"
        },
        "cambio": {
          "texto": "el camión trae 8 batas limpias.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "batas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas batas hay?"
        }
      },
      "imagePath": "help-images/DOCTORES/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "Hay 13 estetoscopios en la mesa y sacan 5 más de un cajón. ¿Cuántos estetoscopios hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 13 estetoscopios en la mesa",
          "cantidad": 13,
          "emoji": "2753",
          "objeto": "estetoscopios"
        },
        "cambio": {
          "texto": "sacan 5 más de un cajón.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "de un cajón",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos estetoscopios hay?"
        }
      },
      "imagePath": "help-images/DOCTORES/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "El hospital tenía 16 ambulancias aparcadas y 5 salen a una urgencia. ¿Cuántas ambulancias quedan?",
      "ayuda": {
        "inicio": {
          "texto": "El hospital tenía 16 ambulancias aparcadas",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "ambulancias aparcadas"
        },
        "cambio": {
          "texto": "5 salen a una urgencia.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "salen a una urgencia",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas ambulancias quedan?"
        }
      },
      "imagePath": "help-images/DOCTORES/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Teníamos 15 mascarillas en el paquete y hemos usado 4 esta mañana. ¿Cuántas mascarillas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 15 mascarillas en el paquete",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "mascarillas"
        },
        "cambio": {
          "texto": "hemos usado 4 esta mañana.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "esta mañana",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas mascarillas sobran?"
        }
      },
      "imagePath": "help-images/DOCTORES/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "Un bote tiene 19 pastillas de vitaminas y nos tomamos 7 pastillas. ¿Cuántas quedan dentro?",
      "ayuda": {
        "inicio": {
          "texto": "Un bote tiene 19 pastillas de vitaminas",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "pastillas de vitaminas"
        },
        "cambio": {
          "texto": "nos tomamos 7 pastillas.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "pastillas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan dentro?"
        }
      },
      "imagePath": "help-images/DOCTORES/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "El hospital está muy limpio y las ventanas brillan mucho. El servicio de limpieza lavó 23 sábanas azules y hoy lavan 15 sábanas blancas. ¿Cuántas sábanas lavaron?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "las ventanas brillan mucho. El servicio de limpieza lavó 23 sábanas azules",
          "cantidad": 23,
          "emoji": "2753",
          "objeto": "sábanas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas sábanas lavaron?"
        }
      },
      "imagePath": "help-images/DOCTORES/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "En el jardín del hospital las flores huelen muy bien. El jardinero plantó 31 margaritas pequeñas y después puso 16 rosas rojas muy bonitas. ¿Cuántas flores hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el jardín del hospital las flores huelen muy bien. El jardinero plantó 31 margaritas pequeñas",
          "cantidad": 31,
          "emoji": "2753",
          "objeto": "margaritas"
        },
        "cambio": {
          "texto": "después puso 16 rosas rojas muy bonitas.",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "rosas bonitas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas flores hay?"
        }
      },
      "imagePath": "help-images/DOCTORES/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "La cafetería del hospital prepara desayunos ricos para todos. Han servido 25 zumos de naranja frescos y ahora sirven 24 vasos de leche caliente. ¿Cuántos desayunos hay?",
      "ayuda": {
        "inicio": {
          "texto": "La cafetería del hospital prepara desayunos ricos para todos. Han servido 25 zumos de naranja frescos",
          "cantidad": 25,
          "emoji": "1f9c3",
          "objeto": "zumos de"
        },
        "cambio": {
          "texto": "ahora sirven 24 vasos de leche caliente.",
          "cantidad": 24,
          "emoji": "1f95b",
          "objeto": "vasos de leche caliente",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos desayunos hay?"
        }
      },
      "imagePath": "help-images/DOCTORES/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "Las luces del pasillo son blancas y ayudan a ver todo. Teníamos 48 bombillas nuevas en la caja pero los electricistas usaron 14 bombillas. ¿Cuántas bombillas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "ayudan a ver todo. Teníamos 48 bombillas nuevas en la caja",
          "cantidad": 48,
          "emoji": "2753",
          "objeto": "bombillas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas bombillas sobran?"
        }
      },
      "imagePath": "help-images/DOCTORES/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "El aire del hospital es fresco porque las plantas dan oxígeno. Había 37 plantas verdes en el pasillo y han llevado 15 plantas a las habitaciones. ¿Cuántas plantas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "El aire del hospital es fresco porque las plantas dan oxígeno. Había 37 plantas verdes en el pasillo",
          "cantidad": 37,
          "emoji": "2753",
          "objeto": "plantas"
        },
        "cambio": {
          "texto": "han llevado 15 plantas a las habitaciones.",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "plantas a las habitaciones",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas plantas quedan?"
        }
      },
      "imagePath": "help-images/DOCTORES/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "Los médicos escriben muchas notas en sus carpetas de colores. Había 45 hojas de papel blanco y ya han escrito en 23 hojas. ¿Cuántas hojas quedan limpias?",
      "ayuda": {
        "inicio": {
          "texto": "Los médicos escriben muchas notas en sus carpetas de colores. Había 45 hojas de papel blanco",
          "cantidad": 45,
          "emoji": "2753",
          "objeto": "hojas de papel"
        },
        "cambio": {
          "texto": "ya han escrito en 23 hojas.",
          "cantidad": 23,
          "emoji": "2753",
          "objeto": "hojas",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas hojas quedan limpias?"
        }
      },
      "imagePath": "help-images/DOCTORES/problem_18.svg"
    }
  ],
  "PATIO": [
    {
      "id": 1,
      "enunciado": "En el arenero hay 5 cubos rojos y 4 cubos azules. ¿Cuántos cubos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En el arenero hay 5 cubos rojos",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "cubos"
        },
        "cambio": {
          "texto": "4 cubos azules.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "cubos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos cubos hay?"
        }
      },
      "imagePath": "help-images/PATIO/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Tenemos 6 pelotas de tenis y el profesor trae 3 pelotas más. ¿Cuántas pelotas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 6 pelotas de tenis",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "pelotas de tenis"
        },
        "cambio": {
          "texto": "el profesor trae 3 pelotas más.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "pelotas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas pelotas hay?"
        }
      },
      "imagePath": "help-images/PATIO/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "Vemos 4 niñas saltando y llegan 4 niños a saltar. ¿Cuántos saltan?",
      "ayuda": {
        "inicio": {
          "texto": "Vemos 4 niñas saltando",
          "cantidad": 4,
          "emoji": "1f467",
          "objeto": "niñas saltando"
        },
        "cambio": {
          "texto": "llegan 4 niños a saltar.",
          "cantidad": 4,
          "emoji": "1f466",
          "objeto": "niños a saltar",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos saltan?"
        }
      },
      "imagePath": "help-images/PATIO/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Había 10 cuerdas en el suelo, pero guardamos 4 en el cesto. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 10 cuerdas en el suelo,",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "cuerdas"
        },
        "cambio": {
          "texto": "guardamos 4 en el cesto.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "en el cesto",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/PATIO/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Tenía 7 tizas de colores y se han gastado 3 tizas. ¿Cuántas colors quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 7 tizas de colores",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "tizas de colores"
        },
        "cambio": {
          "texto": "se han gastado 3 tizas.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "tizas",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas colors quedan?"
        }
      },
      "imagePath": "help-images/PATIO/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "En el banco hay 8 mochilas y 5 niños cogen la suya. ¿Cuántas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "En el banco hay 8 mochilas",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "mochilas"
        },
        "cambio": {
          "texto": "5 niños cogen la suya.",
          "cantidad": 5,
          "emoji": "1f466",
          "objeto": "niños cogen la suya",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas sobran?"
        }
      },
      "imagePath": "help-images/PATIO/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Hay 12 cromos de animales en el suelo y ponemos 7 cromos más. ¿Cuántos cromos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 cromos de animales en el suelo",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "cromos de animales"
        },
        "cambio": {
          "texto": "ponemos 7 cromos más.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "cromos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos cromos hay?"
        }
      },
      "imagePath": "help-images/PATIO/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Un equipo tiene 11 pecheras azules y el otro trae 8 pecheras. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Un equipo tiene 11 pecheras azules",
          "cantidad": 11,
          "emoji": "2753",
          "objeto": "pecheras"
        },
        "cambio": {
          "texto": "el otro trae 8 pecheras.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "pecheras",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/PATIO/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En la fila hay 10 niños y llegan 5 niños de clase. ¿Cuántos niños hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la fila hay 10 niños",
          "cantidad": 10,
          "emoji": "1f466",
          "objeto": "niños"
        },
        "cambio": {
          "texto": "llegan 5 niños de clase.",
          "cantidad": 5,
          "emoji": "1f466",
          "objeto": "niños de clase",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos niños hay?"
        }
      },
      "imagePath": "help-images/PATIO/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Teníamos 16 raquetas en el carrito y 5 niños las cogen. ¿Cuántas niños quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 raquetas en el carrito",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "raquetas"
        },
        "cambio": {
          "texto": "5 niños las cogen.",
          "cantidad": 5,
          "emoji": "1f466",
          "objeto": "niños las cogen",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas niños quedan?"
        }
      },
      "imagePath": "help-images/PATIO/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "El frutero tenía 18 plátanos para almorzar y repartimos 6 plátanos. ¿Cuántos plátanos sobran?",
      "ayuda": {
        "inicio": {
          "texto": "El frutero tenía 18 plátanos para almorzar",
          "cantidad": 18,
          "emoji": "1f34c",
          "objeto": "plátanos"
        },
        "cambio": {
          "texto": "repartimos 6 plátanos.",
          "cantidad": 6,
          "emoji": "1f34c",
          "objeto": "plátanos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos plátanos sobran?"
        }
      },
      "imagePath": "help-images/PATIO/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "Había 15 aros de gimnasia y se han roto 4 aros. ¿Cuántos aros sirven?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 aros de gimnasia",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "aros de gimnasia"
        },
        "cambio": {
          "texto": "se han roto 4 aros.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "aros",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos aros sirven?"
        }
      },
      "imagePath": "help-images/PATIO/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "El sol calienta mucho el suelo del patio central hoy. Hay 22 niños jugando al fútbol y llegan 14 niños de primaria. ¿Cuántos niños juegan?",
      "ayuda": {
        "inicio": {
          "texto": "El sol calienta mucho el suelo del patio central hoy. Hay 22 niños jugando al fútbol",
          "cantidad": 22,
          "emoji": "1f466",
          "objeto": "niños jugando"
        },
        "cambio": {
          "texto": "llegan 14 niños de primaria.",
          "cantidad": 14,
          "emoji": "1f466",
          "objeto": "niños de primaria",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos niños juegan?"
        }
      },
      "imagePath": "help-images/PATIO/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "Los árboles del patio dan una sombra muy fresca y rica. Hay 31 hojas secas amarillas y caen 12 hojas marrones muy grandes. ¿Cuántas hojas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "rica. Hay 31 hojas secas amarillas",
          "cantidad": 31,
          "emoji": "2753",
          "objeto": "hojas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hojas hay?"
        }
      },
      "imagePath": "help-images/PATIO/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "El agua de la fuente sale muy fría y nos gusta. Hemos llenado 25 botellas pequeñas y después llenamos 23 botellas grandes de plástico. ¿Cuántas botellas llenamos?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "nos gusta. Hemos llenado 25 botellas pequeñas",
          "cantidad": 25,
          "emoji": "1f4a7",
          "objeto": "botellas",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas botellas llenamos?"
        }
      },
      "imagePath": "help-images/PATIO/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "Las líneas blancas del suelo sirven para correr y jugar. Teníamos 45 piedras pequeñas para jugar y hemos perdido 12 piedras entre la arena. ¿Cuántas piedras quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "jugar. Teníamos 45 piedras pequeñas para jugar",
          "cantidad": 45,
          "emoji": "2753",
          "objeto": "piedras",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas piedras quedan?"
        }
      },
      "imagePath": "help-images/PATIO/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "En el patio se oyen pájaros cantando y niños gritando. Había 36 bocadillos de queso preparados y los alumnos comieron 13 bocadillos. ¿Cuántos bocadillos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "niños gritando. Había 36 bocadillos de queso preparados",
          "cantidad": 36,
          "emoji": "1f9c0",
          "objeto": "bocadillos de queso preparados",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos bocadillos quedan?"
        }
      },
      "imagePath": "help-images/PATIO/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "La red de baloncesto es nueva y de color blanco. Teníamos 49 canicas brillantes en la bolsa y regalamos 24 canicas a otros compañeros. ¿Cuántas tenemos?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "de color blanco. Teníamos 49 canicas brillantes en la bolsa",
          "cantidad": 49,
          "emoji": "2753",
          "objeto": "canicas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas tenemos?"
        }
      },
      "imagePath": "help-images/PATIO/problem_18.svg"
    }
  ],
  "BIBLIOTECA": [
    {
      "id": 1,
      "enunciado": "En la mesa hay 5 cuentos de animales y 3 cuentos de risa. ¿Cuántos cuentos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la mesa hay 5 cuentos de animales",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "cuentos de animales"
        },
        "cambio": {
          "texto": "3 cuentos de risa.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "cuentos de risa",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos cuentos hay?"
        }
      },
      "imagePath": "help-images/BIBLIOTECA/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Tenemos 4 libros de piratas y compramos 4 libros de hadas. ¿Cuántos libros hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 4 libros de piratas",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "libros de piratas"
        },
        "cambio": {
          "texto": "compramos 4 libros de hadas.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "libros de hadas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos libros hay?"
        }
      },
      "imagePath": "help-images/BIBLIOTECA/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "La bibliotecaria tiene 6 revistas y encuentra 2 revistas más. ¿Cuántas revistas tiene?",
      "ayuda": {
        "inicio": {
          "texto": "La bibliotecaria tiene 6 revistas",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "revistas"
        },
        "cambio": {
          "texto": "encuentra 2 revistas más.",
          "cantidad": 2,
          "emoji": "2753",
          "objeto": "revistas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas revistas tiene?"
        }
      },
      "imagePath": "help-images/BIBLIOTECA/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Había 10 libros sobre la mesa y hemos guardado 3. ¿Cuántos quedan por guardar?",
      "ayuda": {
        "inicio": {
          "texto": "Había 10 libros sobre la mesa",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "libros sobre la mesa"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan por guardar?"
        }
      },
      "imagePath": "help-images/BIBLIOTECA/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Teníamos 9 marcadores de páginas y hemos perdido 5 marcadores. ¿Cuántos marcadores tenemos?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 9 marcadores de páginas",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "marcadores de páginas"
        },
        "cambio": {
          "texto": "hemos perdido 5 marcadores.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "marcadores",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos marcadores tenemos?"
        }
      },
      "imagePath": "help-images/BIBLIOTECA/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "En el estante hay 8 enciclopedias y los niños cogen 4. ¿Cuántas quedan puestas?",
      "ayuda": {
        "inicio": {
          "texto": "En el estante hay 8 enciclopedias",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "enciclopedias"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan puestas?"
        }
      },
      "imagePath": "help-images/BIBLIOTECA/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Hay 12 diccionarios rojos y ponemos 6 diccionarios verdes en la balda. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 diccionarios rojos",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "diccionarios"
        },
        "cambio": {
          "texto": "ponemos 6 diccionarios verdes en la balda.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "diccionarios",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/BIBLIOTECA/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Un niño lee 11 páginas hoy y lee 8 páginas mañana. ¿Cuántas páginas lee?",
      "ayuda": {
        "inicio": {
          "texto": "Un niño lee 11 páginas hoy",
          "cantidad": 11,
          "emoji": "2753",
          "objeto": "páginas hoy"
        },
        "cambio": {
          "texto": "lee 8 páginas mañana.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "páginas mañana",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas páginas lee?"
        }
      },
      "imagePath": "help-images/BIBLIOTECA/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En la caja hay 10 gomas y traemos 7 gomas de borrar. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la caja hay 10 gomas",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "gomas"
        },
        "cambio": {
          "texto": "traemos 7 gomas de borrar.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "gomas de borrar",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/BIBLIOTECA/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Teníamos 16 lápices de colores y se han roto 5 puntas. ¿Cuántos lápices sirven?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 lápices de colores",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "lápices de colores"
        },
        "cambio": {
          "texto": "se han roto 5 puntas.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "puntas",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos lápices sirven?"
        }
      },
      "imagePath": "help-images/BIBLIOTECA/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Había 15 sillas en la zona de lectura y retiramos 4 sillas. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 sillas en la zona de lectura",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "sillas"
        },
        "cambio": {
          "texto": "retiramos 4 sillas.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "sillas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/BIBLIOTECA/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En el mostrador había 19 carnets y los socios cogen 7. ¿Cuántos carnets sobran?",
      "ayuda": {
        "inicio": {
          "texto": "En el mostrador había 19 carnets",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "carnets"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos carnets sobran?"
        }
      },
      "imagePath": "help-images/BIBLIOTECA/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "El silencio de la biblioteca ayuda a soñar con naves espaciales. Vemos 24 libros de planetas y traen 15 libros de estrellas muy brillantes. ¿Cuántos libros hay?",
      "ayuda": {
        "inicio": {
          "texto": "El silencio de la biblioteca ayuda a soñar con naves espaciales. Vemos 24 libros de planetas",
          "cantidad": 24,
          "emoji": "2753",
          "objeto": "libros de planetas"
        },
        "cambio": {
          "texto": "traen 15 libros de estrellas muy brillantes.",
          "cantidad": 15,
          "emoji": "2b50",
          "objeto": "libros de estrellas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos libros hay?"
        }
      },
      "imagePath": "help-images/BIBLIOTECA/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "El olor de los libros nuevos es muy especial y nos encanta. Hay 31 cuentos de hadas y el cartero trae 16 cuentos de gigantes. ¿Cuántos libros hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "nos encanta. Hay 31 cuentos de hadas",
          "cantidad": 31,
          "emoji": "2753",
          "objeto": "cuentos de hadas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos libros hay?"
        }
      },
      "imagePath": "help-images/BIBLIOTECA/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Las mesas de madera son grandes y caben muchos niños que leen. Hay 25 sillas de color madera y ponemos 24 sillas de color azul. ¿Cuántas niños hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "caben muchos niños que leen. Hay 25 sillas de color madera",
          "cantidad": 25,
          "emoji": "2753",
          "objeto": "sillas de color madera",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas niños hay?"
        }
      },
      "imagePath": "help-images/BIBLIOTECA/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "La luz de la ventana entra con fuerza y calienta los libros. Teníamos 48 dibujos de flores para colorear y los niños usaron 14 dibujos. ¿Cuántos libros quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "calienta los libros. Teníamos 48 dibujos de flores para colorear",
          "cantidad": 48,
          "emoji": "2753",
          "objeto": "dibujos de flores",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos libros quedan?"
        }
      },
      "imagePath": "help-images/BIBLIOTECA/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "El bibliotecario usa gafas pequeñas para ver mejor las letras negras. Había 37 periódicos viejos y han tirado 15 periódicos al contenedor de papel. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "El bibliotecario usa gafas pequeñas para ver mejor las letras negras. Había 37 periódicos viejos",
          "cantidad": 37,
          "emoji": "2753",
          "objeto": "periódicos"
        },
        "cambio": {
          "texto": "han tirado 15 periódicos al contenedor de papel.",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "periódicos",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/BIBLIOTECA/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "Las estanterías son muy altas y llegan casi hasta el techo blanco. Teníamos 46 pegatinas de premios y hemos pegado 23 pegatinas en los libros. ¿Cuántas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "llegan casi hasta el techo blanco. Teníamos 46 pegatinas de premios",
          "cantidad": 46,
          "emoji": "2b50",
          "objeto": "pegatinas de premios",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas sobran?"
        }
      },
      "imagePath": "help-images/BIBLIOTECA/problem_18.svg"
    }
  ],
  "CENTRO COMERCIAL": [
    {
      "id": 1,
      "enunciado": "En la juguetería hay 5 ositos de peluche y traen 4 muñecas nuevas. ¿Cuántos juguetes hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la juguetería hay 5 ositos de peluche",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "ositos de peluche"
        },
        "cambio": {
          "texto": "traen 4 muñecas nuevas.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "muñecas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos juguetes hay?"
        }
      },
      "imagePath": "help-images/CENTRO COMERCIAL/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Tenemos 6 coches de metal y compramos 3 coches de plástico. ¿Cuántos coches hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 6 coches de metal",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "coches de metal"
        },
        "cambio": {
          "texto": "compramos 3 coches de plástico.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "coches de plástico",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos coches hay?"
        }
      },
      "imagePath": "help-images/CENTRO COMERCIAL/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "En la zapatería hay 4 botas rojas y 4 zapatillas azules. ¿Cuántos zapatos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la zapatería hay 4 botas rojas",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "botas"
        },
        "cambio": {
          "texto": "4 zapatillas azules.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "zapatillas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos zapatos hay?"
        }
      },
      "imagePath": "help-images/CENTRO COMERCIAL/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Había 10 globos en la entrada y se han volado 3 globos. ¿Cuántos globos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 10 globos en la entrada",
          "cantidad": 10,
          "emoji": "1f388",
          "objeto": "globos"
        },
        "cambio": {
          "texto": "se han volado 3 globos.",
          "cantidad": 3,
          "emoji": "1f388",
          "objeto": "globos",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos globos quedan?"
        }
      },
      "imagePath": "help-images/CENTRO COMERCIAL/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Tenía 9 monedas para las máquinas y he gastado 5 monedas. ¿Cuántas me quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 9 monedas para las máquinas",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "monedas"
        },
        "cambio": {
          "texto": "he gastado 5 monedas.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "monedas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas me quedan?"
        }
      },
      "imagePath": "help-images/CENTRO COMERCIAL/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "En la estantería hay 8 libros de pegatinas y vendemos 4 libros. ¿Cuántos libros sobran?",
      "ayuda": {
        "inicio": {
          "texto": "En la estantería hay 8 libros de pegatinas",
          "cantidad": 8,
          "emoji": "2b50",
          "objeto": "libros de pegatinas"
        },
        "cambio": {
          "texto": "vendemos 4 libros.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "libros",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos libros sobran?"
        }
      },
      "imagePath": "help-images/CENTRO COMERCIAL/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Hay 12 camisetas de rayas y ponemos 6 camisetas lisas en el montón. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 camisetas de rayas",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "camisetas de rayas"
        },
        "cambio": {
          "texto": "ponemos 6 camisetas lisas en el montón.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "camisetas lisas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/CENTRO COMERCIAL/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "En el cine compramos 11 bolsas de palomitas y 8 refrescos de cola. ¿Cuántas cosas compramos?",
      "ayuda": {
        "inicio": {
          "texto": "En el cine compramos 11 bolsas de palomitas",
          "cantidad": 11,
          "emoji": "1f381",
          "objeto": "bolsas de palomitas"
        },
        "cambio": {
          "texto": "8 refrescos de cola.",
          "cantidad": 8,
          "emoji": "1f964",
          "objeto": "refrescos de cola",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas cosas compramos?"
        }
      },
      "imagePath": "help-images/CENTRO COMERCIAL/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En la caja hay 10 pulseras brillantes y traen 7 collares de colores. ¿Cuántas joyas hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la caja hay 10 pulseras brillantes",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "pulseras"
        },
        "cambio": {
          "texto": "traen 7 collares de colores.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "collares de colores",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas joyas hay?"
        }
      },
      "imagePath": "help-images/CENTRO COMERCIAL/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Teníamos 16 gorras de sol en el estante y se llevan 5 gorras. ¿Cuántas gorras quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 gorras de sol en el estante",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "gorras de sol"
        },
        "cambio": {
          "texto": "se llevan 5 gorras.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "gorras",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas gorras quedan?"
        }
      },
      "imagePath": "help-images/CENTRO COMERCIAL/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Había 15 helados de fresa en la nevera y vendemos 4 helados. ¿Cuántos helados sobran?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 helados de fresa en la nevera",
          "cantidad": 15,
          "emoji": "1f353",
          "objeto": "helados de fresa"
        },
        "cambio": {
          "texto": "vendemos 4 helados.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "helados",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos helados sobran?"
        }
      },
      "imagePath": "help-images/CENTRO COMERCIAL/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En el parking había 19 coches aparcados y salen 7 coches por la rampa. ¿Cuántos coches quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En el parking había 19 coches aparcados",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "coches aparcados"
        },
        "cambio": {
          "texto": "salen 7 coches por la rampa.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "coches por la rampa",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos coches quedan?"
        }
      },
      "imagePath": "help-images/CENTRO COMERCIAL/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "Las escaleras mecánicas suben y bajan sin parar durante toda la tarde. Hay 24 personas subiendo felices y después llegan 15 personas bajando muy rápido. ¿Cuántas personas hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "bajan sin parar durante toda la tarde. Hay 24 personas subiendo felices",
          "cantidad": 24,
          "emoji": "2753",
          "objeto": "personas subiendo felices",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas personas hay?"
        }
      },
      "imagePath": "help-images/CENTRO COMERCIAL/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "El escaparate de la tienda de música tiene luces de colores muy potentes. Hay 31 guitarras pequeñas y el camión trae 16 guitarras grandes amarillas. ¿Cuántas colors hay?",
      "ayuda": {
        "inicio": {
          "texto": "El escaparate de la tienda de música tiene luces de colores muy potentes. Hay 31 guitarras pequeñas",
          "cantidad": 31,
          "emoji": "2753",
          "objeto": "guitarras"
        },
        "cambio": {
          "texto": "el camión trae 16 guitarras grandes amarillas.",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "guitarras",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas colors hay?"
        }
      },
      "imagePath": "help-images/CENTRO COMERCIAL/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "En la planta de deportes los balones rebotan con un ruido muy fuerte. Hay 25 balones de fútbol y traen 24 balones de baloncesto. ¿Cuántos balones hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la planta de deportes los balones rebotan con un ruido muy fuerte. Hay 25 balones de fútbol",
          "cantidad": 25,
          "emoji": "2753",
          "objeto": "balones de fútbol"
        },
        "cambio": {
          "texto": "traen 24 balones de baloncesto.",
          "cantidad": 24,
          "emoji": "2753",
          "objeto": "balones de baloncesto",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos balones hay?"
        }
      },
      "imagePath": "help-images/CENTRO COMERCIAL/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "La fuente de la plaza central lanza agua con música muy suave. Teníamos 48 platos en la cafetería y los camareros usaron 14 platos blancos. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "La fuente de la plaza central lanza agua con música muy suave. Teníamos 48 platos en la cafetería",
          "cantidad": 48,
          "emoji": "1f37d",
          "objeto": "platos"
        },
        "cambio": {
          "texto": "los camareros usaron 14 platos blancos.",
          "cantidad": 14,
          "emoji": "1f37d",
          "objeto": "platos",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/CENTRO COMERCIAL/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "Los ascensores de cristal son muy modernos y se ve todo el centro. Había 37 perchas con abrigos y los clientes han comprado 15 abrigos largos. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "se ve todo el centro. Había 37 perchas con abrigos",
          "cantidad": 37,
          "emoji": "2753",
          "objeto": "perchas con abrigos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/CENTRO COMERCIAL/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "En la zona de juegos hay muchas luces brillantes de color azul. Teníamos 46 fichas para jugar y hemos gastado 23 fichas en las máquinas. ¿Cuántas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "En la zona de juegos hay muchas luces brillantes de color azul. Teníamos 46 fichas para jugar",
          "cantidad": 46,
          "emoji": "2753",
          "objeto": "fichas"
        },
        "cambio": {
          "texto": "hemos gastado 23 fichas en las máquinas.",
          "cantidad": 23,
          "emoji": "2753",
          "objeto": "fichas",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas sobran?"
        }
      },
      "imagePath": "help-images/CENTRO COMERCIAL/problem_18.svg"
    }
  ],
  "SUPERMERCADO": [
    {
      "id": 1,
      "enunciado": "Hay 4 briks de leche y después aparecen 6 briks de leche más. ¿Cuántos briks de leche hay en total?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 4 briks de leche",
          "cantidad": 4,
          "emoji": "1f95b",
          "objeto": "briks de leche"
        },
        "cambio": {
          "texto": "después aparecen 6 briks de leche más.",
          "cantidad": 6,
          "emoji": "1f95b",
          "objeto": "briks de leche",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos briks de leche hay en total?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Hay 2 paquetes de pasta y después aparecen 6 paquetes de pasta más. ¿Cuántos paquetes de pasta hay en total?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 2 paquetes de pasta",
          "cantidad": 2,
          "emoji": "2753",
          "objeto": "paquetes de pasta"
        },
        "cambio": {
          "texto": "después aparecen 6 paquetes de pasta más.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "paquetes de pasta",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos paquetes de pasta hay en total?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "Papá compra 5 yogures y luego coge 2 yogur más. ¿Cuántos yogures lleva en la bolsa?",
      "ayuda": {
        "inicio": {
          "texto": "Papá compra 5 yogures",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "yogures"
        },
        "cambio": {
          "texto": "luego coge 2 yogur más.",
          "cantidad": 2,
          "emoji": "2753",
          "objeto": "yogur",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos yogures lleva en la bolsa?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Había 6 botellas y después se pierden 4. ¿Cuántas botellas quedan en la bolsa?",
      "ayuda": {
        "inicio": {
          "texto": "Había 6 botellas",
          "cantidad": 6,
          "emoji": "1f4a7",
          "objeto": "botellas"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas botellas quedan en la bolsa?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "En el supermercado, Lucas cuenta 6 latas. Luego busca 4 de ellos. ¿Cuántas latas quedan en la cesta?",
      "ayuda": {
        "inicio": {
          "texto": "En el supermercado, Lucas cuenta 6 latas. Luego busca 4 de ellos.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "latas"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas latas quedan en la cesta?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "Papá cogió 9 barras de pan pero deja 3 porque cree que son demasiadas. ¿Cuántos barras de pan se lleva?",
      "ayuda": {
        "inicio": {
          "texto": "Papá cogió 9 barras de pan",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "barras de pan"
        },
        "cambio": {
          "texto": "deja 3 porque cree que son demasiadas.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "porque cree que son demasiadas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos barras de pan se lleva?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Hay 2 arroces y después aparecen 12 arroces más. ¿Cuántos arroces hay en total?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 2 arroces",
          "cantidad": 2,
          "emoji": "2753",
          "objeto": "arroces"
        },
        "cambio": {
          "texto": "después aparecen 12 arroces más.",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "arroces",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos arroces hay en total?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Hay 9 frutas y después aparecen 6 frutas más. ¿Cuántas frutas habrá ahora?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 9 frutas",
          "cantidad": 9,
          "emoji": "1f34e",
          "objeto": "frutas"
        },
        "cambio": {
          "texto": "después aparecen 6 frutas más.",
          "cantidad": 6,
          "emoji": "1f34e",
          "objeto": "frutas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas frutas habrá ahora?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "En la cesta tenemos 13 latas de atún y ponemos 16 latas de atún más. ¿Cuántos latas de atún hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la cesta tenemos 13 latas de atún",
          "cantidad": 13,
          "emoji": "2753",
          "objeto": "latas de atún"
        },
        "cambio": {
          "texto": "ponemos 16 latas de atún más.",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "latas de atún",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos latas de atún hay?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Al principio hay 18 paquetes de galletas. Cuando María busca, quedan menos porque busca 10. ¿Cuántas paquetes de galletas quedan en total?",
      "ayuda": {
        "inicio": {
          "texto": "Al principio hay 18 paquetes de galletas. Cuando María busca, quedan menos porque busca 10.",
          "cantidad": 18,
          "emoji": "1f36a",
          "objeto": "paquetes de galletas"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas paquetes de galletas quedan en total?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "En el supermercado, Carla cuenta 16 paquetes de arroz. Luego compra 10 de ellos. ¿Cuántos paquetes de arroz quedan en total?",
      "ayuda": {
        "inicio": {
          "texto": "En el supermercado, Carla cuenta 16 paquetes de arroz. Luego compra 10 de ellos.",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "paquetes de arroz"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos paquetes de arroz quedan en total?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "Papá cogió 18 tomates pero deja 7 porque están maduros. ¿Cuántos tomates se lleva?",
      "ayuda": {
        "inicio": {
          "texto": "Papá cogió 18 tomates",
          "cantidad": 18,
          "emoji": "1f345",
          "objeto": "tomates"
        },
        "cambio": {
          "texto": "deja 7 porque están maduros.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "porque están maduros",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos tomates se lleva?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "Hay 27 jabones y después aparecen 21 jabones más. ¿Cuántos jabones hay en total?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 27 jabones",
          "cantidad": 27,
          "emoji": "2753",
          "objeto": "jabones"
        },
        "cambio": {
          "texto": "después aparecen 21 jabones más.",
          "cantidad": 21,
          "emoji": "2753",
          "objeto": "jabones",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos jabones hay en total?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "Alejandro llena 5 bolsas. Luego, compra 12 bolsas más. ¿Cuántas bolsas hay en total?",
      "ayuda": {
        "inicio": {
          "texto": "Alejandro llena 5 bolsas. Luego, compra 12 bolsas más.",
          "cantidad": 5,
          "emoji": "1f381",
          "objeto": "bolsas"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas bolsas hay en total?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "El supermercado tiene 46 barras de pan en la estantería y llegan 26 barras de pan más. ¿Cuántos barras de pan hay ahora?",
      "ayuda": {
        "inicio": {
          "texto": "El supermercado tiene 46 barras de pan en la estantería",
          "cantidad": 46,
          "emoji": "2753",
          "objeto": "barras de pan"
        },
        "cambio": {
          "texto": "llegan 26 barras de pan más.",
          "cantidad": 26,
          "emoji": "2753",
          "objeto": "barras de pan",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos barras de pan hay ahora?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "Había 22 huevos y después se pierden 2. ¿Cuántos huevos quedan en la bolsa?",
      "ayuda": {
        "inicio": {
          "texto": "Había 22 huevos",
          "cantidad": 22,
          "emoji": "1f95a",
          "objeto": "huevos"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos huevos quedan en la bolsa?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "En el supermercado, Thiago cuenta 36 paquetes de galletas. Luego carga 8 de ellos. ¿Cuántas paquetes de galletas quedan en total?",
      "ayuda": {
        "inicio": {
          "texto": "En el supermercado, Thiago cuenta 36 paquetes de galletas. Luego carga 8 de ellos.",
          "cantidad": 36,
          "emoji": "1f36a",
          "objeto": "paquetes de galletas"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas paquetes de galletas quedan en total?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "Había 32 cajas de cereales en el estante y se venden 10. ¿Cuántos cajas de cereales quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 32 cajas de cereales en el estante",
          "cantidad": 32,
          "emoji": "1f4e6",
          "objeto": "cajas de cereales"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos cajas de cereales quedan?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_18.svg"
    },
    {
      "id": 19,
      "enunciado": "Papá compra 5 yogures y luego coge 2 yogur más. ¿Cuántos yogures lleva en la bolsa?",
      "ayuda": {
        "inicio": {
          "texto": "Papá compra 5 yogures",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "yogures"
        },
        "cambio": {
          "texto": "luego coge 2 yogur más.",
          "cantidad": 2,
          "emoji": "2753",
          "objeto": "yogur",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos yogures lleva en la bolsa?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_19.svg"
    },
    {
      "id": 20,
      "enunciado": "En la cesta tenemos 3 zumo y ponemos 4 zumos más. ¿Cuántos zumos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la cesta tenemos 3 zumo",
          "cantidad": 3,
          "emoji": "1f9c3",
          "objeto": "zumo"
        },
        "cambio": {
          "texto": "ponemos 4 zumos más.",
          "cantidad": 4,
          "emoji": "1f9c3",
          "objeto": "zumos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos zumos hay?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_20.svg"
    },
    {
      "id": 21,
      "enunciado": "Papá cogió 9 barras de pan pero deja 3 porque cree que son demasiadas. ¿Cuántos barras de pan se lleva?",
      "ayuda": {
        "inicio": {
          "texto": "Papá cogió 9 barras de pan",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "barras de pan"
        },
        "cambio": {
          "texto": "deja 3 porque cree que son demasiadas.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "porque cree que son demasiadas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos barras de pan se lleva?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_21.svg"
    },
    {
      "id": 22,
      "enunciado": "En el carrito metí 5 cajas de galletas pero mamá devuelve 3 al estante. ¿Cuántas cajas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En el carrito metí 5 cajas de galletas",
          "cantidad": 5,
          "emoji": "1f36a",
          "objeto": "cajas de galletas"
        },
        "cambio": {
          "texto": "mamá devuelve 3 al estante.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "al estante",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas cajas quedan?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_22.svg"
    },
    {
      "id": 23,
      "enunciado": "En la cesta tenemos 13 latas de atún y ponemos 16 latas de atún más. ¿Cuántos latas de atún hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la cesta tenemos 13 latas de atún",
          "cantidad": 13,
          "emoji": "2753",
          "objeto": "latas de atún"
        },
        "cambio": {
          "texto": "ponemos 16 latas de atún más.",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "latas de atún",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos latas de atún hay?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_23.svg"
    },
    {
      "id": 24,
      "enunciado": "La cajera cuenta 14 huevos y el cliente trae 10 huevos más. ¿Cuántos huevos son en total?",
      "ayuda": {
        "inicio": {
          "texto": "La cajera cuenta 14 huevos",
          "cantidad": 14,
          "emoji": "1f95a",
          "objeto": "huevos"
        },
        "cambio": {
          "texto": "el cliente trae 10 huevos más.",
          "cantidad": 10,
          "emoji": "1f95a",
          "objeto": "huevos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos huevos son en total?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_24.svg"
    },
    {
      "id": 25,
      "enunciado": "Papá cogió 18 tomates pero deja 7 porque están maduros. ¿Cuántos tomates se lleva?",
      "ayuda": {
        "inicio": {
          "texto": "Papá cogió 18 tomates",
          "cantidad": 18,
          "emoji": "1f345",
          "objeto": "tomates"
        },
        "cambio": {
          "texto": "deja 7 porque están maduros.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "porque están maduros",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos tomates se lleva?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_25.svg"
    },
    {
      "id": 26,
      "enunciado": "En la nevera hay 12 barras de pan y se gastan 6 para una receta. ¿Cuántos barras de pan sobran?",
      "ayuda": {
        "inicio": {
          "texto": "En la nevera hay 12 barras de pan",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "barras de pan"
        },
        "cambio": {
          "texto": "se gastan 6 para una receta.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "para una receta",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos barras de pan sobran?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_26.svg"
    },
    {
      "id": 27,
      "enunciado": "El supermercado tiene 46 barras de pan en la estantería y llegan 26 barras de pan más. ¿Cuántos barras de pan hay ahora?",
      "ayuda": {
        "inicio": {
          "texto": "El supermercado tiene 46 barras de pan en la estantería",
          "cantidad": 46,
          "emoji": "2753",
          "objeto": "barras de pan"
        },
        "cambio": {
          "texto": "llegan 26 barras de pan más.",
          "cantidad": 26,
          "emoji": "2753",
          "objeto": "barras de pan",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos barras de pan hay ahora?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_27.svg"
    },
    {
      "id": 28,
      "enunciado": "Papá compra 50 yogures y luego coge 10 yogures más. ¿Cuántos yogures lleva en la bolsa?",
      "ayuda": {
        "inicio": {
          "texto": "Papá compra 50 yogures",
          "cantidad": 50,
          "emoji": "2753",
          "objeto": "yogures"
        },
        "cambio": {
          "texto": "luego coge 10 yogures más.",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "yogures",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos yogures lleva en la bolsa?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_28.svg"
    },
    {
      "id": 29,
      "enunciado": "En el carrito hay 31 cajas de cereales pero mamá devuelve 12 al estante. ¿Cuántos cajas de cereales quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En el carrito hay 31 cajas de cereales",
          "cantidad": 31,
          "emoji": "1f4e6",
          "objeto": "cajas de cereales"
        },
        "cambio": {
          "texto": "mamá devuelve 12 al estante.",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "al estante",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos cajas de cereales quedan?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_29.svg"
    },
    {
      "id": 30,
      "enunciado": "Había 32 cajas de cereales en el estante y se venden 10. ¿Cuántos cajas de cereales quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 32 cajas de cereales en el estante",
          "cantidad": 32,
          "emoji": "1f4e6",
          "objeto": "cajas de cereales"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos cajas de cereales quedan?"
        }
      },
      "imagePath": "help-images/SUPERMERCADO/problem_30.svg"
    }
  ],
  "MUSEO": [
    {
      "id": 1,
      "enunciado": "En la entrada hay 4 dinosaurios verdes y 3 dinosaurios naranjas. ¿Cuántos dinosaurios hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la entrada hay 4 dinosaurios verdes",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "dinosaurios"
        },
        "cambio": {
          "texto": "3 dinosaurios naranjas.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "dinosaurios",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos dinosaurios hay?"
        }
      },
      "imagePath": "help-images/MUSEO/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Vemos 5 mariposas azules grandes y 2 mariposas amarillas pequeñas. ¿Cuántas mariposas vemos?",
      "ayuda": {
        "inicio": {
          "texto": "Vemos 5 mariposas azules grandes",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "mariposas"
        },
        "cambio": {
          "texto": "2 mariposas amarillas pequeñas.",
          "cantidad": 2,
          "emoji": "2753",
          "objeto": "mariposas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas mariposas vemos?"
        }
      },
      "imagePath": "help-images/MUSEO/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "El guía nos enseña 6 piedras brillantes y saca 4 piedras más. ¿Cuántas piedras hay?",
      "ayuda": {
        "inicio": {
          "texto": "El guía nos enseña 6 piedras brillantes",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "piedras"
        },
        "cambio": {
          "texto": "saca 4 piedras más.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "piedras",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas piedras hay?"
        }
      },
      "imagePath": "help-images/MUSEO/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Había 8 huevos de dinosaurio en el nido, pero 3 se rompieron. ¿Cuántos quedan enteros?",
      "ayuda": {
        "inicio": {
          "texto": "Había 8 huevos de dinosaurio en el nido,",
          "cantidad": 8,
          "emoji": "1f95a",
          "objeto": "huevos de dinosaurio"
        },
        "cambio": {
          "texto": "3 se rompieron.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "se rompieron",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan enteros?"
        }
      },
      "imagePath": "help-images/MUSEO/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "En la tienda hay 9 peluches de mamut y venden 2 peluches. ¿Cuántos peluches quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En la tienda hay 9 peluches de mamut",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "peluches de mamut"
        },
        "cambio": {
          "texto": "venden 2 peluches.",
          "cantidad": 2,
          "emoji": "2753",
          "objeto": "peluches",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos peluches quedan?"
        }
      },
      "imagePath": "help-images/MUSEO/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "Tenemos 7 lupas para investigar, pero 4 lupas se han perdido. ¿Cuántas lupas tenemos?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 7 lupas para investigar,",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "lupas"
        },
        "cambio": {
          "texto": "4 lupas se han perdido.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "lupas se han perdido",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas lupas tenemos?"
        }
      },
      "imagePath": "help-images/MUSEO/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "En la sala del espacio hay 12 cohetes rojos y llegan 5 cohetes azules. ¿Cuántos cohetes hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la sala del espacio hay 12 cohetes rojos",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "cohetes"
        },
        "cambio": {
          "texto": "llegan 5 cohetes azules.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "cohetes",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos cohetes hay?"
        }
      },
      "imagePath": "help-images/MUSEO/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Vemos una colección con 11 hojas secas y recogemos 8 hojas más. ¿Cuántas hojas tenemos?",
      "ayuda": {
        "inicio": {
          "texto": "Vemos una colección con 11 hojas secas",
          "cantidad": 11,
          "emoji": "2753",
          "objeto": "hojas"
        },
        "cambio": {
          "texto": "recogemos 8 hojas más.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "hojas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hojas tenemos?"
        }
      },
      "imagePath": "help-images/MUSEO/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "Hay 13 niños en la fila y llegan 6 niños más. ¿Cuántos niños hay en total?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 13 niños en la fila",
          "cantidad": 13,
          "emoji": "1f466",
          "objeto": "niños"
        },
        "cambio": {
          "texto": "llegan 6 niños más.",
          "cantidad": 6,
          "emoji": "1f466",
          "objeto": "niños",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos niños hay en total?"
        }
      },
      "imagePath": "help-images/MUSEO/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "El esqueleto tenía 18 costillas, pero se le cayeron 5 costillas al suelo. ¿Cuántas quedan puestas?",
      "ayuda": {
        "inicio": {
          "texto": "El esqueleto tenía 18 costillas,",
          "cantidad": 18,
          "emoji": "2753",
          "objeto": "costillas"
        },
        "cambio": {
          "texto": "se le cayeron 5 costillas al suelo.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "costillas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan puestas?"
        }
      },
      "imagePath": "help-images/MUSEO/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "En una pecera nadaban 16 peces antiguos y se esconden 4 peces. ¿Cuántos peces vemos?",
      "ayuda": {
        "inicio": {
          "texto": "En una pecera nadaban 16 peces antiguos",
          "cantidad": 16,
          "emoji": "2753",
          "objeto": "peces antiguos"
        },
        "cambio": {
          "texto": "se esconden 4 peces.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "peces",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos peces vemos?"
        }
      },
      "imagePath": "help-images/MUSEO/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "Había 19 mapas del museo en el mostrador y los visitantes cogen 7. ¿Cuántos mapas sobran?",
      "ayuda": {
        "inicio": {
          "texto": "Había 19 mapas del museo en el mostrador",
          "cantidad": 19,
          "emoji": "2753",
          "objeto": "mapas"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos mapas sobran?"
        }
      },
      "imagePath": "help-images/MUSEO/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "La sala de los planetas es muy oscura y misteriosa. Vemos 24 estrellas brillantes en el techo y luego se encienden otras 13 estrellas fugaces preciosas. ¿Cuántas estrellas brillan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "misteriosa. Vemos 24 estrellas brillantes en el techo",
          "cantidad": 24,
          "emoji": "2b50",
          "objeto": "estrellas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas estrellas brillan?"
        }
      },
      "imagePath": "help-images/MUSEO/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "Los insectos del museo tienen muchos colores y patas. En una vitrina hay 32 escarabajos verdes y llegan 15 escarabajos dorados muy raros. ¿Cuántos escarabajos hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "patas. En una vitrina hay 32 escarabajos verdes",
          "cantidad": 32,
          "emoji": "1f9c4",
          "objeto": "escarabajos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos escarabajos hay?"
        }
      },
      "imagePath": "help-images/MUSEO/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Las piedras preciosas brillan mucho bajo la luz fuerte. El guía muestra 21 diamantes blancos y saca 26 esmeraldas verdes de una caja fuerte. ¿Cuántas piedras enseña?",
      "ayuda": {
        "inicio": {
          "texto": "Las piedras preciosas brillan mucho bajo la luz fuerte. El guía muestra 21 diamantes blancos",
          "cantidad": 21,
          "emoji": "2753",
          "objeto": "diamantes"
        },
        "cambio": {
          "texto": "saca 26 esmeraldas verdes de una caja fuerte.",
          "cantidad": 26,
          "emoji": "1f4e6",
          "objeto": "esmeraldas de una caja fuerte",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas piedras enseña?"
        }
      },
      "imagePath": "help-images/MUSEO/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "El esqueleto del dinosaurio gigante asusta un poco a todos. Tenía 48 huesos grandes en la cola, pero se cayeron 14 huesos al suelo. ¿Cuántos huesos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "El esqueleto del dinosaurio gigante asusta un poco a todos. Tenía 48 huesos grandes en la cola,",
          "cantidad": 48,
          "emoji": "2753",
          "objeto": "huesos"
        },
        "cambio": {
          "texto": "se cayeron 14 huesos al suelo.",
          "cantidad": 14,
          "emoji": "2753",
          "objeto": "huesos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos huesos quedan?"
        }
      },
      "imagePath": "help-images/MUSEO/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "La colección de aves tiene plumas de muchos colores vivos. Había 36 loros disecados en la rama, pero se llevaron 12 loros para limpiarlos. ¿Cuántos loros quedan?",
      "ayuda": {
        "inicio": {
          "texto": "La colección de aves tiene plumas de muchos colores vivos. Había 36 loros disecados en la rama,",
          "cantidad": 36,
          "emoji": "2753",
          "objeto": "loros disecados"
        },
        "cambio": {
          "texto": "se llevaron 12 loros para limpiarlos.",
          "cantidad": 12,
          "emoji": "2753",
          "objeto": "loros",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos loros quedan?"
        }
      },
      "imagePath": "help-images/MUSEO/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "Después de la visita todos tenemos mucha hambre y sed. En la tienda había 45 zumos de naranja y los niños bebieron 23 zumos ricos. ¿Cuántos zumos sobran?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "sed. En la tienda había 45 zumos de naranja",
          "cantidad": 45,
          "emoji": "1f9c3",
          "objeto": "zumos de",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos zumos sobran?"
        }
      },
      "imagePath": "help-images/MUSEO/problem_18.svg"
    }
  ],
  "FERIA": [
    {
      "id": 1,
      "enunciado": "Suma",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Suma",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "Suma",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Suma",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Suma",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "Resta",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Resta",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "Resta",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "Resta",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Resta",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Suma",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "Suma",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "Suma",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "Suma",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Suma",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "Resta",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "Resta",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "Resta",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_18.svg"
    },
    {
      "id": 19,
      "enunciado": "Resta",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_19.svg"
    },
    {
      "id": 20,
      "enunciado": "Resta",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_20.svg"
    },
    {
      "id": 21,
      "enunciado": "Suma",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_21.svg"
    },
    {
      "id": 22,
      "enunciado": "Suma",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_22.svg"
    },
    {
      "id": 23,
      "enunciado": "Suma",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_23.svg"
    },
    {
      "id": 24,
      "enunciado": "Suma",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_24.svg"
    },
    {
      "id": 25,
      "enunciado": "Suma",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_25.svg"
    },
    {
      "id": 26,
      "enunciado": "Resta",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_26.svg"
    },
    {
      "id": 27,
      "enunciado": "Resta",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_27.svg"
    },
    {
      "id": 28,
      "enunciado": "Resta",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_28.svg"
    },
    {
      "id": 29,
      "enunciado": "Resta",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_29.svg"
    },
    {
      "id": 30,
      "enunciado": "Resta",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": ""
        }
      },
      "imagePath": "help-images/FERIA/problem_30.svg"
    }
  ],
  "CUMPLEAÑOS": [
    {
      "id": 1,
      "enunciado": "La tarta se ve estupenda, pero antes nos comeremos los sándwiches.Había 48 sándwiches y mis amigos ya se han comido 15 sándwiches. ¿Cuántos sándwiches quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 48 sándwiches",
          "cantidad": 48,
          "emoji": "1f388",
          "objeto": "sándwiches"
        },
        "cambio": {
          "texto": "se han comido 15 sándwiches.",
          "cantidad": 15,
          "emoji": "1f388",
          "objeto": "globos",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos sándwiches quedan?"
        },
        "audioFull": "AL PRINCIPIO... Había 48 sándwiches DESPUÉS... se han comido 15 sándwiches. LA PREGUNTA ES... ¿Cuántos sándwiches quedan?"
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_1.svg"
    },
    {
      "id": 2,
      "enunciado": "Antes de cantar \"Cumpleaños Feliz\", vamos a repartir los gorros de cartón. Había 38 gorros de cartón y ya hemos repartido 14 gorros. ¿Cuántos gorros quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 38 gorros de cartón",
          "cantidad": 38,
          "emoji": "1f370",
          "objeto": "gorros"
        },
        "cambio": {
          "texto": "hemos repartido 14 gorros.",
          "cantidad": 14,
          "emoji": "1f370",
          "objeto": "trozos",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos gorros quedan?"
        },
        "audioFull": "AL PRINCIPIO... Había 38 gorros de cartón DESPUÉS... hemos repartido 14 gorros. LA PREGUNTA ES... ¿Cuántos gorros quedan?"
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_2.svg"
    },
    {
      "id": 3,
      "enunciado": "Mis padres han comprado muchos zumos para la fiesta. Hay 25 zumos de naranja y 22 de melocotón. ¿Cuántos zumos han comprado?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 25 zumos de naranja",
          "cantidad": 25,
          "emoji": "1f466",
          "objeto": "zumos"
        },
        "cambio": {
          "texto": "además hay 22 de melocotón.",
          "cantidad": 22,
          "emoji": "1f467",
          "objeto": "amigas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos zumos han comprado?"
        },
        "audioFull": "AL PRINCIPIO... Hay 25 zumos de naranja DESPUÉS... además hay 22 de melocotón. LA PREGUNTA ES... ¿Cuántos zumos han comprado?"
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_3.svg"
    },
    {
      "id": 4,
      "enunciado": "Teníamos 8 trozos de sandía, pero, como está tan rica, han traído 3 trozos de sandía más. ¿Cuántos trozos hay en total?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 8 trozos de sandía",
          "cantidad": 8,
          "emoji": "1f389",
          "objeto": "trozos"
        },
        "cambio": {
          "texto": "han traído 3 trozos de sandía más.",
          "cantidad": 3,
          "emoji": "2753",
          "objeto": "más",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos trozos hay en total?"
        },
        "audioFull": "AL PRINCIPIO... Teníamos 8 trozos de sandía DESPUÉS... han traído 3 trozos de sandía más. LA PREGUNTA ES... ¿Cuántos trozos hay en total?"
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_4.svg"
    },
    {
      "id": 5,
      "enunciado": "Había 14 globos inflados y mi primo infla 4 globos más. ¿Cuántos globos hay ahora?",
      "ayuda": {
        "inicio": {
          "texto": "Había 14 globos inflados",
          "cantidad": 14,
          "emoji": "1f96a",
          "objeto": "globos"
        },
        "cambio": {
          "texto": "mi primo infla 4 globos más.",
          "cantidad": 4,
          "emoji": "1f9c0",
          "objeto": "de queso",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos globos hay ahora?"
        },
        "audioFull": "AL PRINCIPIO... Había 14 globos inflados DESPUÉS... mi primo infla 4 globos más. LA PREGUNTA ES... ¿Cuántos globos hay ahora?"
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_5.svg"
    },
    {
      "id": 6,
      "enunciado": "Había 10 vasos en la mesa y se han caído 4. ¿Cuántos vasos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 10 vasos en la mesa",
          "cantidad": 10,
          "emoji": "1f964",
          "objeto": "vasos"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos vasos quedan?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_6.svg"
    },
    {
      "id": 7,
      "enunciado": "Tenía 9 regalos y ya he abierto 5. ¿Cuántos faltan por abrir?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 9 regalos",
          "cantidad": 9,
          "emoji": "1f381",
          "objeto": "regalos"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos faltan por abrir?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_7.svg"
    },
    {
      "id": 8,
      "enunciado": "En un banco hay 8 niños y 5 se van a jugar. ¿Cuántos niños quedan?",
      "ayuda": {
        "inicio": {
          "texto": "En un banco hay 8 niños",
          "cantidad": 8,
          "emoji": "1f466",
          "objeto": "niños"
        },
        "cambio": {
          "texto": "5 se van a jugar.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "se van a jugar",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos niños quedan?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_8.svg"
    },
    {
      "id": 9,
      "enunciado": "El pastel tenía 7 velas y he soplado 3. ¿Cuántas quedan encendidas?",
      "ayuda": {
        "inicio": {
          "texto": "El pastel tenía 7 velas",
          "cantidad": 7,
          "emoji": "1f56f",
          "objeto": "velas"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan encendidas?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_9.svg"
    },
    {
      "id": 10,
      "enunciado": "Había 6 pajitas en el bote y he usado 2. ¿Cuántas quedan nuevas?",
      "ayuda": {
        "inicio": {
          "texto": "Había 6 pajitas en el bote",
          "cantidad": 6,
          "emoji": "1f964",
          "objeto": "pajitas"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan nuevas?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_10.svg"
    },
    {
      "id": 11,
      "enunciado": "Hay 12 servilletas y la abuela pone 6 más. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 12 servilletas",
          "cantidad": 12,
          "emoji": "1f9fb",
          "objeto": "servilletas"
        },
        "cambio": {
          "texto": "la abuela pone 6 más.",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "más",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_11.svg"
    },
    {
      "id": 12,
      "enunciado": "En la bandeja hay 11 platos y traigo 8 más. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "En la bandeja hay 11 platos",
          "cantidad": 11,
          "emoji": "1f37d",
          "objeto": "platos"
        },
        "cambio": {
          "texto": "traigo 8 más.",
          "cantidad": 8,
          "emoji": "2753",
          "objeto": "más",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_12.svg"
    },
    {
      "id": 13,
      "enunciado": "Tengo 10 tenedores de plástico y compro 7 más. ¿Cuántos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Tengo 10 tenedores de plástico",
          "cantidad": 10,
          "emoji": "1f374",
          "objeto": "tenedores de plástico"
        },
        "cambio": {
          "texto": "compro 7 más.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "más",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos hay?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_13.svg"
    },
    {
      "id": 14,
      "enunciado": "En el jardín hay 13 niños y entran 5 más. ¿Cuántos niños son?",
      "ayuda": {
        "inicio": {
          "texto": "En el jardín hay 13 niños",
          "cantidad": 13,
          "emoji": "1f466",
          "objeto": "niños"
        },
        "cambio": {
          "texto": "entran 5 más.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "más",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos niños son?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_14.svg"
    },
    {
      "id": 15,
      "enunciado": "Hay 14 globos inflados y mi primo infla 5 más. ¿Cuántos globos hay?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 14 globos inflados",
          "cantidad": 14,
          "emoji": "1f388",
          "objeto": "globos"
        },
        "cambio": {
          "texto": "mi primo infla 5 más.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "más",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos globos hay?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_15.svg"
    },
    {
      "id": 16,
      "enunciado": "Teníamos 16 bolsas de chuches y hemos dado 5. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Teníamos 16 bolsas de chuches",
          "cantidad": 16,
          "emoji": "1f36c",
          "objeto": "bolsas de chuches"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_16.svg"
    },
    {
      "id": 17,
      "enunciado": "Había 15 galletas y se han roto 4 al sacarlas. ¿Cuántas galletas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 15 galletas",
          "cantidad": 15,
          "emoji": "1f36a",
          "objeto": "galletas"
        },
        "cambio": {
          "texto": "se han roto 4 al sacarlas.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "al sacarlas",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas galletas quedan?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_17.svg"
    },
    {
      "id": 18,
      "enunciado": "Tenía 19 pegatinas y he pegado 7 en las invitaciones. ¿Cuántas pegatinas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 19 pegatinas",
          "cantidad": 19,
          "emoji": "2b50",
          "objeto": "pegatinas"
        },
        "cambio": {
          "texto": "he pegado 7 en las invitaciones.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "en las invitaciones",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas pegatinas quedan?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_18.svg"
    },
    {
      "id": 19,
      "enunciado": "Había 18 botellas de agua y nos hemos bebido 6. ¿Cuántas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Había 18 botellas de agua",
          "cantidad": 18,
          "emoji": "1f4a7",
          "objeto": "botellas de agua"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_19.svg"
    },
    {
      "id": 20,
      "enunciado": "Tenía 17 cucharas y he usado 4 para el postre. ¿Cuántas quedan limpias?",
      "ayuda": {
        "inicio": {
          "texto": "Tenía 17 cucharas",
          "cantidad": 17,
          "emoji": "1f944",
          "objeto": "cucharas"
        },
        "cambio": {
          "texto": "he usado 4 para el postre.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "para el postre",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántas quedan limpias?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_20.svg"
    },
    {
      "id": 21,
      "enunciado": "Huele a chocolate caliente y suena música de baile. Tenemos 22 cupcakes de vainilla y llegan 14 de fresa. ¿Cuántos chocolate hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "suena música de baile. Tenemos 22 cupcakes de vainilla",
          "cantidad": 22,
          "emoji": "1f9c1",
          "objeto": "cupcakes de vainilla",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos chocolate hay?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_21.svg"
    },
    {
      "id": 22,
      "enunciado": "Las luces parpadean de colores y todos ríen. Hay 31 serpentinas en el suelo y tiramos 16 más. ¿Cuántas colors hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "todos ríen. Hay 31 serpentinas en el suelo",
          "cantidad": 31,
          "emoji": "1f38a",
          "objeto": "serpentinas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas colors hay?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_22.svg"
    },
    {
      "id": 23,
      "enunciado": "El suelo está un poco pegajoso de zumo y hace calor. Hay 25 cajas de zumo y compramos 23 de leche. ¿Cuántas zumo hay?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "hace calor. Hay 25 cajas de zumo",
          "cantidad": 25,
          "emoji": "1f9c3",
          "objeto": "cajas de zumo",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas zumo hay?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_23.svg"
    },
    {
      "id": 24,
      "enunciado": "Los globos brillan mucho y se oye un \"¡Pum!\". Hay 32 invitados sentados y entran 15 primos corriendo. ¿Cuántos globos son?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "se oye un \"¡Pum!\". Hay 32 invitados sentados",
          "cantidad": 32,
          "emoji": "1f466",
          "objeto": "invitados sentados",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos globos son?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_24.svg"
    },
    {
      "id": 25,
      "enunciado": "Se oye el ruido de la piñata al romperse. Tenemos 24 bolsas de premios y preparamos 22 bolsas más. ¿Cuántas hay?",
      "ayuda": {
        "inicio": {
          "texto": "Se oye el ruido de la piñata al romperse. Tenemos 24 bolsas de premios",
          "cantidad": 24,
          "emoji": "1f381",
          "objeto": "bolsas de premios"
        },
        "cambio": {
          "texto": "preparamos 22 bolsas más.",
          "cantidad": 22,
          "emoji": "1f381",
          "objeto": "bolsas",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas hay?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_25.svg"
    },
    {
      "id": 26,
      "enunciado": "La tarta es gigante y huele a nata. Teníamos 48 sándwiches y los niños se han comido 15. ¿Cuántas tarta quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "huele a nata. Teníamos 48 sándwiches",
          "cantidad": 48,
          "emoji": "1f96a",
          "objeto": "sándwiches",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas tarta quedan?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_26.svg"
    },
    {
      "id": 27,
      "enunciado": "Todos cantan \"Cumpleaños Feliz\" muy alto. Había 37 gorros de cartón y hemos repartido 15. ¿Cuántos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Todos cantan \"Cumpleaños Feliz\" muy alto. Había 37 gorros de cartón",
          "cantidad": 37,
          "emoji": "1f389",
          "objeto": "gorros de cartón"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos quedan?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_27.svg"
    },
    {
      "id": 28,
      "enunciado": "Hay fuegos artificiales de colores en el jardín. Tenía 46 bengalas y hemos encendido 23. ¿Cuántas colors quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Hay fuegos artificiales de colores en el jardín. Tenía 46 bengalas",
          "cantidad": 46,
          "emoji": "2728",
          "objeto": "bengalas"
        },
        "cambio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas colors quedan?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_28.svg"
    },
    {
      "id": 29,
      "enunciado": "El agua de los refrescos está muy fría y hace ruido el hielo. Había 39 cubitos de hielo y se han derretido 16. ¿Cuántos refrescos quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "hace ruido el hielo. Había 39 cubitos de hielo",
          "cantidad": 39,
          "emoji": "1f9ca",
          "objeto": "cubitos de hielo",
          "operacion": "-"
        },
        "pregunta": {
          "texto": "¿Cuántos refrescos quedan?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_29.svg"
    },
    {
      "id": 30,
      "enunciado": "La alfombra es muy suave y estamos descalzos. Tenía 45 estrellas de confeti y he barrido 23. ¿Cuántas estrellas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "",
          "cantidad": 0,
          "emoji": "2753",
          "objeto": ""
        },
        "cambio": {
          "texto": "estamos descalzos. Tenía 45 estrellas de confeti",
          "cantidad": 45,
          "emoji": "2b50",
          "objeto": "estrellas de confeti",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas estrellas quedan?"
        }
      },
      "imagePath": "help-images/CUMPLEAÑOS/problem_30.svg"
    },
    {
      "id": 1,
      "enunciado": "Hay 5 globos azules y 4 globos amarillos. ¿Cuántos globos hay en total?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 5 globos azules",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "globos"
        },
        "cambio": {
          "texto": "se añaden 4 globos amarillos.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos globos hay en total?"
        },
        "audioFull": "AL PRINCIPIO... Hay 5 globos azules DESPUÉS... se añaden 4 globos amarillos. LA PREGUNTA ES... ¿Cuántos globos hay en total?"
      }
    },
    {
      "id": 2,
      "enunciado": "En la mesa hay 6 trozos de tarta y mamá trae 2 trozos más. ¿Cuántos trozos de tarta hay ahora?",
      "ayuda": {
        "inicio": {
          "texto": "En la mesa hay 6 trozos de tarta",
          "cantidad": 6,
          "emoji": "2753",
          "objeto": "trozos"
        },
        "cambio": {
          "texto": "mamá trae 2 trozos más.",
          "cantidad": 2,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos trozos de tarta hay ahora?"
        },
        "audioFull": "AL PRINCIPIO... En la mesa hay 6 trozos de tarta DESPUÉS... mamá trae 2 trozos más. LA PREGUNTA ES... ¿Cuántos trozos de tarta hay ahora?"
      }
    },
    {
      "id": 3,
      "enunciado": "Hace un momento llegaron 4 amigos y ahora llegan 4 amigos más. ¿Cuántos amigos han llegado en total?",
      "ayuda": {
        "inicio": {
          "texto": "Llegaron 4 amigos",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "amigos"
        },
        "cambio": {
          "texto": "llegan 4 amigos más.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos amigos han llegado en total?"
        },
        "audioFull": "AL PRINCIPIO... Llegaron 4 amigos DESPUÉS... llegan 4 amigos más. LA PREGUNTA ES... ¿Cuántos amigos han llegado en total?"
      }
    },
    {
      "id": 4,
      "enunciado": "Tengo 5 gorritos de fiesta y papá compra 2 gorritos más. ¿Cuántos gorritos tendré?",
      "ayuda": {
        "inicio": {
          "texto": "Tengo 5 gorritos de fiesta",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "gorritos"
        },
        "cambio": {
          "texto": "papá compra 2 gorritos más.",
          "cantidad": 2,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos gorritos tendré?"
        },
        "audioFull": "AL PRINCIPIO... Tengo 5 gorritos de fiesta DESPUÉS... papá compra 2 gorritos más. LA PREGUNTA ES... ¿Cuántos gorritos tendré?"
      }
    },
    {
      "id": 5,
      "enunciado": "En la mesa hay 10 vasos con zumo de naranja y nos traen 4 vasos de zumo más. ¿Cuántos vasos tendremos ahora?",
      "ayuda": {
        "inicio": {
          "texto": "En la mesa hay 10 vasos",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "vasos"
        },
        "cambio": {
          "texto": "nos traen 4 vasos de zumo.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos vasos tendremos ahora?"
        },
        "audioFull": "AL PRINCIPIO... En la mesa hay 10 vasos DESPUÉS... nos traen 4 vasos de zumo. LA PREGUNTA ES... ¿Cuántos vasos tendremos ahora?"
      }
    },
    {
      "id": 2,
      "enunciado": "Me han hecho 9 regalos y ya he abierto 5 regalos. ¿Cuántos regalos faltan por abrir?",
      "ayuda": {
        "inicio": {
          "texto": "Me han hecho 9 regalos",
          "cantidad": 9,
          "emoji": "2753",
          "objeto": "regalos"
        },
        "cambio": {
          "texto": "he abierto 5 regalos.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos regalos faltan por abrir?"
        },
        "audioFull": "AL PRINCIPIO... Me han hecho 9 regalos DESPUÉS... he abierto 5 regalos. LA PREGUNTA ES... ¿Cuántos regalos faltan por abrir?"
      }
    },
    {
      "id": 1,
      "enunciado": "Hay 14 servilletas y la abuela pone 4 servilletas más. ¿Cuántas servilletas tendremos ahora?",
      "ayuda": {
        "inicio": {
          "texto": "Hay 14 servilletas",
          "cantidad": 14,
          "emoji": "2753",
          "objeto": "servilletas"
        },
        "cambio": {
          "texto": "la abuela pone 4 servilletas más.",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas servilletas tendremos ahora?"
        },
        "audioFull": "AL PRINCIPIO... Hay 14 servilletas DESPUÉS... la abuela pone 4 servilletas más. LA PREGUNTA ES... ¿Cuántas servilletas tendremos ahora?"
      }
    },
    {
      "id": 3,
      "enunciado": "Tengo 10 tenedores de plástico y compro 7 tenedores más. ¿Cuántos tenedores tendré?",
      "ayuda": {
        "inicio": {
          "texto": "Tengo 10 tenedores de plástico",
          "cantidad": 10,
          "emoji": "2753",
          "objeto": "tenedores"
        },
        "cambio": {
          "texto": "compro 7 tenedores.",
          "cantidad": 7,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos tenedores tendré?"
        },
        "audioFull": "AL PRINCIPIO... Tengo 10 tenedores de plástico DESPUÉS... compro 7 tenedores. LA PREGUNTA ES... ¿Cuántos tenedores tendré?"
      }
    },
    {
      "id": 2,
      "enunciado": "El el plato teníamos 15 galletas, pero, 4 galletas  se han roto al sacarlas. ¿Cuántas galletas quedan?",
      "ayuda": {
        "inicio": {
          "texto": "El el plato teníamos 15 galletas",
          "cantidad": 15,
          "emoji": "2753",
          "objeto": "galletas"
        },
        "cambio": {
          "texto": "4 galletas  se han roto al sacarlas",
          "cantidad": 4,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas galletas quedan?"
        },
        "audioFull": "AL PRINCIPIO... El el plato teníamos 15 galletas DESPUÉS... 4 galletas se han roto al sacarlas LA PREGUNTA ES... ¿Cuántas galletas quedan?"
      }
    },
    {
      "id": 4,
      "enunciado": "Habíamos preparado 18 botellas de agua y nos hemos bebido 5 botellas. ¿Cuántas botellas de agua quedan?",
      "ayuda": {
        "inicio": {
          "texto": "Habíamos preparado 18 botellas de agua",
          "cantidad": 18,
          "emoji": "2753",
          "objeto": "botellas"
        },
        "cambio": {
          "texto": "nos hemos bebido 5 botellas.",
          "cantidad": 5,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántas botellas de agua quedan?"
        },
        "audioFull": "AL PRINCIPIO... Habíamos preparado 18 botellas de agua DESPUÉS... nos hemos bebido 5 botellas. LA PREGUNTA ES... ¿Cuántas botellas de agua quedan?"
      }
    },
    {
      "id": 1,
      "enunciado": "¡Qué bien huelen los cupcakes! Tenemos 21 cupcakes de vainilla y otros 14 cupcakes de fresa. ¿Cuántos cupcakes hay en total?",
      "ayuda": {
        "inicio": {
          "texto": "Tenemos 21 cupcakes de vainilla",
          "cantidad": 21,
          "emoji": "2753",
          "objeto": "cupcakes"
        },
        "cambio": {
          "texto": "además, tenemos otros 14 cupcakes de fresa.",
          "cantidad": 14,
          "emoji": "2753",
          "objeto": "",
          "operacion": "+"
        },
        "pregunta": {
          "texto": "¿Cuántos cupcakes hay en total?"
        },
        "audioFull": "AL PRINCIPIO... Tenemos 21 cupcakes de vainilla DESPUÉS... además, tenemos otros 14 cupcakes de fresa. LA PREGUNTA ES... ¿Cuántos cupcakes hay en total?"
      }
    }
  ]
};
console.log('✅ Datos de ayuda offline cargados (32 contextos)');
